export const existingUsers = {
    "Recreio": [
        {
        "id": "1492001720",
        "name": "Felipe Martins da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "felipedecar@yahoo.com.br",
        "genero": "M",
        "dataNasc": "27 Mai.",
        "telefone": "5512988716623",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/05/2025"
        },
        {
        "id": "156245889",
        "name": "Paulo Cesar Ogrodowski",
        "comPromocional": true,
        "numCompras": 1,
        "email": "paulo_paulinho.cesar@hotmail.com",
        "genero": "M",
        "dataNasc": "16 Fev.",
        "telefone": "46-30257424",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/05/2025"
        },
        {
        "id": "629328390",
        "name": "Meiricler Frisso",
        "comPromocional": true,
        "numCompras": 1,
        "email": "meiriclertx@gmail.com",
        "genero": "",
        "dataNasc": "01 Fev.",
        "telefone": "31988624793",
        "ultInteracao": "Assinatura",
        "dataInteracao": "07/05/2025"
        },
        {
        "id": "64833314",
        "name": "Cristiano Aurelio Camargos de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cristiano.aurelio@yahoo.com.br",
        "genero": "M",
        "dataNasc": "06 Set.",
        "telefone": "2232330533",
        "ultInteracao": "Assinatura",
        "dataInteracao": "23/04/2025"
        },
        {
        "id": "195144855",
        "name": "Gustavo Guimaraes de Oliveira Porto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "guuoliveira1@gmail.com",
        "genero": "M",
        "dataNasc": "12 Nov.",
        "telefone": " 31994132994",
        "ultInteracao": "Compra",
        "dataInteracao": "16/04/2025"
        },
        {
        "id": "556466023",
        "name": "Adailton Pereira da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pereiraadailton2011@gmail.com",
        "genero": "M",
        "dataNasc": "26 Ago.",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "25/03/2025"
        },
        {
        "id": "402483017",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "laviniasouzah_@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "24/03/2025"
        },
        {
        "id": "2335875936",
        "name": "Ricardo Lacerda",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ryccolacerda@gmail.com",
        "genero": "M",
        "dataNasc": "25 Mai.",
        "telefone": "5531989519790",
        "ultInteracao": "Compra",
        "dataInteracao": "17/03/2025"
        },
        {
        "id": "1165144693",
        "name": "Adilson Estevo Xavier",
        "comPromocional": true,
        "numCompras": 2,
        "email": "adilsonxavier1985@gmail.com",
        "genero": "M",
        "dataNasc": "26 Jan.",
        "telefone": "5533998064320",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/03/2025"
        },
        {
        "id": "2309864694",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nino.abn@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5521995625010",
        "ultInteracao": "Assinatura",
        "dataInteracao": "06/03/2025"
        },
        {
        "id": "2309835136",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nino.abn@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5521995625010",
        "ultInteracao": "Assinatura",
        "dataInteracao": "06/03/2025"
        },
        {
        "id": "153248415",
        "name": "Cristiano Franca Ribeiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "crfrancca@hotmail.com",
        "genero": "",
        "dataNasc": "05 Mai.",
        "telefone": " 31 92411472",
        "ultInteracao": "Compra",
        "dataInteracao": "25/02/2025"
        },
        {
        "id": "618265375",
        "name": "Aldo da Silva Barreto",
        "comPromocional": true,
        "numCompras": 3,
        "email": "abmix7@gmail.com",
        "genero": "M",
        "dataNasc": "20 Jun.",
        "telefone": "5575998528291",
        "ultInteracao": "Compra",
        "dataInteracao": "22/01/2025"
        },
        {
        "id": "38565187",
        "name": "Daniel Marciano Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "danielmadossantos@yahoo.com.br",
        "genero": "M",
        "dataNasc": "30 Mai.",
        "telefone": "972202628",
        "ultInteracao": "Assinatura",
        "dataInteracao": "16/01/2025"
        },
        {
        "id": "2208386831",
        "name": "Braulio Alves Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "brauzip@hotmail.com",
        "genero": "M",
        "dataNasc": "09 Jan.",
        "telefone": "5531992794829",
        "ultInteracao": "Assinatura",
        "dataInteracao": "15/01/2025"
        },
        {
        "id": "2208370046",
        "name": "Bruno Mauricio de Menezes Lima",
        "comPromocional": true,
        "numCompras": 2,
        "email": "Bmmenezeslima@gmail.com",
        "genero": "M",
        "dataNasc": "17 Ago.",
        "telefone": "5531992919075",
        "ultInteracao": "Compra",
        "dataInteracao": "11/01/2025"
        },
        {
        "id": "2205403841",
        "name": "Bruno Mauricio de Menezes Lima",
        "comPromocional": true,
        "numCompras": 1,
        "email": "Bmmenezeslima@gmail.com",
        "genero": "M",
        "dataNasc": "17 Ago.",
        "telefone": "5531992919075",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/01/2025"
        },
        {
        "id": "1487172432",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "luciowagnermello@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531991797881",
        "ultInteracao": "Compra",
        "dataInteracao": "19/12/2024"
        },
        {
        "id": "67422416",
        "name": "Geovane Santos de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "souzagsa@hotmail.com",
        "genero": "M",
        "dataNasc": "02 Set.",
        "telefone": " 31982313705",
        "ultInteracao": "Assinatura",
        "dataInteracao": "02/12/2024"
        },
        {
        "id": "52148761",
        "name": "Everaldo Jose da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eeveraldojose.silva@gmail.com",
        "genero": "M",
        "dataNasc": "30 Dez.",
        "telefone": "0081988893562",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/09/2024"
        },
        {
        "id": "10710729",
        "name": "Alexandre Henrique Garcia Rocha Gomes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ahgomes2009@hotmail.com",
        "genero": "M",
        "dataNasc": "27 Abr.",
        "telefone": "3131 30314960",
        "ultInteracao": "Assinatura",
        "dataInteracao": "14/09/2024"
        },
        {
        "id": "251123726",
        "name": "Bianca de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "biancasouza12e@gmail.com",
        "genero": "",
        "dataNasc": "23 Mai.",
        "telefone": "3198515354",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/08/2024"
        },
        {
        "id": "216425927",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jovemdemais4@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": " 031333221921",
        "ultInteracao": "Compra",
        "dataInteracao": "12/08/2024"
        },
        {
        "id": "31329318",
        "name": "Fabio de Paiva Melo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fabiomelo2@yahoo.com.br",
        "genero": "M",
        "dataNasc": "15 Jan.",
        "telefone": "21981453669",
        "ultInteracao": "Compra",
        "dataInteracao": "07/08/2024"
        },
        {
        "id": "468924826",
        "name": "Renato da Silva Araujo",
        "comPromocional": true,
        "numCompras": 3,
        "email": "renatoaraujo259@gmail.com",
        "genero": "M",
        "dataNasc": "25 Mar.",
        "telefone": "33988609849",
        "ultInteracao": "Compra",
        "dataInteracao": "22/07/2024"
        },
        {
        "id": "242369132",
        "name": "Wilson Soares Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wilsonsws007@gmail.com",
        "genero": "M",
        "dataNasc": "17 Jan.",
        "telefone": " 15997847143",
        "ultInteracao": "Compra",
        "dataInteracao": "19/05/2025"
        },
        {
        "id": "160135628",
        "name": "Diego Viana Azevedo",
        "comPromocional": false,
        "numCompras": 1,
        "email": "dva.pessoal@gmail.com",
        "genero": "M",
        "dataNasc": "28 Out.",
        "telefone": " 22-998844780",
        "ultInteracao": "Compra",
        "dataInteracao": "19/05/2025"
        },
        {
        "id": "299043941",
        "name": "Rafael Francisco Guimaraes",
        "comPromocional": false,
        "numCompras": 1,
        "email": "faelguimaraesgesso@gmail.com",
        "genero": "M",
        "dataNasc": "27 Set.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "19/05/2025"
        },
        {
        "id": "656436450",
        "name": "Italo Coura Martins",
        "comPromocional": true,
        "numCompras": 1,
        "email": "italocm123@outlook.com",
        "genero": "M",
        "dataNasc": "15 Jun.",
        "telefone": " 31987172521",
        "ultInteracao": "Compra",
        "dataInteracao": "18/05/2025"
        },
        {
        "id": "158446241",
        "name": "Jose Alejandro Moreno Alfonzo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "joc.alejandro.m@gmail.com",
        "genero": "M",
        "dataNasc": "12 Abr.",
        "telefone": " 71992541813",
        "ultInteracao": "Compra",
        "dataInteracao": "16/05/2025"
        },
        {
        "id": "424033971",
        "name": "Ali Hikmat Hasan",
        "comPromocional": false,
        "numCompras": 1,
        "email": "a77577@yahoo.com",
        "genero": "M",
        "dataNasc": "30 Jun.",
        "telefone": "11986372690",
        "ultInteracao": "Compra",
        "dataInteracao": "16/05/2025"
        },
        {
        "id": "1006700046",
        "name": "Igor de Oliveira Faturi Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "oligor9966@gmail.com",
        "genero": "M",
        "dataNasc": "12 Mar.",
        "telefone": "5521988637330",
        "ultInteracao": "Compra",
        "dataInteracao": "16/05/2025"
        },
        {
        "id": "630182246",
        "name": "Priscilla Lemos Franca",
        "comPromocional": true,
        "numCompras": 5,
        "email": "restaurantedeguste1@hotmail.com",
        "genero": "",
        "dataNasc": "18 Ago.",
        "telefone": "5598999951220",
        "ultInteracao": "Compra",
        "dataInteracao": "16/05/2025"
        },
        {
        "id": "157936220",
        "name": "Janaina Carneiro de Souza Bueno",
        "comPromocional": true,
        "numCompras": 1,
        "email": "janatec87@gmail.com",
        "genero": "",
        "dataNasc": "23 Mar.",
        "telefone": " (41)34221488",
        "ultInteracao": "Compra",
        "dataInteracao": "15/05/2025"
        },
        {
        "id": "463216368",
        "name": "Jose Nonato Martins",
        "comPromocional": true,
        "numCompras": 1,
        "email": "josenonatomartins62@gmail.com",
        "genero": "M",
        "dataNasc": "23 Abr.",
        "telefone": "5531997490083",
        "ultInteracao": "Compra",
        "dataInteracao": "12/05/2025"
        },
        {
        "id": "52834807",
        "name": "Jorge Luis Teixeira Silva",
        "comPromocional": true,
        "numCompras": 2,
        "email": "borracha12@hotmail.com",
        "genero": "M",
        "dataNasc": "22 Fev.",
        "telefone": "31997493730",
        "ultInteracao": "Compra",
        "dataInteracao": "15/05/2025"
        },
        {
        "id": "56736426",
        "name": "Gustavo Lucas de Assuncao",
        "comPromocional": false,
        "numCompras": 2,
        "email": "cabuloso_gutavinho@hotmail.com",
        "genero": "M",
        "dataNasc": "05 Fev.",
        "telefone": "31985603325",
        "ultInteracao": "Compra",
        "dataInteracao": "15/05/2025"
        },
        {
        "id": "232830955",
        "name": "Valdecir Antonio de Miranda",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mirandinha52@hotmail.com",
        "genero": "M",
        "dataNasc": "28 Jul.",
        "telefone": " 31998709795",
        "ultInteracao": "Compra",
        "dataInteracao": "15/05/2025"
        },
        {
        "id": "1354482728",
        "name": "Rodrigo Afonso Cordeiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rodrigoafonso21@icloud.com",
        "genero": "M",
        "dataNasc": "14 Jun.",
        "telefone": "5582998311816",
        "ultInteracao": "Compra",
        "dataInteracao": "15/05/2025"
        },
        {
        "id": "1062910236",
        "name": "Cicero Ferreira Neto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ferreiracicero095@gmail.com",
        "genero": "M",
        "dataNasc": "20 Mai.",
        "telefone": "5538999297335",
        "ultInteracao": "Compra",
        "dataInteracao": "14/05/2025"
        },
        {
        "id": "201355678",
        "name": "Fabio Parcino Duarte",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fabioduarte1979@hotmail.com",
        "genero": "M",
        "dataNasc": "26 Out.",
        "telefone": "31992014160",
        "ultInteracao": "Compra",
        "dataInteracao": "14/05/2025"
        },
        {
        "id": "1031701291",
        "name": "Carolina Dos Santos Ribeiro",
        "comPromocional": false,
        "numCompras": 1,
        "email": "cfr.962@gmail.com",
        "genero": "",
        "dataNasc": "11 Mar.",
        "telefone": "5522981835617",
        "ultInteracao": "Compra",
        "dataInteracao": "14/05/2025"
        },
        {
        "id": "275309418",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "julianosiewertt@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "14/05/2025"
        },
        {
        "id": "49868778",
        "name": "Dalmo Capella Ferreira Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dalmo.junior13@hotmail.com",
        "genero": "M",
        "dataNasc": "12 Jul.",
        "telefone": "21975106479",
        "ultInteracao": "Compra",
        "dataInteracao": "14/05/2025"
        },
        {
        "id": "2441461420",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "naiarafigueiredo22@icloud.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "553198011290",
        "ultInteracao": "Compra",
        "dataInteracao": "14/05/2025"
        },
        {
        "id": "66584582",
        "name": "Carlo Jose Kowalski Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carlo_juca@hotmail.com",
        "genero": "M",
        "dataNasc": "26 Ago.",
        "telefone": "499827 3795",
        "ultInteracao": "Compra",
        "dataInteracao": "14/05/2025"
        },
        {
        "id": "70733703",
        "name": "Natalia Faria Diniz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "naty_diniz04@yahoo.com.br",
        "genero": "",
        "dataNasc": "09 Out.",
        "telefone": " 87953305",
        "ultInteracao": "Compra",
        "dataInteracao": "13/05/2025"
        },
        {
        "id": "163839956",
        "name": "Douglas Morais Azara",
        "comPromocional": true,
        "numCompras": 1,
        "email": "douglasazara@yahoo.com.br",
        "genero": "M",
        "dataNasc": "22 Mai.",
        "telefone": "35992601940",
        "ultInteracao": "Compra",
        "dataInteracao": "14/05/2025"
        },
        {
        "id": "157255520",
        "name": "Ivan Carlos Marques da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tockforte@gmail.com",
        "genero": "M",
        "dataNasc": "21 Set.",
        "telefone": "073-999296756",
        "ultInteracao": "Compra",
        "dataInteracao": "13/05/2025"
        },
        {
        "id": "250496129",
        "name": "Ana Maria Carvalho de Vasconcelos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "kratos.souls@gmail.com",
        "genero": "",
        "dataNasc": "26 Jul.",
        "telefone": "5531971022672",
        "ultInteracao": "Compra",
        "dataInteracao": "13/05/2025"
        },
        {
        "id": "392767194",
        "name": "Hallys Brondson Freire Alves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "hallysfreire@gmail.com",
        "genero": "",
        "dataNasc": "11 Nov.",
        "telefone": " 33988937553",
        "ultInteracao": "Compra",
        "dataInteracao": "13/05/2025"
        },
        {
        "id": "148326412",
        "name": "Alexandre Vital Do Carmo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mengovitall@hotmail.com",
        "genero": "M",
        "dataNasc": "22 Nov.",
        "telefone": "21964938722",
        "ultInteracao": "Compra",
        "dataInteracao": "13/05/2025"
        },
        {
        "id": "381272174",
        "name": "Jessica de Castro Azevedo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jessicaazevedo.jc@gmail.com",
        "genero": "",
        "dataNasc": "01 Jul.",
        "telefone": "31998160207",
        "ultInteracao": "Compra",
        "dataInteracao": "12/05/2025"
        },
        {
        "id": "606587854",
        "name": "Thiago Rocha Pereira de Moraes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thiago.pereira@engenharia.ufjf.br",
        "genero": "M",
        "dataNasc": "22 Out.",
        "telefone": "5532999656185",
        "ultInteracao": "Compra",
        "dataInteracao": "12/05/2025"
        },
        {
        "id": "1392923388",
        "name": "Filipe Correa Castro",
        "comPromocional": true,
        "numCompras": 2,
        "email": "filipeccastro23@gmail.com",
        "genero": "M",
        "dataNasc": "22 Out.",
        "telefone": "5524981184181",
        "ultInteracao": "Compra",
        "dataInteracao": "12/05/2025"
        },
        {
        "id": "244359334",
        "name": "Joao Henrique Franco Garcia",
        "comPromocional": true,
        "numCompras": 1,
        "email": "joaohenrique@garciacp.com.br",
        "genero": "M",
        "dataNasc": "07 Jan.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "12/05/2025"
        },
        {
        "id": "185090081",
        "name": "Frederico Pereira Gomes",
        "comPromocional": false,
        "numCompras": 3,
        "email": "frederico.morusimoveis@gmail.com",
        "genero": "M",
        "dataNasc": "09 Dez.",
        "telefone": "31997553484",
        "ultInteracao": "Compra",
        "dataInteracao": "12/05/2025"
        },
        {
        "id": "236412838",
        "name": "Jose Fernando Pereira da Silva",
        "comPromocional": true,
        "numCompras": 2,
        "email": "josefernandopereiradasilvaf@gmail.com",
        "genero": "M",
        "dataNasc": "28 Jun.",
        "telefone": " 2130159461",
        "ultInteracao": "Compra",
        "dataInteracao": "12/05/2025"
        },
        {
        "id": "2433258103",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rubensm828@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5532984273137",
        "ultInteracao": "Compra",
        "dataInteracao": "12/05/2025"
        },
        {
        "id": "2437291918",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "denercarvalho37@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531993389047",
        "ultInteracao": "Compra",
        "dataInteracao": "12/05/2025"
        },
        {
        "id": "571627726",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "brunasoaresa1@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531987089534",
        "ultInteracao": "Compra",
        "dataInteracao": "12/05/2025"
        },
        {
        "id": "2432814783",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "julinhoresende@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531984278778",
        "ultInteracao": "Compra",
        "dataInteracao": "12/05/2025"
        },
        {
        "id": "227879377",
        "name": "Daniela de Cassia Ribeiro Fagundes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "danyribeirofagundes@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "35991657680",
        "ultInteracao": "Compra",
        "dataInteracao": "11/05/2025"
        },
        {
        "id": "321693916",
        "name": "Nilson Ferreira",
        "comPromocional": true,
        "numCompras": 4,
        "email": "brunoferre281@gmail.com",
        "genero": "M",
        "dataNasc": "23 Out.",
        "telefone": "5566997221214",
        "ultInteracao": "Compra",
        "dataInteracao": "09/05/2025"
        },
        {
        "id": "138146458",
        "name": "Rodrigo Otavio Gomes Ferreira",
        "comPromocional": true,
        "numCompras": 3,
        "email": "streetcar_acessorios@yahoo.com.br",
        "genero": "M",
        "dataNasc": "24 Mar.",
        "telefone": " (31)98599300",
        "ultInteracao": "Compra",
        "dataInteracao": "09/05/2025"
        },
        {
        "id": "178059074",
        "name": "Viviane Aparecida Ponciano Leite",
        "comPromocional": true,
        "numCompras": 3,
        "email": "vivianeponciano@gmail.com",
        "genero": "",
        "dataNasc": "22 Out.",
        "telefone": " (37)99690200",
        "ultInteracao": "Compra",
        "dataInteracao": "09/05/2025"
        },
        {
        "id": "67815045",
        "name": "Jerffeson Ferreira de Castro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jerffesonferreiradecastro@gmail.com",
        "genero": "M",
        "dataNasc": "17 Nov.",
        "telefone": "32998053595",
        "ultInteracao": "Compra",
        "dataInteracao": "09/05/2025"
        },
        {
        "id": "160475022",
        "name": "Lucimar Santana Correia",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tuquinh100@hotmail.com",
        "genero": "",
        "dataNasc": "10 Fev.",
        "telefone": "11959597199",
        "ultInteracao": "Compra",
        "dataInteracao": "09/05/2025"
        },
        {
        "id": "565525938",
        "name": "Tiago Duarte Teixeira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tiagoduartefly@gmail.com",
        "genero": "M",
        "dataNasc": "03 Jun.",
        "telefone": "031997274883",
        "ultInteracao": "Compra",
        "dataInteracao": "09/05/2025"
        },
        {
        "id": "380797981",
        "name": "Adenir Rodrigues de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "adenoliv@gmail.com",
        "genero": "",
        "dataNasc": "19 Dez.",
        "telefone": "5531998152083",
        "ultInteracao": "Compra",
        "dataInteracao": "08/05/2025"
        },
        {
        "id": "208020707",
        "name": "Eliane Meire Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lilimeyre@yahoo.com.br",
        "genero": "",
        "dataNasc": "23 Fev.",
        "telefone": " 38999200402",
        "ultInteracao": "Compra",
        "dataInteracao": "08/05/2025"
        },
        {
        "id": "147918867",
        "name": "Hugo Rodrigues de Farias",
        "comPromocional": true,
        "numCompras": 1,
        "email": "hugo.rfarias@gmail.com",
        "genero": "M",
        "dataNasc": "21 Jul.",
        "telefone": "31994471295",
        "ultInteracao": "Compra",
        "dataInteracao": "08/05/2025"
        },
        {
        "id": "216160522",
        "name": "Florencio Felix da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "florenciofelix2015@gmail.com",
        "genero": "M",
        "dataNasc": "05 Set.",
        "telefone": "021994162362",
        "ultInteracao": "Compra",
        "dataInteracao": "08/05/2025"
        },
        {
        "id": "268026856",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "artemecanica@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "31985113129",
        "ultInteracao": "Compra",
        "dataInteracao": "08/05/2025"
        },
        {
        "id": "2293330659",
        "name": "Gabriela Carvalho Archanjo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gabriela.bruninho12@hotmail.com",
        "genero": "",
        "dataNasc": "14 Dez.",
        "telefone": "5531971160579",
        "ultInteracao": "Compra",
        "dataInteracao": "08/05/2025"
        },
        {
        "id": "1628249948",
        "name": "Raul Felipe Macedo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "feliperaul270@gmail.com",
        "genero": "M",
        "dataNasc": "07 Fev.",
        "telefone": "5519999742515",
        "ultInteracao": "Compra",
        "dataInteracao": "08/05/2025"
        },
        {
        "id": "128031484",
        "name": "Leonardo Monge Braga",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leo_monge_bmx@hotmail.com",
        "genero": "M",
        "dataNasc": "10 Set.",
        "telefone": " 88602587",
        "ultInteracao": "Compra",
        "dataInteracao": "08/05/2025"
        },
        {
        "id": "12655240",
        "name": "Cleiton Marcio de Azevedo",
        "comPromocional": true,
        "numCompras": 12,
        "email": "cleitimm19@gmail.com",
        "genero": "M",
        "dataNasc": "19 Set.",
        "telefone": " 31992138227",
        "ultInteracao": "Compra",
        "dataInteracao": "08/05/2025"
        },
        {
        "id": "192125488",
        "name": "Jose Ricardo Mueller",
        "comPromocional": true,
        "numCompras": 1,
        "email": "josericardomueller@yahoo.com.br",
        "genero": "M",
        "dataNasc": "20 Jan.",
        "telefone": " 4196071443",
        "ultInteracao": "Compra",
        "dataInteracao": "08/05/2025"
        },
        {
        "id": "99208437",
        "name": "Neimar Moura Cunha",
        "comPromocional": true,
        "numCompras": 1,
        "email": "neimarm.cunha@hotmail.com",
        "genero": "M",
        "dataNasc": "16 Jul.",
        "telefone": " 3333223990",
        "ultInteracao": "Compra",
        "dataInteracao": "07/05/2025"
        },
        {
        "id": "1397296930",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marceloautoplast@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531994380390",
        "ultInteracao": "Compra",
        "dataInteracao": "07/05/2025"
        },
        {
        "id": "178055124",
        "name": "Denner Roberto Santana",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dennerroberto2012@hotmail.com",
        "genero": "M",
        "dataNasc": "25 Mar.",
        "telefone": " 3384505066",
        "ultInteracao": "Compra",
        "dataInteracao": "07/05/2025"
        },
        {
        "id": "1270492459",
        "name": "Leonardo Calcagno Ribas",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leocrbs301@gmail.com",
        "genero": "M",
        "dataNasc": "19 Mai.",
        "telefone": "5531984127858",
        "ultInteracao": "Compra",
        "dataInteracao": "06/05/2025"
        },
        {
        "id": "1328242206",
        "name": " ",
        "comPromocional": true,
        "numCompras": 2,
        "email": "walterdamasceno752@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5538997303620",
        "ultInteracao": "Compra",
        "dataInteracao": "06/05/2025"
        },
        {
        "id": "164506305",
        "name": "Ramon de Castro Fonseca",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ramoncfonseca@gmail.com",
        "genero": "M",
        "dataNasc": "16 Dez.",
        "telefone": " 3133867683",
        "ultInteracao": "Compra",
        "dataInteracao": "06/05/2025"
        },
        {
        "id": "79837923",
        "name": "Pedro de Almeida Meniconi",
        "comPromocional": true,
        "numCompras": 2,
        "email": "pedro.meniconi@gmail.com",
        "genero": "M",
        "dataNasc": "19 Out.",
        "telefone": "3125118153",
        "ultInteracao": "Compra",
        "dataInteracao": "06/05/2025"
        },
        {
        "id": "261501490",
        "name": "Rodrigo Garbulha Castelo",
        "comPromocional": true,
        "numCompras": 4,
        "email": "rodycastelo@gmail.com",
        "genero": "M",
        "dataNasc": "11 Nov.",
        "telefone": "67998433135",
        "ultInteracao": "Compra",
        "dataInteracao": "06/05/2025"
        },
        {
        "id": "107855893",
        "name": "Claudio Cesar de Aguiar",
        "comPromocional": true,
        "numCompras": 1,
        "email": "claudiourique@gmail.com",
        "genero": "M",
        "dataNasc": "15 Jul.",
        "telefone": " (22)9826-4500",
        "ultInteracao": "Compra",
        "dataInteracao": "06/05/2025"
        },
        {
        "id": "240958052",
        "name": "Lucas de Sa Moreira Braganca",
        "comPromocional": false,
        "numCompras": 1,
        "email": "lucassbraganca@hotmail.com",
        "genero": "M",
        "dataNasc": "14 Mar.",
        "telefone": "31975041950",
        "ultInteracao": "Compra",
        "dataInteracao": "06/05/2025"
        },
        {
        "id": "180961324",
        "name": "Ronaldo Fabiano Baeta Guimaraes Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ronaldo.gui.jr@gmail.com",
        "genero": "M",
        "dataNasc": "10 Dez.",
        "telefone": " 2132237922",
        "ultInteracao": "Compra",
        "dataInteracao": "05/05/2025"
        },
        {
        "id": "70249122",
        "name": "Michel Pablo Vieira Rodrigues",
        "comPromocional": true,
        "numCompras": 1,
        "email": "michelpablo.vieira@gmail.com",
        "genero": "M",
        "dataNasc": "09 Mai.",
        "telefone": "02198401-1016",
        "ultInteracao": "Compra",
        "dataInteracao": "05/05/2025"
        },
        {
        "id": "205302190",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "vendas@marechalvidros.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "11940717264",
        "ultInteracao": "Compra",
        "dataInteracao": "05/05/2025"
        },
        {
        "id": "1073196418",
        "name": "Adriano Cesar Augusto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "adrianocesaraugustoc@gmail.com",
        "genero": "M",
        "dataNasc": "27 Jun.",
        "telefone": "5535999155626",
        "ultInteracao": "Compra",
        "dataInteracao": "05/05/2025"
        },
        {
        "id": "155573250",
        "name": "Tiago Antonio Nato",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tiagonato@live.com",
        "genero": "M",
        "dataNasc": "01 Mai.",
        "telefone": " 3187431920",
        "ultInteracao": "Compra",
        "dataInteracao": "04/05/2025"
        },
        {
        "id": "757200036",
        "name": "Gilmar Braga Dantas",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gilmarbragadantas@gmail.com",
        "genero": "M",
        "dataNasc": "24 Jan.",
        "telefone": "5531995860438",
        "ultInteracao": "Compra",
        "dataInteracao": "04/05/2025"
        },
        {
        "id": "2419947719",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "antoniovm01@outlook.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531986182823",
        "ultInteracao": "Compra",
        "dataInteracao": "04/05/2025"
        },
        {
        "id": "1293415485",
        "name": "Leonardo Rocha Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leoegi1406@gmail.com",
        "genero": "M",
        "dataNasc": "24 Mai.",
        "telefone": "5531988225883",
        "ultInteracao": "Compra",
        "dataInteracao": "04/05/2025"
        },
        {
        "id": "245405123",
        "name": "Giovani Angelo Vieira Mendes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "giovanijosiane@gmail.com",
        "genero": "",
        "dataNasc": "25 Jun.",
        "telefone": " (31) 993145689",
        "ultInteracao": "Compra",
        "dataInteracao": "04/05/2025"
        },
        {
        "id": "1023482094",
        "name": "Arthur Messias da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "messiasarthur400@gmail.com",
        "genero": "M",
        "dataNasc": "26 Jul.",
        "telefone": "5531972239486",
        "ultInteracao": "Compra",
        "dataInteracao": "04/05/2025"
        },
        {
        "id": "238739480",
        "name": "Patricia Chaves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "patiperio@uol.com.br",
        "genero": "",
        "dataNasc": "22 Nov.",
        "telefone": "19988091929",
        "ultInteracao": "Compra",
        "dataInteracao": "03/05/2025"
        },
        {
        "id": "246147384",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rita_guilh@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": " 44 9 99349883",
        "ultInteracao": "Compra",
        "dataInteracao": "02/05/2025"
        },
        {
        "id": "49414834",
        "name": "Anderson Alberto da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "andersonalberto2@yahoo.com.br",
        "genero": "M",
        "dataNasc": "03 Dez.",
        "telefone": "2124033634",
        "ultInteracao": "Compra",
        "dataInteracao": "02/05/2025"
        },
        {
        "id": "124965078",
        "name": "Roni Januario de Medeiros",
        "comPromocional": false,
        "numCompras": 1,
        "email": "roni-januario@hotmail.com",
        "genero": "M",
        "dataNasc": "26 Fev.",
        "telefone": "3137726848",
        "ultInteracao": "Compra",
        "dataInteracao": "02/05/2025"
        },
        {
        "id": "90290895",
        "name": "Ivair Pereira de Lima",
        "comPromocional": true,
        "numCompras": 1,
        "email": "molequinho.lima@bol.com.br",
        "genero": "M",
        "dataNasc": "26 Nov.",
        "telefone": "16991559114",
        "ultInteracao": "Compra",
        "dataInteracao": "01/05/2025"
        },
        {
        "id": "115085427",
        "name": "Hueberty Hudson Guedes",
        "comPromocional": false,
        "numCompras": 1,
        "email": "huguedes@yahoo.com.br",
        "genero": "M",
        "dataNasc": "27 Out.",
        "telefone": "31999546808",
        "ultInteracao": "Compra",
        "dataInteracao": "01/05/2025"
        },
        {
        "id": "2413131443",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dmendesrbh@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531998024022",
        "ultInteracao": "Compra",
        "dataInteracao": "30/04/2025"
        },
        {
        "id": "150429320",
        "name": "Samuel de Souza Vicente Pinheiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mecanicavarginha@bol.com.br",
        "genero": "M",
        "dataNasc": "03 Jan.",
        "telefone": " 35992260922",
        "ultInteracao": "Compra",
        "dataInteracao": "30/04/2025"
        },
        {
        "id": "1518960025",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leonardoprado11@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531996900522",
        "ultInteracao": "Compra",
        "dataInteracao": "30/04/2025"
        },
        {
        "id": "112028432",
        "name": "Cristiane Lara Leandro",
        "comPromocional": false,
        "numCompras": 1,
        "email": "crislleandro@hotmail.com",
        "genero": "",
        "dataNasc": "05 Fev.",
        "telefone": " 3194967088",
        "ultInteracao": "Compra",
        "dataInteracao": "30/04/2025"
        },
        {
        "id": "130971347",
        "name": "Edson Fagner Goncalves Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fagnere20@hotmail.com",
        "genero": "M",
        "dataNasc": "06 Ago.",
        "telefone": " (33)88088423",
        "ultInteracao": "Compra",
        "dataInteracao": "29/04/2025"
        },
        {
        "id": "489616822",
        "name": "Marcus Vinicius Deleo",
        "comPromocional": false,
        "numCompras": 1,
        "email": "marcus.deleo@gmail.com",
        "genero": "M",
        "dataNasc": "05 Out.",
        "telefone": "31999719978",
        "ultInteracao": "Compra",
        "dataInteracao": "29/04/2025"
        },
        {
        "id": "389889069",
        "name": "Jose Flavio Dornelas",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jfdornelas@gmail.com",
        "genero": "M",
        "dataNasc": "19 Mar.",
        "telefone": "5531999414950",
        "ultInteracao": "Compra",
        "dataInteracao": "29/04/2025"
        },
        {
        "id": "575701388",
        "name": "Arthur Bezerra Goncalves",
        "comPromocional": false,
        "numCompras": 1,
        "email": "gon.arthur16@gmail.com",
        "genero": "M",
        "dataNasc": "16 Nov.",
        "telefone": "5521976749640",
        "ultInteracao": "Compra",
        "dataInteracao": "29/04/2025"
        },
        {
        "id": "202435457",
        "name": "Gabriel Victor de Souza",
        "comPromocional": true,
        "numCompras": 2,
        "email": "gabrielvict@gmail.com",
        "genero": "M",
        "dataNasc": "03 Set.",
        "telefone": " 31996187404",
        "ultInteracao": "Compra",
        "dataInteracao": "29/04/2025"
        },
        {
        "id": "1389710276",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "falecom@v3autocenter.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "5514991092027",
        "ultInteracao": "Compra",
        "dataInteracao": "29/04/2025"
        },
        {
        "id": "556044610",
        "name": "Renato Lopes de Andrade",
        "comPromocional": true,
        "numCompras": 1,
        "email": "renatolopesdeandrade6.5@gmail.com",
        "genero": "M",
        "dataNasc": "03 Jul.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "28/04/2025"
        },
        {
        "id": "1990970703",
        "name": "Gabriel Vargas Faria",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gabrielvargas201096@gmail.com",
        "genero": "M",
        "dataNasc": "20 Out.",
        "telefone": "5531975762117",
        "ultInteracao": "Compra",
        "dataInteracao": "28/04/2025"
        },
        {
        "id": "397288753",
        "name": "Alex Goncalves de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alex.goncalves.oliveira@hotmail.com",
        "genero": "M",
        "dataNasc": "21 Abr.",
        "telefone": "5531985675853",
        "ultInteracao": "Compra",
        "dataInteracao": "28/04/2025"
        },
        {
        "id": "585872449",
        "name": "Milena de Oliveira Rosa Barbosa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "viniciuscaiobr@gmail.com",
        "genero": "",
        "dataNasc": "06 Abr.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "28/04/2025"
        },
        {
        "id": "2413712450",
        "name": "Marcos Issao Suenaga",
        "comPromocional": true,
        "numCompras": 1,
        "email": "iss_suen@yahoo.com",
        "genero": "M",
        "dataNasc": "28 Abr.",
        "telefone": "5511914042047",
        "ultInteracao": "Compra",
        "dataInteracao": "28/04/2025"
        },
        {
        "id": "2408868799",
        "name": "Ezequiel Moraes Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "zique.moraes@gmail.com",
        "genero": "M",
        "dataNasc": "13 Mar.",
        "telefone": "5522999468213",
        "ultInteracao": "Compra",
        "dataInteracao": "27/04/2025"
        },
        {
        "id": "1090117202",
        "name": "Luciano Ribeiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lucianoribeiro770707@gmail.com",
        "genero": "M",
        "dataNasc": "24 Abr.",
        "telefone": "5531985709565",
        "ultInteracao": "Compra",
        "dataInteracao": "27/04/2025"
        },
        {
        "id": "66328668",
        "name": "Hugo Fabiano Denucci Miranda",
        "comPromocional": true,
        "numCompras": 3,
        "email": "denuccih@gmail.com",
        "genero": "M",
        "dataNasc": "25 Jun.",
        "telefone": "3125281862",
        "ultInteracao": "Compra",
        "dataInteracao": "26/04/2025"
        },
        {
        "id": "502186318",
        "name": "Railton Dos Santos Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rdextintores@yahoo.com.br",
        "genero": "M",
        "dataNasc": "07 Mai.",
        "telefone": "5571983105882",
        "ultInteracao": "Compra",
        "dataInteracao": "26/04/2025"
        },
        {
        "id": "2407154513",
        "name": "Robson Lopes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "roblopes0808@gmail.com",
        "genero": "M",
        "dataNasc": "08 Ago.",
        "telefone": "5521970207172",
        "ultInteracao": "Compra",
        "dataInteracao": "26/04/2025"
        },
        {
        "id": "156892900",
        "name": "Renata Maleiner",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rmaleiner@gmail.com",
        "genero": "",
        "dataNasc": "20 Jun.",
        "telefone": " 11975809168",
        "ultInteracao": "Compra",
        "dataInteracao": "26/04/2025"
        },
        {
        "id": "267307253",
        "name": "Gabriel Leite Fonseca",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gabrielsmkfonseca@gmail.com",
        "genero": "M",
        "dataNasc": "21 Nov.",
        "telefone": "31 34519517",
        "ultInteracao": "Compra",
        "dataInteracao": "25/04/2025"
        },
        {
        "id": "2405527301",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "renatomangussi@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531995650914",
        "ultInteracao": "Compra",
        "dataInteracao": "25/04/2025"
        },
        {
        "id": "2049453529",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "henriqueerepresentacoes@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5585985586495",
        "ultInteracao": "Compra",
        "dataInteracao": "22/04/2025"
        },
        {
        "id": "142865287",
        "name": "Bryan Michael Muller",
        "comPromocional": true,
        "numCompras": 1,
        "email": "bryanmuller.eng@gmail.com",
        "genero": "M",
        "dataNasc": "02 Jun.",
        "telefone": "31999733867",
        "ultInteracao": "Compra",
        "dataInteracao": "25/04/2025"
        },
        {
        "id": "2066580434",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "melzanileandro4@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5519996780217",
        "ultInteracao": "Compra",
        "dataInteracao": "24/04/2025"
        },
        {
        "id": "436753068",
        "name": "Luis Claudio Mageste",
        "comPromocional": true,
        "numCompras": 1,
        "email": "magestepanzer@outlook.com",
        "genero": "M",
        "dataNasc": "13 Jul.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "24/04/2025"
        },
        {
        "id": "68356922",
        "name": "Daniel Dambros",
        "comPromocional": false,
        "numCompras": 1,
        "email": "danidam@ig.com.br",
        "genero": "M",
        "dataNasc": "25 Out.",
        "telefone": " 35551778",
        "ultInteracao": "Compra",
        "dataInteracao": "22/04/2025"
        },
        {
        "id": "1275471995",
        "name": "James Souza Pereira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jhames.gg1@gmail.com",
        "genero": "M",
        "dataNasc": "17 Jan.",
        "telefone": "5511945033051",
        "ultInteracao": "Compra",
        "dataInteracao": "23/04/2025"
        },
        {
        "id": "1731259611",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sergiofmorais@icloud.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531998172898",
        "ultInteracao": "Compra",
        "dataInteracao": "23/04/2025"
        },
        {
        "id": "84524787",
        "name": "Anderson Schneider",
        "comPromocional": true,
        "numCompras": 1,
        "email": "schneider_146@hotmail.com",
        "genero": "M",
        "dataNasc": "29 Set.",
        "telefone": "11953484647",
        "ultInteracao": "Compra",
        "dataInteracao": "23/04/2025"
        },
        {
        "id": "155218616",
        "name": "Euclides Martins Tristao Neto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tristaokid@hotmail.com",
        "genero": "M",
        "dataNasc": "11 Fev.",
        "telefone": " 99673535",
        "ultInteracao": "Compra",
        "dataInteracao": "22/04/2025"
        },
        {
        "id": "69704667",
        "name": "Claudio Bonsucesso Atanazio",
        "comPromocional": true,
        "numCompras": 1,
        "email": "yzfmp3@yahoo.com.br",
        "genero": "M",
        "dataNasc": "02 Jun.",
        "telefone": "3136514025",
        "ultInteracao": "Compra",
        "dataInteracao": "22/04/2025"
        },
        {
        "id": "53122106",
        "name": "Caroline de Paula da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "caroline_dpds@hotmail.com",
        "genero": "",
        "dataNasc": "05 Jul.",
        "telefone": "2178011184",
        "ultInteracao": "Compra",
        "dataInteracao": "22/04/2025"
        },
        {
        "id": "487433043",
        "name": "Rodrigo Soares Dias",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rodrigo123soares@hotmail.com",
        "genero": "M",
        "dataNasc": "26 Dez.",
        "telefone": "5533988566979",
        "ultInteracao": "Compra",
        "dataInteracao": "22/04/2025"
        },
        {
        "id": "380067858",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jonathanm1lopes@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531998077081",
        "ultInteracao": "Compra",
        "dataInteracao": "22/04/2025"
        },
        {
        "id": "2403967866",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "debora89guimaraes@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5528999631372",
        "ultInteracao": "Compra",
        "dataInteracao": "22/04/2025"
        },
        {
        "id": "74795845",
        "name": "Hudson Luiz Medeiros",
        "comPromocional": true,
        "numCompras": 1,
        "email": "hhudsonharb@yahoo.com.br",
        "genero": "",
        "dataNasc": "26 Nov.",
        "telefone": " 88042251",
        "ultInteracao": "Compra",
        "dataInteracao": "21/04/2025"
        },
        {
        "id": "89630082",
        "name": "Mauro Aparecido Almeida",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mauroabba@hotmail.com",
        "genero": "M",
        "dataNasc": "25 Jan.",
        "telefone": "4535267466",
        "ultInteracao": "Compra",
        "dataInteracao": "20/04/2025"
        },
        {
        "id": "798402412",
        "name": "Adriano Cesar Lopardi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "adrianocesarlopardilopardi@gmail.com",
        "genero": "M",
        "dataNasc": "05 Jan.",
        "telefone": "5531991117879",
        "ultInteracao": "Compra",
        "dataInteracao": "19/04/2025"
        },
        {
        "id": "217990336",
        "name": "Rafael Izaias da Silva Antunes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rafaelizaias09@gmail.com",
        "genero": "M",
        "dataNasc": "17 Jul.",
        "telefone": "31988427943",
        "ultInteracao": "Compra",
        "dataInteracao": "19/04/2025"
        },
        {
        "id": "510621300",
        "name": "Flavio Dos Santos Pereira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "flaviosantospereirasantosperei@gmail.com",
        "genero": "M",
        "dataNasc": "30 Jan.",
        "telefone": "32999975552",
        "ultInteracao": "Compra",
        "dataInteracao": "18/04/2025"
        },
        {
        "id": "1181284787",
        "name": "Anderson Nogueira Resende",
        "comPromocional": true,
        "numCompras": 1,
        "email": "anderson.nresende83@gmail.com",
        "genero": "M",
        "dataNasc": "19 Jul.",
        "telefone": "5543984830592",
        "ultInteracao": "Compra",
        "dataInteracao": "18/04/2025"
        },
        {
        "id": "83148088",
        "name": "Michel de Camargo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "michelpaidojuelorena@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Ago.",
        "telefone": "15981600509",
        "ultInteracao": "Compra",
        "dataInteracao": "18/04/2025"
        },
        {
        "id": "90281273",
        "name": "Flavio Christovam Dos Santos",
        "comPromocional": true,
        "numCompras": 2,
        "email": "flavio.christovam@gmail.com",
        "genero": "M",
        "dataNasc": "03 Jan.",
        "telefone": "3133782709",
        "ultInteracao": "Compra",
        "dataInteracao": "18/04/2025"
        },
        {
        "id": "294946414",
        "name": "Joao Victor Guimaraes Louzada",
        "comPromocional": true,
        "numCompras": 1,
        "email": "louzadajoaovictor@gmail.com",
        "genero": "M",
        "dataNasc": "28 Nov.",
        "telefone": "5531995086311",
        "ultInteracao": "Compra",
        "dataInteracao": "18/04/2025"
        },
        {
        "id": "86210676",
        "name": "Deuvande Roberto da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "deuvand@yahoo.com.br",
        "genero": "",
        "dataNasc": "26 Abr.",
        "telefone": "38984312707",
        "ultInteracao": "Compra",
        "dataInteracao": "18/04/2025"
        },
        {
        "id": "157309323",
        "name": "Jusciene Teixeira de Souza Bacelar",
        "comPromocional": true,
        "numCompras": 1,
        "email": "auto.visual@yahoo.com.br",
        "genero": "",
        "dataNasc": "17 Mai.",
        "telefone": " 3185323718",
        "ultInteracao": "Compra",
        "dataInteracao": "17/04/2025"
        },
        {
        "id": "549940520",
        "name": "Carlos Eduardo Ribeiro Machado",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cemnit@gmail.com",
        "genero": "M",
        "dataNasc": "04 Out.",
        "telefone": "5521970018737",
        "ultInteracao": "Compra",
        "dataInteracao": "17/04/2025"
        },
        {
        "id": "28470178",
        "name": "Angelo Miguel Gomide de Paula",
        "comPromocional": true,
        "numCompras": 1,
        "email": "aangelomig@icloud.com",
        "genero": "M",
        "dataNasc": "25 Set.",
        "telefone": "03193010003",
        "ultInteracao": "Compra",
        "dataInteracao": "16/04/2025"
        },
        {
        "id": "2391083673",
        "name": " ",
        "comPromocional": true,
        "numCompras": 2,
        "email": "igor.frinf002@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5527992292813",
        "ultInteracao": "Compra",
        "dataInteracao": "16/04/2025"
        },
        {
        "id": "52517109",
        "name": "Ozenildo Pereira Dos Santos",
        "comPromocional": false,
        "numCompras": 1,
        "email": "contato@flexutilidades.com",
        "genero": "M",
        "dataNasc": "07 Ago.",
        "telefone": "7198282-5230",
        "ultInteracao": "Compra",
        "dataInteracao": "16/04/2025"
        },
        {
        "id": "795257057",
        "name": "Glaubia de Paula Pimentel Alves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "paulapimentel013@gmail.com",
        "genero": "",
        "dataNasc": "10 Ago.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "16/04/2025"
        },
        {
        "id": "96032818",
        "name": "Fabricio Avila",
        "comPromocional": true,
        "numCompras": 1,
        "email": "bricio0108@hotmail.com",
        "genero": "M",
        "dataNasc": "01 Ago.",
        "telefone": "3134976250",
        "ultInteracao": "Compra",
        "dataInteracao": "16/04/2025"
        },
        {
        "id": "2389809449",
        "name": "Davi Monteiro Macedo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "davimmacedo@yahoo.com",
        "genero": "M",
        "dataNasc": "19 Fev.",
        "telefone": "5522999821844",
        "ultInteracao": "Compra",
        "dataInteracao": "15/04/2025"
        },
        {
        "id": "1366465674",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sergiospil880@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5542999451124",
        "ultInteracao": "Compra",
        "dataInteracao": "15/04/2025"
        },
        {
        "id": "486722036",
        "name": "Barbara Figueiredo Campos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "barbara.figueiredo@yahoo.com.br",
        "genero": "",
        "dataNasc": "06 Set.",
        "telefone": "5531999898641",
        "ultInteracao": "Compra",
        "dataInteracao": "15/04/2025"
        },
        {
        "id": "514400843",
        "name": "Gilber Abreu Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gilber318silva@gmail.com",
        "genero": "M",
        "dataNasc": "21 Mai.",
        "telefone": "5522999095373",
        "ultInteracao": "Compra",
        "dataInteracao": "15/04/2025"
        },
        {
        "id": "3612124",
        "name": "Joao Victor Freire Lessa",
        "comPromocional": true,
        "numCompras": 2,
        "email": "joaovictorlessa@hotmail.com",
        "genero": "M",
        "dataNasc": "21 Fev.",
        "telefone": "3832213904",
        "ultInteracao": "Compra",
        "dataInteracao": "15/04/2025"
        },
        {
        "id": "245717368",
        "name": "Otavio Augusto Euzebio Ventura",
        "comPromocional": true,
        "numCompras": 1,
        "email": "otavio_ventura_@hotmail.com",
        "genero": "M",
        "dataNasc": "09 Fev.",
        "telefone": " 14998865080",
        "ultInteracao": "Compra",
        "dataInteracao": "15/04/2025"
        },
        {
        "id": "617271615",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcosmlima05@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531988252920",
        "ultInteracao": "Compra",
        "dataInteracao": "14/04/2025"
        },
        {
        "id": "1121300814",
        "name": "Edivaldo de Carvalho Pereira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "edivaldopereira09031990@gmail.com",
        "genero": "M",
        "dataNasc": "09 Mar.",
        "telefone": "5566999822605",
        "ultInteracao": "Compra",
        "dataInteracao": "14/04/2025"
        },
        {
        "id": "3548657",
        "name": "Thiago Santos de Moraes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thiago.s.moraes@hotmail.com",
        "genero": "M",
        "dataNasc": "26 Mar.",
        "telefone": "4834353649",
        "ultInteracao": "Compra",
        "dataInteracao": "14/04/2025"
        },
        {
        "id": "32817105",
        "name": "Rafael Ferreira Linari",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rlinari@bol.com.br",
        "genero": "M",
        "dataNasc": "26 Mar.",
        "telefone": "3192148292",
        "ultInteracao": "Compra",
        "dataInteracao": "14/04/2025"
        },
        {
        "id": "53403788",
        "name": "Pablo Cristiano de Oliveira",
        "comPromocional": true,
        "numCompras": 2,
        "email": "pablofacsal@gmail.com",
        "genero": "M",
        "dataNasc": "08 Ago.",
        "telefone": "3130633175",
        "ultInteracao": "Compra",
        "dataInteracao": "14/04/2025"
        },
        {
        "id": "233974329",
        "name": "Paulo de Souza Castro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mileumveiculos@bol.com.br",
        "genero": "M",
        "dataNasc": "03 Ago.",
        "telefone": " 35988489301",
        "ultInteracao": "Compra",
        "dataInteracao": "14/04/2025"
        },
        {
        "id": "111053424",
        "name": "Christian Monteiro Guimaraes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "christtian.guimaraes@gmail.com",
        "genero": "M",
        "dataNasc": "26 Abr.",
        "telefone": " 62-92135336",
        "ultInteracao": "Compra",
        "dataInteracao": "12/04/2025"
        },
        {
        "id": "284268351",
        "name": "Lucas Leandro Lobo Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lucasleandrolobo.santos@gmail.com",
        "genero": "M",
        "dataNasc": "28 Jan.",
        "telefone": "67 992144411",
        "ultInteracao": "Compra",
        "dataInteracao": "12/04/2025"
        },
        {
        "id": "237231440",
        "name": "Fernando Cesar Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fernandocesar1008@gmail.com",
        "genero": "M",
        "dataNasc": "19 Jan.",
        "telefone": " 11995316977",
        "ultInteracao": "Compra",
        "dataInteracao": "11/04/2025"
        },
        {
        "id": "356236636",
        "name": "Paulo Silva Matta",
        "comPromocional": true,
        "numCompras": 1,
        "email": "paulo.matta1973@gmail.com",
        "genero": "M",
        "dataNasc": "08 Out.",
        "telefone": "077999198030",
        "ultInteracao": "Compra",
        "dataInteracao": "10/04/2025"
        },
        {
        "id": "5793871",
        "name": "Maria Ines Xavier Pitaluga",
        "comPromocional": false,
        "numCompras": 1,
        "email": "inespitaluga@hotmail.com",
        "genero": "",
        "dataNasc": "04 Abr.",
        "telefone": "3131991088399",
        "ultInteracao": "Compra",
        "dataInteracao": "10/04/2025"
        },
        {
        "id": "2385082772",
        "name": " ",
        "comPromocional": true,
        "numCompras": 2,
        "email": "netojurca@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5567992496988",
        "ultInteracao": "Compra",
        "dataInteracao": "10/04/2025"
        },
        {
        "id": "264386494",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "mateussoaresl101@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531983938116",
        "ultInteracao": "Compra",
        "dataInteracao": "10/04/2025"
        },
        {
        "id": "92151126",
        "name": "Fabricio Alexandre",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fabriciobanderas@yahoo.com.br",
        "genero": "M",
        "dataNasc": "02 Dez.",
        "telefone": "03133838191",
        "ultInteracao": "Compra",
        "dataInteracao": "10/04/2025"
        },
        {
        "id": "2384671952",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thiago.moose@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5511995091385",
        "ultInteracao": "Compra",
        "dataInteracao": "10/04/2025"
        },
        {
        "id": "1523514442",
        "name": " ",
        "comPromocional": true,
        "numCompras": 4,
        "email": "larmarmore@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5511981800005",
        "ultInteracao": "Compra",
        "dataInteracao": "10/04/2025"
        },
        {
        "id": "37576870",
        "name": "Antonio Carlos Alexandre Do Prado",
        "comPromocional": true,
        "numCompras": 1,
        "email": "prado.antonioc@gmail.com",
        "genero": "M",
        "dataNasc": "07 Jun.",
        "telefone": "1111947970636",
        "ultInteracao": "Compra",
        "dataInteracao": "09/04/2025"
        },
        {
        "id": "1216052498",
        "name": " ",
        "comPromocional": true,
        "numCompras": 2,
        "email": "marciaantonia2006@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531984356866",
        "ultInteracao": "Compra",
        "dataInteracao": "09/04/2025"
        },
        {
        "id": "72259317",
        "name": "Victor Tanos Jorge Maldonado",
        "comPromocional": true,
        "numCompras": 1,
        "email": "vmaldonado99@yahoo.com.br",
        "genero": "M",
        "dataNasc": "09 Nov.",
        "telefone": " 3191849949",
        "ultInteracao": "Compra",
        "dataInteracao": "09/04/2025"
        },
        {
        "id": "93142200",
        "name": "Romulo Bressanelli Valiati",
        "comPromocional": true,
        "numCompras": 1,
        "email": "romulo.valiati@hotmail.com",
        "genero": "M",
        "dataNasc": "30 Out.",
        "telefone": "2831995714774",
        "ultInteracao": "Compra",
        "dataInteracao": "08/04/2025"
        },
        {
        "id": "223258364",
        "name": "Leosidio Ulig",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cupimulig@gmail.com",
        "genero": "M",
        "dataNasc": "13 Jul.",
        "telefone": "027999408682",
        "ultInteracao": "Compra",
        "dataInteracao": "08/04/2025"
        },
        {
        "id": "735370700",
        "name": "Wanderson da Mata Barbosa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wandersondamatabarbosa@gmail.com",
        "genero": "",
        "dataNasc": "25 Out.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "08/04/2025"
        },
        {
        "id": "1614511105",
        "name": "Joao Vitor Santos de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "layxzerfenixofc@gmail.com",
        "genero": "M",
        "dataNasc": "16 Nov.",
        "telefone": "5571999949378",
        "ultInteracao": "Compra",
        "dataInteracao": "08/04/2025"
        },
        {
        "id": "535499947",
        "name": "Luciano de Souza E Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lucianosouzaesilva@gmail.com",
        "genero": "M",
        "dataNasc": "05 Jan.",
        "telefone": "5531996449484",
        "ultInteracao": "Compra",
        "dataInteracao": "08/04/2025"
        },
        {
        "id": "2376215325",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "Sable9999_@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531987387438",
        "ultInteracao": "Compra",
        "dataInteracao": "07/04/2025"
        },
        {
        "id": "133376633",
        "name": "Leandro Rodrigues Lisboa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leandrolisboa535@gmail.com",
        "genero": "M",
        "dataNasc": "26 Fev.",
        "telefone": " 11941140490",
        "ultInteracao": "Compra",
        "dataInteracao": "07/04/2025"
        },
        {
        "id": "297465171",
        "name": "Flavia Ferreira da Silva Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "flaviafesilva@hotmail.com",
        "genero": "",
        "dataNasc": "05 Nov.",
        "telefone": "5511972399750",
        "ultInteracao": "Compra",
        "dataInteracao": "07/04/2025"
        },
        {
        "id": "118488458",
        "name": "Antonio Carlos Gustmann Hennerich",
        "comPromocional": true,
        "numCompras": 1,
        "email": "antony_hennerich@hotmail.com",
        "genero": "M",
        "dataNasc": "25 Jul.",
        "telefone": "66996351653",
        "ultInteracao": "Compra",
        "dataInteracao": "07/04/2025"
        },
        {
        "id": "368966480",
        "name": "Marcell Luiz Lara Soares",
        "comPromocional": false,
        "numCompras": 2,
        "email": "marcelllara@hotmail.com",
        "genero": "M",
        "dataNasc": "05 Out.",
        "telefone": "5531996683544",
        "ultInteracao": "Compra",
        "dataInteracao": "07/04/2025"
        },
        {
        "id": "677845071",
        "name": "Vinicius Araujo Silva",
        "comPromocional": false,
        "numCompras": 1,
        "email": "vinicius.araujovet@gmail.com",
        "genero": "M",
        "dataNasc": "31 Jan.",
        "telefone": "5537991031300",
        "ultInteracao": "Compra",
        "dataInteracao": "07/04/2025"
        },
        {
        "id": "2374512379",
        "name": "Tatiane Martins Pinheiro",
        "comPromocional": false,
        "numCompras": 1,
        "email": "tatianepinheiro.farma@gmail.com",
        "genero": "",
        "dataNasc": "16 Nov.",
        "telefone": "5531994997157",
        "ultInteracao": "Compra",
        "dataInteracao": "07/04/2025"
        },
        {
        "id": "2373747933",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "raquelgon2011@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5537998269754",
        "ultInteracao": "Compra",
        "dataInteracao": "06/04/2025"
        },
        {
        "id": "1034581829",
        "name": "Rodrigo Domingues Prati",
        "comPromocional": true,
        "numCompras": 1,
        "email": "entregas@jbblocos.com.br",
        "genero": "M",
        "dataNasc": "03 Set.",
        "telefone": "5511998116920",
        "ultInteracao": "Compra",
        "dataInteracao": "06/04/2025"
        },
        {
        "id": "20507865",
        "name": "Ivan da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ivands18@gmail.com",
        "genero": "M",
        "dataNasc": "26 Nov.",
        "telefone": "11973515885",
        "ultInteracao": "Compra",
        "dataInteracao": "05/04/2025"
        },
        {
        "id": "33469973",
        "name": "Phelipe Vilas Boas Vianna Pavan de Paula",
        "comPromocional": true,
        "numCompras": 1,
        "email": "phelipevilasboaspavan@hotmail.com",
        "genero": "M",
        "dataNasc": "24 Fev.",
        "telefone": "021 7839652021 36270680",
        "ultInteracao": "Compra",
        "dataInteracao": "05/04/2025"
        },
        {
        "id": "629271178",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "adm@fujirio.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "21985552676",
        "ultInteracao": "Compra",
        "dataInteracao": "05/04/2025"
        },
        {
        "id": "131303782",
        "name": "Elias Dias de Sa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eliasdesa@live.com",
        "genero": "M",
        "dataNasc": "19 Nov.",
        "telefone": " 33 84251012",
        "ultInteracao": "Compra",
        "dataInteracao": "05/04/2025"
        },
        {
        "id": "51593144",
        "name": "Marcio Tavares Diniz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "martelodiniz@yahoo.com.br",
        "genero": "",
        "dataNasc": "29 Mar.",
        "telefone": "312105.5057",
        "ultInteracao": "Compra",
        "dataInteracao": "05/04/2025"
        },
        {
        "id": "13184543",
        "name": "Sergio Henrique Cecilio Goncalves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ceciliohenrique@icloud.com",
        "genero": "M",
        "dataNasc": "20 Jun.",
        "telefone": "03134347350",
        "ultInteracao": "Compra",
        "dataInteracao": "04/04/2025"
        },
        {
        "id": "1121491894",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sinistrohrprotecaoveicular@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "31991036070",
        "ultInteracao": "Compra",
        "dataInteracao": "04/04/2025"
        },
        {
        "id": "2373043122",
        "name": "Andre Jose Leite",
        "comPromocional": true,
        "numCompras": 1,
        "email": "andreleite3131@gmail.com",
        "genero": "M",
        "dataNasc": "28 Set.",
        "telefone": "5531985673864",
        "ultInteracao": "Compra",
        "dataInteracao": "04/04/2025"
        },
        {
        "id": "204267338",
        "name": "Larissa Fernandes Ferreira Do Patrocinio",
        "comPromocional": true,
        "numCompras": 1,
        "email": "larissafernandes1990@hotmail.com",
        "genero": "",
        "dataNasc": "23 Set.",
        "telefone": " 32991217664",
        "ultInteracao": "Compra",
        "dataInteracao": "04/04/2025"
        },
        {
        "id": "1509402288",
        "name": "Paulo Cesar de Araujo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cesardotantan@gmail.com",
        "genero": "",
        "dataNasc": "15 Jan.",
        "telefone": "5531982791027",
        "ultInteracao": "Compra",
        "dataInteracao": "04/04/2025"
        },
        {
        "id": "58312185",
        "name": "Rafael Tanure Carvalho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rafa_tanure@hotmail.com",
        "genero": "M",
        "dataNasc": "29 Out.",
        "telefone": "3837223683",
        "ultInteracao": "Compra",
        "dataInteracao": "04/04/2025"
        },
        {
        "id": "2372722548",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nfe@nortesulmg.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531995876870",
        "ultInteracao": "Compra",
        "dataInteracao": "04/04/2025"
        },
        {
        "id": "2372572410",
        "name": "Andre Jose Leite",
        "comPromocional": true,
        "numCompras": 1,
        "email": "andreleite3131@gmail.com",
        "genero": "M",
        "dataNasc": "28 Set.",
        "telefone": "5531985673864",
        "ultInteracao": "Compra",
        "dataInteracao": "04/04/2025"
        },
        {
        "id": "1002107781",
        "name": "Fabio Augusto Neman",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fabneman@gmail.com",
        "genero": "",
        "dataNasc": "08 Dez.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "04/04/2025"
        },
        {
        "id": "53240342",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "melsb@melsantabarbara.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "31972154128",
        "ultInteracao": "Compra",
        "dataInteracao": "04/04/2025"
        },
        {
        "id": "74277656",
        "name": "Naceso Alves Soares Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "naceso.junior@gmail.com",
        "genero": "",
        "dataNasc": "27 Abr.",
        "telefone": "6133532071",
        "ultInteracao": "Compra",
        "dataInteracao": "03/04/2025"
        },
        {
        "id": "2370085188",
        "name": "Nilo Francisco da Cruz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nilofcruz@gmail.com",
        "genero": "M",
        "dataNasc": "05 Jul.",
        "telefone": "5522999290318",
        "ultInteracao": "Compra",
        "dataInteracao": "03/04/2025"
        },
        {
        "id": "438032767",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fernando.piresoliveira75@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "11983431623",
        "ultInteracao": "Compra",
        "dataInteracao": "03/04/2025"
        },
        {
        "id": "843380",
        "name": "Gerci Antunes Soares Filho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gerciantunes@yahoo.com.br",
        "genero": "",
        "dataNasc": "11 Fev.",
        "telefone": "03891451032",
        "ultInteracao": "Compra",
        "dataInteracao": "03/04/2025"
        },
        {
        "id": "398166277",
        "name": "Dener Brasil",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dbrasil2807@gmail.com",
        "genero": "M",
        "dataNasc": "16 Jun.",
        "telefone": "32984092135",
        "ultInteracao": "Compra",
        "dataInteracao": "03/04/2025"
        },
        {
        "id": "217935630",
        "name": "Antenor Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "antenorfgomes@hotmail.com",
        "genero": "M",
        "dataNasc": "12 Dez.",
        "telefone": " 75.98805.9906",
        "ultInteracao": "Compra",
        "dataInteracao": "02/04/2025"
        },
        {
        "id": "2368527990",
        "name": "Roberta Coelho Santana Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "coelho.roberta@gmail.com",
        "genero": "",
        "dataNasc": "15 Nov.",
        "telefone": "5531982111171",
        "ultInteracao": "Compra",
        "dataInteracao": "02/04/2025"
        },
        {
        "id": "797792857",
        "name": "Fernando Almeida Ribeiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ferthamami@gmail.com",
        "genero": "M",
        "dataNasc": "01 Mar.",
        "telefone": "21988981319",
        "ultInteracao": "Compra",
        "dataInteracao": "02/04/2025"
        },
        {
        "id": "2364566377",
        "name": "Carlos Eduardo Lopes da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gerencia@reflextempervidros.com.br",
        "genero": "M",
        "dataNasc": "04 Mai.",
        "telefone": "5531986265429",
        "ultInteracao": "Compra",
        "dataInteracao": "02/04/2025"
        },
        {
        "id": "459521013",
        "name": "Nilton Osamu Shibata",
        "comPromocional": true,
        "numCompras": 1,
        "email": "niltonshibatta@gmail.com",
        "genero": "M",
        "dataNasc": "13 Out.",
        "telefone": "11953356182",
        "ultInteracao": "Compra",
        "dataInteracao": "02/04/2025"
        },
        {
        "id": "16723573",
        "name": "William Duarte Pessoa de Faria",
        "comPromocional": true,
        "numCompras": 3,
        "email": "wildpessoa@gmail.com",
        "genero": "M",
        "dataNasc": "15 Dez.",
        "telefone": "3131999264975",
        "ultInteracao": "Compra",
        "dataInteracao": "02/04/2025"
        },
        {
        "id": "322830540",
        "name": "Desiree Pinheiro Burlamaqui Vieira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "desireepbv@gmail.com",
        "genero": "",
        "dataNasc": "25 Abr.",
        "telefone": "5547991086361",
        "ultInteracao": "Compra",
        "dataInteracao": "02/04/2025"
        },
        {
        "id": "363042768",
        "name": "Danielle Braganca Araujo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "daniaraujo1989@icloud.com",
        "genero": "",
        "dataNasc": "11 Jun.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "01/04/2025"
        },
        {
        "id": "34586765",
        "name": "Renato Guimaraes Moreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "renatogmoreira@gmail.com",
        "genero": "M",
        "dataNasc": "24 Jan.",
        "telefone": "02178943356",
        "ultInteracao": "Compra",
        "dataInteracao": "01/04/2025"
        },
        {
        "id": "2359581718",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "gpcrangel@outlook.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "31/03/2025"
        },
        {
        "id": "200179402",
        "name": "Rogerio Soares de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rogerio.soar@hotmail.com",
        "genero": "M",
        "dataNasc": "09 Set.",
        "telefone": "33 32777165",
        "ultInteracao": "Compra",
        "dataInteracao": "31/03/2025"
        },
        {
        "id": "88408432",
        "name": "Rafael Moulin Penido de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rafaelmpo@yahoo.com.br",
        "genero": "M",
        "dataNasc": "10 Out.",
        "telefone": "31991137454",
        "ultInteracao": "Compra",
        "dataInteracao": "31/03/2025"
        },
        {
        "id": "189588560",
        "name": "Rogerio Sabato",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rsabato@bol.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": " 31-99860901",
        "ultInteracao": "Compra",
        "dataInteracao": "30/03/2025"
        },
        {
        "id": "68551220",
        "name": "Bruno Ramos Berwig",
        "comPromocional": true,
        "numCompras": 1,
        "email": "bruno_rammos@hotmail.com",
        "genero": "",
        "dataNasc": "26 Out.",
        "telefone": " 04999096783",
        "ultInteracao": "Compra",
        "dataInteracao": "31/03/2025"
        },
        {
        "id": "31631357",
        "name": "Renan Thomaz Bueno Malanski Baran",
        "comPromocional": true,
        "numCompras": 1,
        "email": "renanbaran@gmail.com",
        "genero": "M",
        "dataNasc": "16 Fev.",
        "telefone": "4284041981",
        "ultInteracao": "Compra",
        "dataInteracao": "31/03/2025"
        },
        {
        "id": "33779416",
        "name": "Leandro Leocadio da Rocha Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leocadio82@yahoo.com.br",
        "genero": "M",
        "dataNasc": "20 Fev.",
        "telefone": "3188130693",
        "ultInteracao": "Compra",
        "dataInteracao": "30/03/2025"
        },
        {
        "id": "2363202352",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jakues@uai.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "5538999159442",
        "ultInteracao": "Compra",
        "dataInteracao": "30/03/2025"
        },
        {
        "id": "172017955",
        "name": "Bruno Rodrigues de Almeida Alves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "brunopsibh@hotmail.com",
        "genero": "M",
        "dataNasc": "21 Mar.",
        "telefone": "31982463773",
        "ultInteracao": "Compra",
        "dataInteracao": "30/03/2025"
        },
        {
        "id": "263866492",
        "name": "Wesley Alexandre de Sousa E Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wesleyalexandre216@gmail.com",
        "genero": "M",
        "dataNasc": "14 Jul.",
        "telefone": "971795339",
        "ultInteracao": "Compra",
        "dataInteracao": "29/03/2025"
        },
        {
        "id": "428053990",
        "name": "Ipojucan Martins Barcelos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ipojucanmbarcelos@gmail.com",
        "genero": "M",
        "dataNasc": "20 Jun.",
        "telefone": "5521995070342",
        "ultInteracao": "Compra",
        "dataInteracao": "29/03/2025"
        },
        {
        "id": "2357035849",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "top.ltda@bol.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "553135650470",
        "ultInteracao": "Compra",
        "dataInteracao": "29/03/2025"
        },
        {
        "id": "64918666",
        "name": "Felipe da Silva Carballo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "felipecarballorj@gmail.com",
        "genero": "",
        "dataNasc": "21 Jun.",
        "telefone": "21984841043",
        "ultInteracao": "Compra",
        "dataInteracao": "28/03/2025"
        },
        {
        "id": "250459299",
        "name": "Aline Tomaz Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alyne_tomaz@hotmail.com",
        "genero": "",
        "dataNasc": "02 Fev.",
        "telefone": "31987186839",
        "ultInteracao": "Compra",
        "dataInteracao": "28/03/2025"
        },
        {
        "id": "40531819",
        "name": "Fernando de Reboucas Rodrigues",
        "comPromocional": true,
        "numCompras": 3,
        "email": "fernandorr2003@hotmail.com",
        "genero": "M",
        "dataNasc": "24 Nov.",
        "telefone": "3132960185",
        "ultInteracao": "Compra",
        "dataInteracao": "28/03/2025"
        },
        {
        "id": "185911100",
        "name": "Christian Rodrigues Apolinario",
        "comPromocional": true,
        "numCompras": 2,
        "email": "crisrodriguesap@yahoo.com.br",
        "genero": "M",
        "dataNasc": "20 Jun.",
        "telefone": " 31994274745",
        "ultInteracao": "Compra",
        "dataInteracao": "28/03/2025"
        },
        {
        "id": "175869488",
        "name": "Lucio Druve",
        "comPromocional": false,
        "numCompras": 1,
        "email": "lucio.druve@yahoo.com",
        "genero": "M",
        "dataNasc": "30 Jun.",
        "telefone": " 3199669880",
        "ultInteracao": "Compra",
        "dataInteracao": "28/03/2025"
        },
        {
        "id": "499178196",
        "name": "Rafaela de Almeida Souza",
        "comPromocional": false,
        "numCompras": 2,
        "email": "rafaa.lopees@hotmail.com",
        "genero": "",
        "dataNasc": "18 Mar.",
        "telefone": "5521999831583",
        "ultInteracao": "Compra",
        "dataInteracao": "27/03/2025"
        },
        {
        "id": "278210500",
        "name": "Matheus Morais Rodrigues",
        "comPromocional": true,
        "numCompras": 2,
        "email": "matheusmoraisrodrigues123@gmail.com",
        "genero": "M",
        "dataNasc": "24 Ago.",
        "telefone": "62984922553",
        "ultInteracao": "Compra",
        "dataInteracao": "27/03/2025"
        },
        {
        "id": "43019478",
        "name": "Anderson Pereira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "andersonper2007@hotmail.com",
        "genero": "M",
        "dataNasc": "30 Abr.",
        "telefone": "31 984763959",
        "ultInteracao": "Compra",
        "dataInteracao": "27/03/2025"
        },
        {
        "id": "814473304",
        "name": "Adriano Fedrigo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fedrigo.adriano82@gmail.com",
        "genero": "M",
        "dataNasc": "23 Jun.",
        "telefone": "5555999267493",
        "ultInteracao": "Compra",
        "dataInteracao": "27/03/2025"
        },
        {
        "id": "729279060",
        "name": "Wesley Dos Santos Soares",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wesleyssoares83@gmail.com",
        "genero": "M",
        "dataNasc": "19 Mai.",
        "telefone": "5531996878386",
        "ultInteracao": "Compra",
        "dataInteracao": "27/03/2025"
        },
        {
        "id": "306768961",
        "name": "Rodrigo Cabral",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rodrigocph2016@gmail.com",
        "genero": "M",
        "dataNasc": "04 Jul.",
        "telefone": "21973066750",
        "ultInteracao": "Compra",
        "dataInteracao": "27/03/2025"
        },
        {
        "id": "131148699",
        "name": "Raquel Ferreira da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "raquel806@yahoo.com.br",
        "genero": "",
        "dataNasc": "07 Dez.",
        "telefone": "21988234046",
        "ultInteracao": "Compra",
        "dataInteracao": "26/03/2025"
        },
        {
        "id": "225704466",
        "name": "Neilor Victor Vieira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "neilorvvieira@gmail.com",
        "genero": "M",
        "dataNasc": "21 Set.",
        "telefone": "31994308857",
        "ultInteracao": "Compra",
        "dataInteracao": "26/03/2025"
        },
        {
        "id": "535688249",
        "name": "Marcos Donizete Tafuri",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcostafuri1@gmail.com",
        "genero": "M",
        "dataNasc": "11 Set.",
        "telefone": "16997117053",
        "ultInteracao": "Compra",
        "dataInteracao": "26/03/2025"
        },
        {
        "id": "198542266",
        "name": "Davi Rodrigues Batista",
        "comPromocional": true,
        "numCompras": 1,
        "email": "davi6b@gmail.com",
        "genero": "M",
        "dataNasc": "01 Ago.",
        "telefone": "5561998235987",
        "ultInteracao": "Compra",
        "dataInteracao": "26/03/2025"
        },
        {
        "id": "68563350",
        "name": "Rodrigo Pereira da Silva",
        "comPromocional": false,
        "numCompras": 1,
        "email": "moreno_rp@hotmail.com",
        "genero": "M",
        "dataNasc": "08 Fev.",
        "telefone": "16 9 82580795",
        "ultInteracao": "Compra",
        "dataInteracao": "26/03/2025"
        },
        {
        "id": "489174803",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jarbas.r@amadeira.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "2734345066",
        "ultInteracao": "Compra",
        "dataInteracao": "25/03/2025"
        },
        {
        "id": "642407242",
        "name": "Matheus da Silva Miranda",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mtthkc@gmail.com",
        "genero": "M",
        "dataNasc": "06 Mar.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "25/03/2025"
        },
        {
        "id": "71782526",
        "name": "Ana Paula Fernandes Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "apdoisf@gmail.com",
        "genero": "",
        "dataNasc": "06 Jun.",
        "telefone": "31994054458",
        "ultInteracao": "Compra",
        "dataInteracao": "25/03/2025"
        },
        {
        "id": "1146145170",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thais.lourdes@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531984091183",
        "ultInteracao": "Compra",
        "dataInteracao": "25/03/2025"
        },
        {
        "id": "239986100",
        "name": "Filipe Silva de Oliveira Leite",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fso.leite@yahoo.com.br",
        "genero": "M",
        "dataNasc": "11 Mai.",
        "telefone": " 31991749291",
        "ultInteracao": "Compra",
        "dataInteracao": "25/03/2025"
        },
        {
        "id": "313973090",
        "name": "Maria Aparecida Rodrigues da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cckar.oficina@gmail.com",
        "genero": "",
        "dataNasc": "14 Jul.",
        "telefone": "5511986617777",
        "ultInteracao": "Compra",
        "dataInteracao": "24/03/2025"
        },
        {
        "id": "129297173",
        "name": "Geliane Novaes de Moraes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "millahermsdoff@gmail.com",
        "genero": "",
        "dataNasc": "21 Jun.",
        "telefone": " 02281391734",
        "ultInteracao": "Compra",
        "dataInteracao": "24/03/2025"
        },
        {
        "id": "2347091749",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jonatasriedel@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531971484297",
        "ultInteracao": "Compra",
        "dataInteracao": "24/03/2025"
        },
        {
        "id": "156170316",
        "name": "Marcelo Araujo Campos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcelocampos@adv.oabmg.org.br",
        "genero": "M",
        "dataNasc": "16 Ago.",
        "telefone": " 3199498088",
        "ultInteracao": "Compra",
        "dataInteracao": "23/03/2025"
        },
        {
        "id": "181340440",
        "name": "Ana Paula Barbosa Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ana.subway@outlook.com",
        "genero": "",
        "dataNasc": "05 Nov.",
        "telefone": " 31985456261",
        "ultInteracao": "Compra",
        "dataInteracao": "22/03/2025"
        },
        {
        "id": "460297156",
        "name": "Josiel Duarte Maciel",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jodumajudo@gmail.com",
        "genero": "M",
        "dataNasc": "11 Ago.",
        "telefone": "5511999312461",
        "ultInteracao": "Compra",
        "dataInteracao": "21/03/2025"
        },
        {
        "id": "2345383598",
        "name": "Plinio Andre Flauzino",
        "comPromocional": true,
        "numCompras": 1,
        "email": "andreplinio@outlook.com",
        "genero": "M",
        "dataNasc": "22 Nov.",
        "telefone": "5531991801096",
        "ultInteracao": "Compra",
        "dataInteracao": "21/03/2025"
        },
        {
        "id": "1951991573",
        "name": "Roney da Rocha Ferreira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "roneydobau2023@gmail.com",
        "genero": "M",
        "dataNasc": "17 Mar.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "21/03/2025"
        },
        {
        "id": "1287589971",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pimentelvidrositz@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5599991771658",
        "ultInteracao": "Compra",
        "dataInteracao": "20/03/2025"
        },
        {
        "id": "259019227",
        "name": "Josimar Pereira da Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "josimarcostapereira48@gmail.com",
        "genero": "M",
        "dataNasc": "28 Mai.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "20/03/2025"
        },
        {
        "id": "223780198",
        "name": "Fagner Mendes de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fagnetum@gmail.com",
        "genero": "M",
        "dataNasc": "27 Jun.",
        "telefone": "38991598096",
        "ultInteracao": "Compra",
        "dataInteracao": "20/03/2025"
        },
        {
        "id": "173713693",
        "name": "Felipe Cordeiro Guimaraes Alves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alves.felipe91@gmail.com",
        "genero": "M",
        "dataNasc": "04 Jan.",
        "telefone": "31975430020",
        "ultInteracao": "Compra",
        "dataInteracao": "20/03/2025"
        },
        {
        "id": "286101266",
        "name": "Josue Machado da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mac21josue@gmail.com",
        "genero": "M",
        "dataNasc": "12 Nov.",
        "telefone": "22999621245",
        "ultInteracao": "Compra",
        "dataInteracao": "20/03/2025"
        },
        {
        "id": "275798872",
        "name": "Marcelo Aparecido de Magalhes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcelomagalhaes5k@gmail.com",
        "genero": "M",
        "dataNasc": "25 Set.",
        "telefone": "5532998352523",
        "ultInteracao": "Compra",
        "dataInteracao": "19/03/2025"
        },
        {
        "id": "158181322",
        "name": "Vanderci Aparecido da Silva",
        "comPromocional": true,
        "numCompras": 2,
        "email": "vanderci.dom@gmail.com",
        "genero": "M",
        "dataNasc": "27 Fev.",
        "telefone": "11932239522",
        "ultInteracao": "Compra",
        "dataInteracao": "19/03/2025"
        },
        {
        "id": "13984595",
        "name": "Genilson Jose Sousa Ramos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "genilson.s.ramos@hotmail.com",
        "genero": "M",
        "dataNasc": "16 Jun.",
        "telefone": "9833631313",
        "ultInteracao": "Compra",
        "dataInteracao": "19/03/2025"
        },
        {
        "id": "32761490",
        "name": "Aures Arlen da Costa Castro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "auris_arlen@hotmail.com",
        "genero": "",
        "dataNasc": "19 Mar.",
        "telefone": "27996230212",
        "ultInteracao": "Compra",
        "dataInteracao": "19/03/2025"
        },
        {
        "id": "28379261",
        "name": "Edna Ferreira da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ednafsilvas@gmail.com",
        "genero": "",
        "dataNasc": "18 Mar.",
        "telefone": "2227689300",
        "ultInteracao": "Compra",
        "dataInteracao": "19/03/2025"
        },
        {
        "id": "148811851",
        "name": "Jose Edmar Oliveira Barbosa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "edmarbarbosa_@hotmail.com",
        "genero": "M",
        "dataNasc": "15 Fev.",
        "telefone": "081 99686912",
        "ultInteracao": "Compra",
        "dataInteracao": "19/03/2025"
        },
        {
        "id": "35036292",
        "name": "Felipe Boaventura Diniz Oliveira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "felipe2760@hotmail.com",
        "genero": "M",
        "dataNasc": "14 Fev.",
        "telefone": "3133329036",
        "ultInteracao": "Compra",
        "dataInteracao": "19/03/2025"
        },
        {
        "id": "326650045",
        "name": "Luis Donizetti de Assis Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "juninho.ld@hotmail.com",
        "genero": "M",
        "dataNasc": "11 Jun.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "19/03/2025"
        },
        {
        "id": "1189036760",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "diocar.vendasonline@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5518996615401",
        "ultInteracao": "Compra",
        "dataInteracao": "19/03/2025"
        },
        {
        "id": "220377516",
        "name": "Ismair Nascimento Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ismairjunior6@gmail.com",
        "genero": "",
        "dataNasc": "18 Jun.",
        "telefone": " 31992699536",
        "ultInteracao": "Compra",
        "dataInteracao": "18/03/2025"
        },
        {
        "id": "1560502306",
        "name": "Julia Madalena Dias Maciel",
        "comPromocional": false,
        "numCompras": 1,
        "email": "diasjulia1914@gmail.com",
        "genero": "",
        "dataNasc": "18 Mai.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "18/03/2025"
        },
        {
        "id": "2339026732",
        "name": " ",
        "comPromocional": true,
        "numCompras": 2,
        "email": "davigl1410@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5533988738953",
        "ultInteracao": "Compra",
        "dataInteracao": "18/03/2025"
        },
        {
        "id": "275140470",
        "name": "Isis de Almeida Nogueira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "almeida.isis@outlook.com",
        "genero": "",
        "dataNasc": "18 Set.",
        "telefone": "(31) 997393833",
        "ultInteracao": "Compra",
        "dataInteracao": "18/03/2025"
        },
        {
        "id": "737610175",
        "name": "Edenilson Roberto Trimer",
        "comPromocional": true,
        "numCompras": 1,
        "email": "trimer.edenilson@gmail.com",
        "genero": "M",
        "dataNasc": "23 Abr.",
        "telefone": "19974096265",
        "ultInteracao": "Compra",
        "dataInteracao": "18/03/2025"
        },
        {
        "id": "352471280",
        "name": "Matheus Salvina Viana Goncalves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "bmfreios@icloud.com",
        "genero": "M",
        "dataNasc": "04 Abr.",
        "telefone": "35992529087",
        "ultInteracao": "Compra",
        "dataInteracao": "17/03/2025"
        },
        {
        "id": "169969589",
        "name": "Joan Carlos Nogueira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "joan_nogueira@yahoo.com.br",
        "genero": "M",
        "dataNasc": "05 Nov.",
        "telefone": " 3284860707",
        "ultInteracao": "Compra",
        "dataInteracao": "17/03/2025"
        },
        {
        "id": "235739865",
        "name": "Francisco Jean Davi Nunes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "f.ab.jam@hotmail.com",
        "genero": "M",
        "dataNasc": "24 Mai.",
        "telefone": "11985655277",
        "ultInteracao": "Compra",
        "dataInteracao": "17/03/2025"
        },
        {
        "id": "616440221",
        "name": "Simara Diniz de Almeida",
        "comPromocional": true,
        "numCompras": 3,
        "email": "simaradinizdealmeida@gmail.com",
        "genero": "",
        "dataNasc": "09 Jul.",
        "telefone": "11964929066",
        "ultInteracao": "Compra",
        "dataInteracao": "17/03/2025"
        },
        {
        "id": "30499586",
        "name": "Ivan Lindolfo Bento Gouveia",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tander209@yahoo.com.br",
        "genero": "M",
        "dataNasc": "18 Set.",
        "telefone": "3131998565517",
        "ultInteracao": "Compra",
        "dataInteracao": "17/03/2025"
        },
        {
        "id": "325621251",
        "name": "Lucio Alvaro de Lima",
        "comPromocional": true,
        "numCompras": 2,
        "email": "lluembew44@gmail.com",
        "genero": "M",
        "dataNasc": "02 Abr.",
        "telefone": "5531987794100",
        "ultInteracao": "Compra",
        "dataInteracao": "17/03/2025"
        },
        {
        "id": "475648752",
        "name": "Tarcisio Israel",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tarcisioisrael@sed.sc.gov.br",
        "genero": "M",
        "dataNasc": "15 Nov.",
        "telefone": "47984633354",
        "ultInteracao": "Compra",
        "dataInteracao": "17/03/2025"
        },
        {
        "id": "181792609",
        "name": "Claudio Armando Nunes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "canunes1966@gmail.com",
        "genero": "M",
        "dataNasc": "18 Mai.",
        "telefone": " 51 99187245",
        "ultInteracao": "Compra",
        "dataInteracao": "17/03/2025"
        },
        {
        "id": "25667186",
        "name": "Luiz Henrique Campos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luizhcampos@yahoo.com.br",
        "genero": "",
        "dataNasc": "27 Jun.",
        "telefone": "3133924930",
        "ultInteracao": "Compra",
        "dataInteracao": "17/03/2025"
        },
        {
        "id": "142439454",
        "name": "Andre Hermogenes da Silva",
        "comPromocional": false,
        "numCompras": 1,
        "email": "hermogenesandre@yahoo.com.br",
        "genero": "M",
        "dataNasc": "12 Abr.",
        "telefone": " 31 83381871",
        "ultInteracao": "Compra",
        "dataInteracao": "16/03/2025"
        },
        {
        "id": "115258607",
        "name": "Ricardo Lacerda",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dorloterenfeitesdecadeira@hotmail.com",
        "genero": "M",
        "dataNasc": "25 Mai.",
        "telefone": "31989519790",
        "ultInteracao": "Compra",
        "dataInteracao": "16/03/2025"
        },
        {
        "id": "1413342658",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "kelsoanogueira@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531987091329",
        "ultInteracao": "Compra",
        "dataInteracao": "16/03/2025"
        },
        {
        "id": "179096558",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gomes.atilio98@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": " 15997278309",
        "ultInteracao": "Compra",
        "dataInteracao": "16/03/2025"
        },
        {
        "id": "217141683",
        "name": "Davi Pinheiro Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sgerais@jardimdasaudade.com.br",
        "genero": "M",
        "dataNasc": "17 Fev.",
        "telefone": " 021 984158620",
        "ultInteracao": "Compra",
        "dataInteracao": "16/03/2025"
        },
        {
        "id": "242779219",
        "name": "Jussara Paula Pereira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "jussarapaulap@gmail.com",
        "genero": "",
        "dataNasc": "24 Set.",
        "telefone": "11978818863",
        "ultInteracao": "Compra",
        "dataInteracao": "16/03/2025"
        },
        {
        "id": "296311921",
        "name": "Wesley Luciano Davi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wesleyld87@gmail.com",
        "genero": "M",
        "dataNasc": "15 Ago.",
        "telefone": "037998369589",
        "ultInteracao": "Compra",
        "dataInteracao": "16/03/2025"
        },
        {
        "id": "25519324",
        "name": "Marco Aurelio Anony Fortes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcoanony@yahoo.com.br",
        "genero": "M",
        "dataNasc": "12 Mar.",
        "telefone": "51996894859",
        "ultInteracao": "Compra",
        "dataInteracao": "16/03/2025"
        },
        {
        "id": "2118520957",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "siberiascosta@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531997010768",
        "ultInteracao": "Compra",
        "dataInteracao": "16/03/2025"
        },
        {
        "id": "52563343",
        "name": "Erika Cristina Dos Santos Medeiros",
        "comPromocional": true,
        "numCompras": 1,
        "email": "comidamineira57@outlook.com",
        "genero": "",
        "dataNasc": "27 Out.",
        "telefone": "01230131708",
        "ultInteracao": "Compra",
        "dataInteracao": "15/03/2025"
        },
        {
        "id": "267450847",
        "name": "Edvanio Carlos Gomes",
        "comPromocional": true,
        "numCompras": 2,
        "email": "gomesedvanio@yahoo.com.br",
        "genero": "M",
        "dataNasc": "04 Jun.",
        "telefone": "31984163153",
        "ultInteracao": "Compra",
        "dataInteracao": "15/03/2025"
        },
        {
        "id": "418787931",
        "name": "Leonardo Dos Santos Franca",
        "comPromocional": true,
        "numCompras": 1,
        "email": "raffabernardoo@gmail.com",
        "genero": "M",
        "dataNasc": "28 Ago.",
        "telefone": "5519997292487",
        "ultInteracao": "Compra",
        "dataInteracao": "14/03/2025"
        },
        {
        "id": "2085650683",
        "name": "Leonardo Soares Moreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leogrampolla10@icloud.com",
        "genero": "M",
        "dataNasc": "17 Out.",
        "telefone": "5524999052639",
        "ultInteracao": "Compra",
        "dataInteracao": "14/03/2025"
        },
        {
        "id": "434059310",
        "name": "Joao Batista Rosa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jbrosa2018@gmail.com",
        "genero": "M",
        "dataNasc": "03 Nov.",
        "telefone": "5542991162372",
        "ultInteracao": "Compra",
        "dataInteracao": "13/03/2025"
        },
        {
        "id": "360637349",
        "name": "Matheus Santos",
        "comPromocional": true,
        "numCompras": 2,
        "email": "suporte@lojacuidadofeminino.com.br",
        "genero": "M",
        "dataNasc": "18 Mar.",
        "telefone": "5571992478737",
        "ultInteracao": "Compra",
        "dataInteracao": "13/03/2025"
        },
        {
        "id": "81340766",
        "name": "Valter Jorge Vitor",
        "comPromocional": true,
        "numCompras": 1,
        "email": "valterjvitor@gmail.com",
        "genero": "M",
        "dataNasc": "27 Mai.",
        "telefone": "03131988001613",
        "ultInteracao": "Compra",
        "dataInteracao": "13/03/2025"
        },
        {
        "id": "2327222170",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "azizneto@terra.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531988716166",
        "ultInteracao": "Compra",
        "dataInteracao": "13/03/2025"
        },
        {
        "id": "35724945",
        "name": "Tancredo Teixeira de Andrade Neto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tancredoposse@gmail.com",
        "genero": "M",
        "dataNasc": "03 Dez.",
        "telefone": "6234812674",
        "ultInteracao": "Compra",
        "dataInteracao": "13/03/2025"
        },
        {
        "id": "11207628",
        "name": "Tais de Castro Quintao",
        "comPromocional": true,
        "numCompras": 1,
        "email": "taislucky@hotmail.com",
        "genero": "",
        "dataNasc": "08 Jun.",
        "telefone": " (31)38482647",
        "ultInteracao": "Compra",
        "dataInteracao": "12/03/2025"
        },
        {
        "id": "93853213",
        "name": "Odair de Andrade Gois",
        "comPromocional": true,
        "numCompras": 1,
        "email": "odairgoiscorretor@hotmail.com",
        "genero": "M",
        "dataNasc": "02 Jul.",
        "telefone": "44991669888",
        "ultInteracao": "Compra",
        "dataInteracao": "12/03/2025"
        },
        {
        "id": "257157985",
        "name": "Silmara Marques Rosa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "silmaramarques17.smr@gmail.com",
        "genero": "",
        "dataNasc": "17 Abr.",
        "telefone": "11920011708",
        "ultInteracao": "Compra",
        "dataInteracao": "12/03/2025"
        },
        {
        "id": "35048135",
        "name": "Andrew Yoiti Taniguchi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "andrewtaniguchi@hotmail.com",
        "genero": "M",
        "dataNasc": "29 Ago.",
        "telefone": "44999849959",
        "ultInteracao": "Compra",
        "dataInteracao": "12/03/2025"
        },
        {
        "id": "823629057",
        "name": "Daniel Nogueira Machado",
        "comPromocional": true,
        "numCompras": 1,
        "email": "daniel.veilub@gmail.com",
        "genero": "M",
        "dataNasc": "11 Abr.",
        "telefone": "5569999658351",
        "ultInteracao": "Compra",
        "dataInteracao": "12/03/2025"
        },
        {
        "id": "2325565322",
        "name": "Fernando Rodrigues Soares",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fernandorosoares189@gmail.com",
        "genero": "M",
        "dataNasc": "25 Jul.",
        "telefone": "5531997831040",
        "ultInteracao": "Compra",
        "dataInteracao": "12/03/2025"
        },
        {
        "id": "175043668",
        "name": "Fabricio Carvalho Sousa",
        "comPromocional": false,
        "numCompras": 1,
        "email": "giganteimports@hotmail.com",
        "genero": "M",
        "dataNasc": "05 Ago.",
        "telefone": "34991271100",
        "ultInteracao": "Compra",
        "dataInteracao": "12/03/2025"
        },
        {
        "id": "168275754",
        "name": "Harald Stumpf",
        "comPromocional": false,
        "numCompras": 1,
        "email": "stumpfharald@gmail.com",
        "genero": "M",
        "dataNasc": "08 Abr.",
        "telefone": "31995010917",
        "ultInteracao": "Compra",
        "dataInteracao": "11/03/2025"
        },
        {
        "id": "271666138",
        "name": "Anderson Cesar Nepomuceno",
        "comPromocional": true,
        "numCompras": 1,
        "email": "anderson.vendasmg@gmail.com",
        "genero": "M",
        "dataNasc": "02 Mar.",
        "telefone": "31994316166",
        "ultInteracao": "Compra",
        "dataInteracao": "11/03/2025"
        },
        {
        "id": "2319624945",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cazenriquerodrigues@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531999586825",
        "ultInteracao": "Compra",
        "dataInteracao": "11/03/2025"
        },
        {
        "id": "167697474",
        "name": "Gabriel da Silva Cerqueira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gabriel.ceerq@live.com",
        "genero": "M",
        "dataNasc": "19 Fev.",
        "telefone": "19993181450",
        "ultInteracao": "Compra",
        "dataInteracao": "11/03/2025"
        },
        {
        "id": "60655665",
        "name": "Luiz Rogerio Alves Gomes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lurog40@gmail.com",
        "genero": "M",
        "dataNasc": "16 Out.",
        "telefone": "2298325959",
        "ultInteracao": "Compra",
        "dataInteracao": "11/03/2025"
        },
        {
        "id": "23901155",
        "name": "Ulisses Vieira Neto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ulisses@informaticavirtual.com.br",
        "genero": "M",
        "dataNasc": "02 Jul.",
        "telefone": "35991840100",
        "ultInteracao": "Compra",
        "dataInteracao": "11/03/2025"
        },
        {
        "id": "80289158",
        "name": "Tomaz Moacir Motta",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tomazmotta@gmail.com",
        "genero": "M",
        "dataNasc": "10 Jun.",
        "telefone": "4192084401",
        "ultInteracao": "Compra",
        "dataInteracao": "11/03/2025"
        },
        {
        "id": "80778062",
        "name": "Rodrigo de Lima Barra Discaciati",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rodrigolbd@yahoo.com.br",
        "genero": "M",
        "dataNasc": "04 Mar.",
        "telefone": "3188089337",
        "ultInteracao": "Compra",
        "dataInteracao": "11/03/2025"
        },
        {
        "id": "688557131",
        "name": "Cleomar Ferreira de Campos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cleomardcampos@gmail.com",
        "genero": "M",
        "dataNasc": "05 Ago.",
        "telefone": "54996162948",
        "ultInteracao": "Compra",
        "dataInteracao": "10/03/2025"
        },
        {
        "id": "67972681",
        "name": "Flavio de Oliveira Ferreira",
        "comPromocional": false,
        "numCompras": 2,
        "email": "fflaviofferreira@yahoo.com.br",
        "genero": "M",
        "dataNasc": "23 Ago.",
        "telefone": "03125599200",
        "ultInteracao": "Compra",
        "dataInteracao": "10/03/2025"
        },
        {
        "id": "1120517960",
        "name": "Francisco Martins de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "franciscomartinsdesouza7571@gmail.com",
        "genero": "M",
        "dataNasc": "16 Jul.",
        "telefone": "5531984656806",
        "ultInteracao": "Compra",
        "dataInteracao": "10/03/2025"
        },
        {
        "id": "209127492",
        "name": "Pedro Arthur Costa Barbosa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "p.arthurcb@gmail.com",
        "genero": "M",
        "dataNasc": "02 Jul.",
        "telefone": " 3134881338",
        "ultInteracao": "Compra",
        "dataInteracao": "10/03/2025"
        },
        {
        "id": "1121909377",
        "name": "Gabriel Martins Tavares",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gabrieltu686@gmail.com",
        "genero": "M",
        "dataNasc": "24 Ago.",
        "telefone": "5531986410289",
        "ultInteracao": "Compra",
        "dataInteracao": "10/03/2025"
        },
        {
        "id": "478737657",
        "name": "Cesar Iran Henriques",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cesariranhenriqueslucia@gmail.com",
        "genero": "",
        "dataNasc": "04 Out.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "10/03/2025"
        },
        {
        "id": "95442259",
        "name": "Gustavo Adriano Dias Berbel",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gu_berbel@hotmail.com",
        "genero": "M",
        "dataNasc": "18 Mai.",
        "telefone": "14 988353083",
        "ultInteracao": "Compra",
        "dataInteracao": "07/03/2025"
        },
        {
        "id": "209466847",
        "name": "Alex Martins da Silva",
        "comPromocional": true,
        "numCompras": 2,
        "email": "alex-345@hotmail.com",
        "genero": "M",
        "dataNasc": "15 Jul.",
        "telefone": "3488416821",
        "ultInteracao": "Compra",
        "dataInteracao": "10/03/2025"
        },
        {
        "id": "279629042",
        "name": "Douglas Nunes Botelho da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "douglasbotelho456@gmail.com",
        "genero": "M",
        "dataNasc": "23 Abr.",
        "telefone": "33999671497",
        "ultInteracao": "Compra",
        "dataInteracao": "08/03/2025"
        },
        {
        "id": "1336751802",
        "name": "Oscar Cesar Toscano de Britto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "octbritto@yahoo.com.br",
        "genero": "M",
        "dataNasc": "31 Ago.",
        "telefone": "5524988371564",
        "ultInteracao": "Compra",
        "dataInteracao": "08/03/2025"
        },
        {
        "id": "314574551",
        "name": "Julio Manasses Prado Esperidiao",
        "comPromocional": true,
        "numCompras": 1,
        "email": "julio73315@gmail.com",
        "genero": "M",
        "dataNasc": "03 Out.",
        "telefone": "11999339294",
        "ultInteracao": "Compra",
        "dataInteracao": "08/03/2025"
        },
        {
        "id": "214023838",
        "name": "Jorge Luiz Teixeira de Almeida",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jorgeltda97@gmail.com",
        "genero": "M",
        "dataNasc": "28 Abr.",
        "telefone": " 21-33151183",
        "ultInteracao": "Compra",
        "dataInteracao": "07/03/2025"
        },
        {
        "id": "219848378",
        "name": "Manoel Mendes Dos Santos Neto",
        "comPromocional": false,
        "numCompras": 2,
        "email": "manoelmendesneto@gmail.com",
        "genero": "M",
        "dataNasc": "02 Out.",
        "telefone": " 31992349502",
        "ultInteracao": "Compra",
        "dataInteracao": "07/03/2025"
        },
        {
        "id": "653801628",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "emmanuel.fortunato@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531987346311",
        "ultInteracao": "Compra",
        "dataInteracao": "07/03/2025"
        },
        {
        "id": "154274501",
        "name": "Leandro Luis de Lima",
        "comPromocional": false,
        "numCompras": 2,
        "email": "leandrolimacar@hotmail.com",
        "genero": "M",
        "dataNasc": "15 Mai.",
        "telefone": "11977215651",
        "ultInteracao": "Compra",
        "dataInteracao": "03/03/2025"
        },
        {
        "id": "65282192",
        "name": "Wares Coelho Fernandes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wares.coelho@yahoo.com",
        "genero": "",
        "dataNasc": "11 Nov.",
        "telefone": " 88485353",
        "ultInteracao": "Compra",
        "dataInteracao": "06/03/2025"
        },
        {
        "id": "538008702",
        "name": "Luis Felipe Blanco",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luisfblanco007@gmail.com",
        "genero": "M",
        "dataNasc": "22 Abr.",
        "telefone": "5591982288522",
        "ultInteracao": "Compra",
        "dataInteracao": "06/03/2025"
        },
        {
        "id": "188378114",
        "name": "Gabriel Oliveira Nascimento",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gabrieloliveira311@outlook.com",
        "genero": "M",
        "dataNasc": "02 Mai.",
        "telefone": " 35 91356649",
        "ultInteracao": "Compra",
        "dataInteracao": "06/03/2025"
        },
        {
        "id": "29924375",
        "name": "Lincoln de Almeida",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lincolndealmeida@gmail.com",
        "genero": "M",
        "dataNasc": "15 Fev.",
        "telefone": "4198973469",
        "ultInteracao": "Compra",
        "dataInteracao": "06/03/2025"
        },
        {
        "id": "159810371",
        "name": "Ander Araujo Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "araujo.consorcio@hotmail.com",
        "genero": "M",
        "dataNasc": "02 Mar.",
        "telefone": "02132984001526",
        "ultInteracao": "Compra",
        "dataInteracao": "05/03/2025"
        },
        {
        "id": "169122566",
        "name": "Charles Bruno Bello de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "bruno.6170bello@outlook.com",
        "genero": "M",
        "dataNasc": "29 Abr.",
        "telefone": "31986990622",
        "ultInteracao": "Compra",
        "dataInteracao": "05/03/2025"
        },
        {
        "id": "71336381",
        "name": "Anderson Elsenbach",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ander_gula@hotmail.com",
        "genero": "M",
        "dataNasc": "28 Jan.",
        "telefone": " 4691043167",
        "ultInteracao": "Compra",
        "dataInteracao": "04/03/2025"
        },
        {
        "id": "186740555",
        "name": "Leandro Xavier da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leospfc5@gmail.com",
        "genero": "M",
        "dataNasc": "11 Ago.",
        "telefone": " 31985510276",
        "ultInteracao": "Compra",
        "dataInteracao": "03/03/2025"
        },
        {
        "id": "635341997",
        "name": "Edson Honorio da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "honorioedsondasilva@gmail.com",
        "genero": "M",
        "dataNasc": "28 Dez.",
        "telefone": "5535997305217",
        "ultInteracao": "Compra",
        "dataInteracao": "03/03/2025"
        },
        {
        "id": "221129188",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "roboti@bol.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": " 35-98852-2988",
        "ultInteracao": "Compra",
        "dataInteracao": "03/03/2025"
        },
        {
        "id": "7041087",
        "name": "Marco Antonio Chaves da Silva Filho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcochavesf@hotmail.com",
        "genero": "M",
        "dataNasc": "10 Dez.",
        "telefone": "7132404275",
        "ultInteracao": "Compra",
        "dataInteracao": "02/03/2025"
        },
        {
        "id": "191343181",
        "name": "Gilvan Bulhoes Portugal",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gilvan_refeilances@hotmail.com",
        "genero": "M",
        "dataNasc": "15 Jul.",
        "telefone": "21998321791",
        "ultInteracao": "Compra",
        "dataInteracao": "02/03/2025"
        },
        {
        "id": "220819441",
        "name": "Ariana Grace Mello Gomes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "arianagmg80@gmail.com",
        "genero": "",
        "dataNasc": "18 Mar.",
        "telefone": " 21964438939",
        "ultInteracao": "Compra",
        "dataInteracao": "02/03/2025"
        },
        {
        "id": "165599772",
        "name": "Wagner Elias",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wagnerelias72@hotmail.com",
        "genero": "M",
        "dataNasc": "11 Nov.",
        "telefone": " 31991072973",
        "ultInteracao": "Compra",
        "dataInteracao": "02/03/2025"
        },
        {
        "id": "183693435",
        "name": "Luiz Ricardo Pereira Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luiz.rps2014@hotmail.com",
        "genero": "",
        "dataNasc": "04 Mar.",
        "telefone": " 03188692664",
        "ultInteracao": "Compra",
        "dataInteracao": "02/03/2025"
        },
        {
        "id": "33786756",
        "name": "Wagner Lazarino Ozorio",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wagner.lazarino@hotmail.com",
        "genero": "M",
        "dataNasc": "28 Nov.",
        "telefone": "3131987061694",
        "ultInteracao": "Compra",
        "dataInteracao": "01/03/2025"
        },
        {
        "id": "1173906581",
        "name": "Mario Tavora Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mario@jppharma.com.br",
        "genero": "M",
        "dataNasc": "30 Mai.",
        "telefone": "5521993732377",
        "ultInteracao": "Compra",
        "dataInteracao": "01/03/2025"
        },
        {
        "id": "230047297",
        "name": "Sergio Miranda Rocha",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sergim129@gmail.com",
        "genero": "M",
        "dataNasc": "01 Out.",
        "telefone": "31982248056",
        "ultInteracao": "Compra",
        "dataInteracao": "01/03/2025"
        },
        {
        "id": "140216247",
        "name": "Wellington Rodrigues Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wellisan16@gmail.com",
        "genero": "M",
        "dataNasc": "28 Fev.",
        "telefone": "3131999042241",
        "ultInteracao": "Compra",
        "dataInteracao": "28/02/2025"
        },
        {
        "id": "38933302",
        "name": "Raner Contini",
        "comPromocional": false,
        "numCompras": 1,
        "email": "ranercontini@hotmail.com",
        "genero": "M",
        "dataNasc": "08 Nov.",
        "telefone": "5198557406",
        "ultInteracao": "Compra",
        "dataInteracao": "28/02/2025"
        },
        {
        "id": "176278164",
        "name": "Antonio Marques Ribeiro Filho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marquesribeiro3@gmail.com",
        "genero": "M",
        "dataNasc": "17 Mar.",
        "telefone": "21999896737",
        "ultInteracao": "Compra",
        "dataInteracao": "28/02/2025"
        },
        {
        "id": "82008419",
        "name": "Pedro Alves Xavier de Almeida",
        "comPromocional": false,
        "numCompras": 1,
        "email": "pedro.axda@gmail.com",
        "genero": "M",
        "dataNasc": "15 Dez.",
        "telefone": "31996334701",
        "ultInteracao": "Compra",
        "dataInteracao": "28/02/2025"
        },
        {
        "id": "467463750",
        "name": "Lucas Ribeiro Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lrs08.rj@gmail.com",
        "genero": "M",
        "dataNasc": "17 Jan.",
        "telefone": "5521997265591",
        "ultInteracao": "Compra",
        "dataInteracao": "27/02/2025"
        },
        {
        "id": "209412440",
        "name": "Daysiane Amanda Goulart Moreira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "daysianegoulart@gmail.com",
        "genero": "",
        "dataNasc": "06 Abr.",
        "telefone": "31997004008",
        "ultInteracao": "Compra",
        "dataInteracao": "27/02/2025"
        },
        {
        "id": "2292942659",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "afonsovieira793@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5533998582772",
        "ultInteracao": "Compra",
        "dataInteracao": "27/02/2025"
        },
        {
        "id": "642196996",
        "name": "Luiz Antonio Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "estaicr@terra.com.br",
        "genero": "M",
        "dataNasc": "24 Jul.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "27/02/2025"
        },
        {
        "id": "2294609110",
        "name": "Lucas Dias Silva",
        "comPromocional": false,
        "numCompras": 1,
        "email": "lucasdias444silva@gmail.com",
        "genero": "M",
        "dataNasc": "13 Mai.",
        "telefone": "553398543902",
        "ultInteracao": "Compra",
        "dataInteracao": "26/02/2025"
        },
        {
        "id": "292957191",
        "name": "Adriano Nunes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "adrianonunes1977@gmail.com",
        "genero": "M",
        "dataNasc": "12 Out.",
        "telefone": "5541999873467",
        "ultInteracao": "Compra",
        "dataInteracao": "26/02/2025"
        },
        {
        "id": "88456949",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "peyrani@peyrani.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "31 38786900",
        "ultInteracao": "Compra",
        "dataInteracao": "26/02/2025"
        },
        {
        "id": "57096464",
        "name": "Varlei Eustaquio Pinto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "varleipinto@hotmail.com",
        "genero": "",
        "dataNasc": "31 Out.",
        "telefone": "3134639784",
        "ultInteracao": "Compra",
        "dataInteracao": "25/02/2025"
        },
        {
        "id": "224418558",
        "name": "Aline Teixeira Brandao Bessa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "raphaelbbessa@gmail.com",
        "genero": "",
        "dataNasc": "07 Dez.",
        "telefone": "31998248907",
        "ultInteracao": "Compra",
        "dataInteracao": "25/02/2025"
        },
        {
        "id": "2073966160",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "welingtonb58@icloud.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5524981712429",
        "ultInteracao": "Compra",
        "dataInteracao": "25/02/2025"
        },
        {
        "id": "230670907",
        "name": "Felipe Leandro da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "feliperedes89@gmail.com",
        "genero": "M",
        "dataNasc": "21 Set.",
        "telefone": "31985552610",
        "ultInteracao": "Compra",
        "dataInteracao": "25/02/2025"
        },
        {
        "id": "162696546",
        "name": "Rodrigo Oliveira Borges",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rodrigooliveiraborges@yahoo.com.br",
        "genero": "M",
        "dataNasc": "07 Set.",
        "telefone": "11937743020",
        "ultInteracao": "Compra",
        "dataInteracao": "25/02/2025"
        },
        {
        "id": "267211191",
        "name": "Luana Roberta da Cunha",
        "comPromocional": false,
        "numCompras": 1,
        "email": "luuaninharobertta@gmail.com",
        "genero": "",
        "dataNasc": "16 Mai.",
        "telefone": "31993273028",
        "ultInteracao": "Compra",
        "dataInteracao": "25/02/2025"
        },
        {
        "id": "246722882",
        "name": " ",
        "comPromocional": true,
        "numCompras": 4,
        "email": "pv_amoglia@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": " 32999133728",
        "ultInteracao": "Compra",
        "dataInteracao": "25/02/2025"
        },
        {
        "id": "170360142",
        "name": "Leandro Carlos Lopes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leandrolopescarlos@hotmail.com",
        "genero": "",
        "dataNasc": "28 Ago.",
        "telefone": " 3193607791",
        "ultInteracao": "Compra",
        "dataInteracao": "24/02/2025"
        },
        {
        "id": "132421738",
        "name": "Patricia Maria da Silva Lara",
        "comPromocional": false,
        "numCompras": 1,
        "email": "patriciamarialara@yahoo.com.br",
        "genero": "",
        "dataNasc": "06 Mar.",
        "telefone": " 31-91129810",
        "ultInteracao": "Compra",
        "dataInteracao": "24/02/2025"
        },
        {
        "id": "163291237",
        "name": "Mauro Lucio Silva Araujo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mauro@villefort.com.br",
        "genero": "M",
        "dataNasc": "22 Jan.",
        "telefone": " 31-99475628",
        "ultInteracao": "Compra",
        "dataInteracao": "24/02/2025"
        },
        {
        "id": "2187220536",
        "name": "Marcos Alves Carlos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcoscarlos9090@gmail.com",
        "genero": "M",
        "dataNasc": "01 Set.",
        "telefone": "5531991036236",
        "ultInteracao": "Compra",
        "dataInteracao": "23/02/2025"
        },
        {
        "id": "53489990",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "rlorini@msn.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "49991224645",
        "ultInteracao": "Compra",
        "dataInteracao": "22/02/2025"
        },
        {
        "id": "213453713",
        "name": "Yuri Rocha de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "yuri.rocha@icloud.com",
        "genero": "M",
        "dataNasc": "21 Jan.",
        "telefone": " 11991751858",
        "ultInteracao": "Compra",
        "dataInteracao": "22/02/2025"
        },
        {
        "id": "672602630",
        "name": "Marcos Antonio da Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "maccosta015@gmail.com",
        "genero": "M",
        "dataNasc": "03 Nov.",
        "telefone": "5519995612711",
        "ultInteracao": "Compra",
        "dataInteracao": "21/02/2025"
        },
        {
        "id": "24324287",
        "name": "Luiz Fernando Gaspar Paulo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luiz.gaspar@ig.com.br",
        "genero": "M",
        "dataNasc": "06 Mai.",
        "telefone": "02125766060",
        "ultInteracao": "Compra",
        "dataInteracao": "21/02/2025"
        },
        {
        "id": "52542636",
        "name": "Renato Martins Castanheira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rmcastanheira@hotmail.com",
        "genero": "M",
        "dataNasc": "03 Dez.",
        "telefone": "11976185750",
        "ultInteracao": "Compra",
        "dataInteracao": "21/02/2025"
        },
        {
        "id": "182886250",
        "name": "Lucas Bruno Diniz Ramos",
        "comPromocional": true,
        "numCompras": 2,
        "email": "lucasbrunodiniz@gmail.com",
        "genero": "M",
        "dataNasc": "10 Set.",
        "telefone": " 31 92631207",
        "ultInteracao": "Compra",
        "dataInteracao": "21/02/2025"
        },
        {
        "id": "2283381938",
        "name": " ",
        "comPromocional": true,
        "numCompras": 5,
        "email": "mariaivanaduartemelo@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5575992001514",
        "ultInteracao": "Compra",
        "dataInteracao": "21/02/2025"
        },
        {
        "id": "253825249",
        "name": "Mateus Figueiredo Martins Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mafigueiredocosta@hotmail.com",
        "genero": "M",
        "dataNasc": "12 Jul.",
        "telefone": "31993567569",
        "ultInteracao": "Compra",
        "dataInteracao": "21/02/2025"
        },
        {
        "id": "174479028",
        "name": "Ednelson Donizeti de Almeida",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eda.almeida123@gmail.com",
        "genero": "",
        "dataNasc": "26 Abr.",
        "telefone": "16992180713",
        "ultInteracao": "Compra",
        "dataInteracao": "20/02/2025"
        },
        {
        "id": "2282473576",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mariaivanaduartemelo@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5575992001514",
        "ultInteracao": "Compra",
        "dataInteracao": "20/02/2025"
        },
        {
        "id": "678257329",
        "name": "Pedro Henrique Dos Santos Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pedroauto19@gmail.com",
        "genero": "M",
        "dataNasc": "24 Jun.",
        "telefone": "31987575558",
        "ultInteracao": "Compra",
        "dataInteracao": "20/02/2025"
        },
        {
        "id": "142507778",
        "name": "Roberto Gomes Caetano",
        "comPromocional": true,
        "numCompras": 1,
        "email": "insinerage@gmail.com",
        "genero": "M",
        "dataNasc": "03 Mai.",
        "telefone": "1197112-7068",
        "ultInteracao": "Compra",
        "dataInteracao": "20/02/2025"
        },
        {
        "id": "5032298",
        "name": "Leandro Willton Pena",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leandropena27@yahoo.com.br",
        "genero": "M",
        "dataNasc": "29 Ago.",
        "telefone": "3135677268",
        "ultInteracao": "Compra",
        "dataInteracao": "20/02/2025"
        },
        {
        "id": "298732779",
        "name": "Luiz Claudio Parente",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luizparente@venustur.com.br",
        "genero": "M",
        "dataNasc": "06 Jun.",
        "telefone": "21998057111",
        "ultInteracao": "Compra",
        "dataInteracao": "20/02/2025"
        },
        {
        "id": "400089255",
        "name": "Luiz Claudio de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luizclau46@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Mai.",
        "telefone": "031996057956",
        "ultInteracao": "Compra",
        "dataInteracao": "20/02/2025"
        },
        {
        "id": "64037355",
        "name": "Filipe Ferreira da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "filipecb600@hotmail.com",
        "genero": "M",
        "dataNasc": "05 Nov.",
        "telefone": "03196725748",
        "ultInteracao": "Compra",
        "dataInteracao": "20/02/2025"
        },
        {
        "id": "619750931",
        "name": "Wesley Gois Maciel",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nico.n11@hotmail.com",
        "genero": "M",
        "dataNasc": "09 Mar.",
        "telefone": "41998310812",
        "ultInteracao": "Compra",
        "dataInteracao": "19/02/2025"
        },
        {
        "id": "11649275",
        "name": "Anderson Klei Bastos Lima",
        "comPromocional": true,
        "numCompras": 1,
        "email": "andersonnbastos@hotmail.com",
        "genero": "M",
        "dataNasc": "09 Fev.",
        "telefone": "31991997091",
        "ultInteracao": "Compra",
        "dataInteracao": "19/02/2025"
        },
        {
        "id": "2276123937",
        "name": "Diego Donelli de Oliveira Martins",
        "comPromocional": true,
        "numCompras": 1,
        "email": "diego.donelli@yahoo.com.br",
        "genero": "M",
        "dataNasc": "15 Jun.",
        "telefone": "5531971483468",
        "ultInteracao": "Compra",
        "dataInteracao": "19/02/2025"
        },
        {
        "id": "2255605407",
        "name": "Arlindo Aparecido Fidelis",
        "comPromocional": true,
        "numCompras": 1,
        "email": "arlinfidelis@gmail.com",
        "genero": "M",
        "dataNasc": "21 Nov.",
        "telefone": "5531984745323",
        "ultInteracao": "Compra",
        "dataInteracao": "19/02/2025"
        },
        {
        "id": "455260228",
        "name": "Vagner Roberto Cuaglia",
        "comPromocional": true,
        "numCompras": 1,
        "email": "vagnercuaglia@gmail.com",
        "genero": "M",
        "dataNasc": "26 Nov.",
        "telefone": "11947048836",
        "ultInteracao": "Compra",
        "dataInteracao": "19/02/2025"
        },
        {
        "id": "130279302",
        "name": "Washington Luis da Silva",
        "comPromocional": true,
        "numCompras": 5,
        "email": "washingtonunifenas@gmail.com",
        "genero": "M",
        "dataNasc": "15 Dez.",
        "telefone": " 31-84809268",
        "ultInteracao": "Compra",
        "dataInteracao": "18/02/2025"
        },
        {
        "id": "23211078",
        "name": "Jander Gomes Ribeiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jander.ribeiro@stellantis.com",
        "genero": "M",
        "dataNasc": "04 Ago.",
        "telefone": "3131991334717",
        "ultInteracao": "Compra",
        "dataInteracao": "18/02/2025"
        },
        {
        "id": "2178899511",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ilberalvesmotorista@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531991813430",
        "ultInteracao": "Compra",
        "dataInteracao": "18/02/2025"
        },
        {
        "id": "2275820086",
        "name": "Pedro Jario Batista Lima",
        "comPromocional": true,
        "numCompras": 1,
        "email": "Pedro.jario@yahoo.com.br",
        "genero": "M",
        "dataNasc": "13 Fev.",
        "telefone": "5527999364944",
        "ultInteracao": "Compra",
        "dataInteracao": "17/02/2025"
        },
        {
        "id": "729814207",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "marcio@avancarbeneficios.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "17/02/2025"
        },
        {
        "id": "1092294799",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fabiossouza100@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5511996658825",
        "ultInteracao": "Compra",
        "dataInteracao": "16/02/2025"
        },
        {
        "id": "1096552233",
        "name": "Rodrigo Rodrigues Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "blackart202020@gmail.com",
        "genero": "M",
        "dataNasc": "17 Mar.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "16/02/2025"
        },
        {
        "id": "31509890",
        "name": "Fernando Gandra Monteiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fernando.gandra@outlook.com.br",
        "genero": "M",
        "dataNasc": "15 Abr.",
        "telefone": "11964714600",
        "ultInteracao": "Compra",
        "dataInteracao": "16/02/2025"
        },
        {
        "id": "23948390",
        "name": "Tony Ezequiel Lucas Moreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tonyezequiel@yahoo.com.br",
        "genero": "M",
        "dataNasc": "07 Jan.",
        "telefone": "31377331989538419",
        "ultInteracao": "Compra",
        "dataInteracao": "16/02/2025"
        },
        {
        "id": "163201066",
        "name": "Ana Claudia Silva Oliveira",
        "comPromocional": true,
        "numCompras": 2,
        "email": "acsilvaoliveira@hotmail.com",
        "genero": "",
        "dataNasc": "26 Out.",
        "telefone": " 35991697184",
        "ultInteracao": "Compra",
        "dataInteracao": "15/02/2025"
        },
        {
        "id": "128154087",
        "name": "Diony de Sena Souza Pereira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "dioneymizere@hotmail.com",
        "genero": "M",
        "dataNasc": "05 Jan.",
        "telefone": " 7581429614",
        "ultInteracao": "Compra",
        "dataInteracao": "15/02/2025"
        },
        {
        "id": "127769482",
        "name": "Carolina Andrade Dos Santos Canuto",
        "comPromocional": true,
        "numCompras": 2,
        "email": "carolcanuto13@hotmail.com",
        "genero": "",
        "dataNasc": "13 Set.",
        "telefone": " 3835316292",
        "ultInteracao": "Compra",
        "dataInteracao": "15/02/2025"
        },
        {
        "id": "132581424",
        "name": "Reginaldo Aparecido Mesquita",
        "comPromocional": true,
        "numCompras": 1,
        "email": "oimesquita@gmail.com",
        "genero": "M",
        "dataNasc": "07 Nov.",
        "telefone": "31988152931",
        "ultInteracao": "Compra",
        "dataInteracao": "15/02/2025"
        },
        {
        "id": "206399346",
        "name": "Wagner Junior Dos Reis",
        "comPromocional": true,
        "numCompras": 2,
        "email": "wagner.real03@hotmail.com",
        "genero": "M",
        "dataNasc": "30 Abr.",
        "telefone": " 31987423431",
        "ultInteracao": "Compra",
        "dataInteracao": "15/02/2025"
        },
        {
        "id": "109963748",
        "name": "Jocivaldo Sousa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jocivaldo_mo@hotmail.com",
        "genero": "M",
        "dataNasc": "28 Mar.",
        "telefone": "73988438851",
        "ultInteracao": "Compra",
        "dataInteracao": "14/02/2025"
        },
        {
        "id": "1084899102",
        "name": "William de Miranda Ataide",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ataidemirandawilliam@gmail.com",
        "genero": "M",
        "dataNasc": "22 Ago.",
        "telefone": "5531981079571",
        "ultInteracao": "Compra",
        "dataInteracao": "14/02/2025"
        },
        {
        "id": "138799638",
        "name": "Everson da Silva Faria",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eversonfaria@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Fev.",
        "telefone": " 0313186672997",
        "ultInteracao": "Compra",
        "dataInteracao": "13/02/2025"
        },
        {
        "id": "3932887",
        "name": "Kaitto Leite",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leite_kaitto@hotmail.com",
        "genero": "M",
        "dataNasc": "10 Mar.",
        "telefone": "3233717483",
        "ultInteracao": "Compra",
        "dataInteracao": "13/02/2025"
        },
        {
        "id": "229857502",
        "name": "Sueli Pereira da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "maduregicar@gmail.com",
        "genero": "",
        "dataNasc": "11 Mai.",
        "telefone": " 11975814776",
        "ultInteracao": "Compra",
        "dataInteracao": "13/02/2025"
        },
        {
        "id": "467882451",
        "name": "Luan Junio de Assis Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luanjunio13x2@gmail.com",
        "genero": "M",
        "dataNasc": "13 Ago.",
        "telefone": "5531988846523",
        "ultInteracao": "Compra",
        "dataInteracao": "13/02/2025"
        },
        {
        "id": "31677222",
        "name": "Audrey Cristiane Macedo Rocha",
        "comPromocional": true,
        "numCompras": 2,
        "email": "audreycristiane@gmail.com",
        "genero": "",
        "dataNasc": "03 Abr.",
        "telefone": "03198821-2421",
        "ultInteracao": "Compra",
        "dataInteracao": "13/02/2025"
        },
        {
        "id": "78569332",
        "name": "Gabriel Custodio",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gabriel.custodio@gmail.com",
        "genero": "M",
        "dataNasc": "12 Jan.",
        "telefone": "13981238392",
        "ultInteracao": "Compra",
        "dataInteracao": "13/02/2025"
        },
        {
        "id": "1027761433",
        "name": "Davi Jorge Alves Benfica",
        "comPromocional": true,
        "numCompras": 1,
        "email": "davijorge249@gmail.com",
        "genero": "M",
        "dataNasc": "09 Jun.",
        "telefone": "5533984601688",
        "ultInteracao": "Compra",
        "dataInteracao": "13/02/2025"
        },
        {
        "id": "20961206",
        "name": "Renato de Figueiredo Cisne",
        "comPromocional": true,
        "numCompras": 1,
        "email": "refcisne@hotmail.com",
        "genero": "M",
        "dataNasc": "31 Mai.",
        "telefone": "21999712726",
        "ultInteracao": "Compra",
        "dataInteracao": "13/02/2025"
        },
        {
        "id": "85527634",
        "name": "Renato Ramos Godoi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "renatoramosgodoi@gmail.com",
        "genero": "M",
        "dataNasc": "25 Set.",
        "telefone": "3732121712",
        "ultInteracao": "Compra",
        "dataInteracao": "12/02/2025"
        },
        {
        "id": "178111395",
        "name": "Ronaldo Mendes de Oliveira Sobrinho",
        "comPromocional": false,
        "numCompras": 2,
        "email": "ronaldoerey@hotmail.com",
        "genero": "M",
        "dataNasc": "18 Jul.",
        "telefone": " 03197872060",
        "ultInteracao": "Compra",
        "dataInteracao": "12/02/2025"
        },
        {
        "id": "269747141",
        "name": "Marcus Eduardo de Souza Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcusvip@hotmail.com",
        "genero": "M",
        "dataNasc": "13 Out.",
        "telefone": "3333314311",
        "ultInteracao": "Compra",
        "dataInteracao": "12/02/2025"
        },
        {
        "id": "62356320",
        "name": "Joao Batista Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "joaoi13@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Out.",
        "telefone": "3432163821",
        "ultInteracao": "Compra",
        "dataInteracao": "12/02/2025"
        },
        {
        "id": "1715620496",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "winstonriomotos@outlook.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5553991461699",
        "ultInteracao": "Compra",
        "dataInteracao": "12/02/2025"
        },
        {
        "id": "36821900",
        "name": "Wallace Willians Dornelas Ribeiro",
        "comPromocional": false,
        "numCompras": 1,
        "email": "wallacedornelas@gmail.com",
        "genero": "M",
        "dataNasc": "14 Nov.",
        "telefone": "3198688-7109",
        "ultInteracao": "Compra",
        "dataInteracao": "12/02/2025"
        },
        {
        "id": "2266229034",
        "name": "Willian Cristiano Lopes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wilian.lopes@ymail.com",
        "genero": "M",
        "dataNasc": "21 Dez.",
        "telefone": "5511971217081",
        "ultInteracao": "Compra",
        "dataInteracao": "12/02/2025"
        },
        {
        "id": "1135586747",
        "name": "Pedro Lucas Carvalho de Azevedo",
        "comPromocional": false,
        "numCompras": 1,
        "email": "pedrolucascarvaho@gmail.com",
        "genero": "M",
        "dataNasc": "22 Abr.",
        "telefone": "5521985892970",
        "ultInteracao": "Compra",
        "dataInteracao": "12/02/2025"
        },
        {
        "id": "230508519",
        "name": "Luiz Felipe Fernandes Marinho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luizfelipe.fernandesmarinho@hotmail.com",
        "genero": "M",
        "dataNasc": "04 Dez.",
        "telefone": " 22 9 99723229",
        "ultInteracao": "Compra",
        "dataInteracao": "11/02/2025"
        },
        {
        "id": "195102166",
        "name": "Edgard Souza E Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "edgardsouzaesilva@gmail.com",
        "genero": "M",
        "dataNasc": "20 Mai.",
        "telefone": "5531996173553",
        "ultInteracao": "Compra",
        "dataInteracao": "11/02/2025"
        },
        {
        "id": "1123760954",
        "name": "Alysson Brandao Costa",
        "comPromocional": true,
        "numCompras": 2,
        "email": "alyssonbc77@gmail.com",
        "genero": "",
        "dataNasc": "04 Ago.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "11/02/2025"
        },
        {
        "id": "609078285",
        "name": "Ricardo Abreu de Jesus",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rajbhmg@gmail.com",
        "genero": "M",
        "dataNasc": "10 Out.",
        "telefone": "5521983178739",
        "ultInteracao": "Compra",
        "dataInteracao": "11/02/2025"
        },
        {
        "id": "5177712",
        "name": "Pedro Stefano Souto Silva",
        "comPromocional": false,
        "numCompras": 1,
        "email": "pedrostefanogv@gmail.com",
        "genero": "M",
        "dataNasc": "29 Jun.",
        "telefone": "33988024188",
        "ultInteracao": "Compra",
        "dataInteracao": "11/02/2025"
        },
        {
        "id": "2260922881",
        "name": "Cleber Silva Cunha",
        "comPromocional": true,
        "numCompras": 1,
        "email": "diretoria@transguto.com.br",
        "genero": "M",
        "dataNasc": "03 Set.",
        "telefone": "5521998013500",
        "ultInteracao": "Compra",
        "dataInteracao": "11/02/2025"
        },
        {
        "id": "208101851",
        "name": "Willian Teles de Sousa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "williantelless@gmail.com",
        "genero": "M",
        "dataNasc": "12 Jun.",
        "telefone": " 89 981036812",
        "ultInteracao": "Compra",
        "dataInteracao": "11/02/2025"
        },
        {
        "id": "240820322",
        "name": "Renato de Freitas Mangussi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "renatomangussi@gmail.com",
        "genero": "M",
        "dataNasc": "08 Mar.",
        "telefone": "5531995650914",
        "ultInteracao": "Compra",
        "dataInteracao": "11/02/2025"
        },
        {
        "id": "14012146",
        "name": "Walter Henrique Klemz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wklemz@gmail.com",
        "genero": "M",
        "dataNasc": "01 Ago.",
        "telefone": " 47 84028709",
        "ultInteracao": "Compra",
        "dataInteracao": "10/02/2025"
        },
        {
        "id": "1366451648",
        "name": "Matheus Martins Quintal",
        "comPromocional": true,
        "numCompras": 1,
        "email": "matheus.quintal04@icloud.com",
        "genero": "M",
        "dataNasc": "04 Out.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "10/02/2025"
        },
        {
        "id": "83078406",
        "name": "Diogo Malta Leal",
        "comPromocional": true,
        "numCompras": 1,
        "email": "diomalta@hotmail.com",
        "genero": "M",
        "dataNasc": "25 Jan.",
        "telefone": "03432621609",
        "ultInteracao": "Compra",
        "dataInteracao": "10/02/2025"
        },
        {
        "id": "15006250",
        "name": "Daniel Venancio de Sousa",
        "comPromocional": false,
        "numCompras": 1,
        "email": "venanciodan@gmail.com",
        "genero": "M",
        "dataNasc": "15 Out.",
        "telefone": "21965137518",
        "ultInteracao": "Compra",
        "dataInteracao": "10/02/2025"
        },
        {
        "id": "327811599",
        "name": "Bernardo Correia Lima",
        "comPromocional": true,
        "numCompras": 2,
        "email": "drbernardoclima@gmail.com",
        "genero": "M",
        "dataNasc": "24 Mai.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "10/02/2025"
        },
        {
        "id": "190569560",
        "name": "Alexsander Abraao Fernandes da Silva Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alexsilvasantos.bh@gmail.com",
        "genero": "M",
        "dataNasc": "05 Jul.",
        "telefone": "31984383083",
        "ultInteracao": "Compra",
        "dataInteracao": "10/02/2025"
        },
        {
        "id": "538870667",
        "name": "Marcelo Benedito Goncalves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcelo.bndt@gmail.com",
        "genero": "M",
        "dataNasc": "11 Jan.",
        "telefone": "5531987446541",
        "ultInteracao": "Compra",
        "dataInteracao": "10/02/2025"
        },
        {
        "id": "1636401783",
        "name": "Valdinei de Souza Dias",
        "comPromocional": true,
        "numCompras": 1,
        "email": "valdidias1972@gmail.com",
        "genero": "M",
        "dataNasc": "14 Nov.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "10/02/2025"
        },
        {
        "id": "2258715877",
        "name": "Marcos Fernandes de Souza",
        "comPromocional": true,
        "numCompras": 3,
        "email": "marcosgrupogg@gmail.com",
        "genero": "M",
        "dataNasc": "20 Nov.",
        "telefone": "5538991239046",
        "ultInteracao": "Compra",
        "dataInteracao": "10/02/2025"
        },
        {
        "id": "534726926",
        "name": "Daniel de Oliveira Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "silvadaniel200@yahoo.com",
        "genero": "",
        "dataNasc": "23 Fev.",
        "telefone": "5531984442803",
        "ultInteracao": "Compra",
        "dataInteracao": "10/02/2025"
        },
        {
        "id": "156034761",
        "name": "Vanessa Resende Chaves Rocha",
        "comPromocional": true,
        "numCompras": 1,
        "email": "w.vanessa06@hotmail.com",
        "genero": "",
        "dataNasc": "06 Dez.",
        "telefone": " 83842383",
        "ultInteracao": "Compra",
        "dataInteracao": "08/02/2025"
        },
        {
        "id": "141146677",
        "name": "Everton Augusto de Souza Melo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "atomose@hotmail.com",
        "genero": "M",
        "dataNasc": "10 Set.",
        "telefone": " 31988126705",
        "ultInteracao": "Compra",
        "dataInteracao": "08/02/2025"
        },
        {
        "id": "198106779",
        "name": "Filipe Alfenas Nantes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "filipealfenas3@gmail.com",
        "genero": "M",
        "dataNasc": "23 Dez.",
        "telefone": " 31996896610",
        "ultInteracao": "Compra",
        "dataInteracao": "08/02/2025"
        },
        {
        "id": "113701393",
        "name": "Jocemar Heinig",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jocemarheinig@hotmail.com",
        "genero": "M",
        "dataNasc": "24 Mar.",
        "telefone": "46999807023",
        "ultInteracao": "Compra",
        "dataInteracao": "08/02/2025"
        },
        {
        "id": "150376245",
        "name": "Elias Batista Meireles",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eliasgpx@gmail.com",
        "genero": "M",
        "dataNasc": "08 Dez.",
        "telefone": " 03184418942",
        "ultInteracao": "Compra",
        "dataInteracao": "08/02/2025"
        },
        {
        "id": "5896569",
        "name": "Oberdan Marinato Badaro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "oberdanmb@yahoo.com.br",
        "genero": "M",
        "dataNasc": "23 Mai.",
        "telefone": "03234491999",
        "ultInteracao": "Compra",
        "dataInteracao": "07/02/2025"
        },
        {
        "id": "163355706",
        "name": "Munir Coelho Zaghlul",
        "comPromocional": true,
        "numCompras": 2,
        "email": "munircz@gmail.com",
        "genero": "M",
        "dataNasc": "23 Abr.",
        "telefone": " 99885007",
        "ultInteracao": "Compra",
        "dataInteracao": "07/02/2025"
        },
        {
        "id": "269635868",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "felipe.santiago23@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "07/02/2025"
        },
        {
        "id": "10382026",
        "name": "Adriano de Melo Reis",
        "comPromocional": true,
        "numCompras": 3,
        "email": "ademeloreis@gmail.com",
        "genero": "M",
        "dataNasc": "19 Jun.",
        "telefone": "03132258361",
        "ultInteracao": "Compra",
        "dataInteracao": "07/02/2025"
        },
        {
        "id": "142080121",
        "name": "Edmilson Lima Braganca",
        "comPromocional": true,
        "numCompras": 2,
        "email": "edmilson.braganca@gmail.com",
        "genero": "M",
        "dataNasc": "07 Mai.",
        "telefone": "31989191585",
        "ultInteracao": "Compra",
        "dataInteracao": "07/02/2025"
        },
        {
        "id": "176306058",
        "name": "Alex da Silva Lourenco",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alexsilvalourenco@yahoo.com.br",
        "genero": "",
        "dataNasc": "23 Ago.",
        "telefone": " 03199661619",
        "ultInteracao": "Compra",
        "dataInteracao": "06/02/2025"
        },
        {
        "id": "165526696",
        "name": "Marcelo Alex Sandro da Silva Almeida",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marceloalex_almeida@yahoo.com.br",
        "genero": "M",
        "dataNasc": "07 Ago.",
        "telefone": " 18997541413",
        "ultInteracao": "Compra",
        "dataInteracao": "06/02/2025"
        },
        {
        "id": "241585121",
        "name": "Luiz Gustavo Sanches Gil Ribeiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luizgustavo.sanches.37@gmail.com",
        "genero": "M",
        "dataNasc": "20 Fev.",
        "telefone": "5522997887856",
        "ultInteracao": "Compra",
        "dataInteracao": "05/02/2025"
        },
        {
        "id": "2253021938",
        "name": "Carlos Fernando Teodosio Soares",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carlosfts@gmail.com",
        "genero": "M",
        "dataNasc": "09 Fev.",
        "telefone": "5521976254775",
        "ultInteracao": "Compra",
        "dataInteracao": "05/02/2025"
        },
        {
        "id": "2249556183",
        "name": "Bernardo Salviano da Fonseca Rezende",
        "comPromocional": false,
        "numCompras": 1,
        "email": "bernardosfrezende@hotmail.com",
        "genero": "M",
        "dataNasc": "22 Set.",
        "telefone": "5531983992896",
        "ultInteracao": "Compra",
        "dataInteracao": "05/02/2025"
        },
        {
        "id": "626043521",
        "name": "Paulo Duarte Neves",
        "comPromocional": true,
        "numCompras": 2,
        "email": "rev.pdn@yahoo.com",
        "genero": "M",
        "dataNasc": "16 Dez.",
        "telefone": "5522998175791",
        "ultInteracao": "Compra",
        "dataInteracao": "05/02/2025"
        },
        {
        "id": "126517614",
        "name": "Guilherme Jonathan Rodrigues da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "guilhermejonathan@hotmail.com",
        "genero": "M",
        "dataNasc": "30 Set.",
        "telefone": "61981914325",
        "ultInteracao": "Compra",
        "dataInteracao": "05/02/2025"
        },
        {
        "id": "554944133",
        "name": "Ederson Pinheiro da Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ederson27costa@gmail.com",
        "genero": "M",
        "dataNasc": "20 Mar.",
        "telefone": "5591988413367",
        "ultInteracao": "Compra",
        "dataInteracao": "04/02/2025"
        },
        {
        "id": "111759517",
        "name": "Jose Carneiro de Araujo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jose.2c.araujo@gmail.com",
        "genero": "M",
        "dataNasc": "10 Dez.",
        "telefone": "21993533208",
        "ultInteracao": "Compra",
        "dataInteracao": "03/02/2025"
        },
        {
        "id": "239903858",
        "name": "Flavio Henrique Silva Dos Santos",
        "comPromocional": false,
        "numCompras": 1,
        "email": "flaviohenrique034@gmail.com",
        "genero": "M",
        "dataNasc": "16 Out.",
        "telefone": " 3492419203",
        "ultInteracao": "Compra",
        "dataInteracao": "03/02/2025"
        },
        {
        "id": "289298694",
        "name": "Micael Santos Azarias",
        "comPromocional": true,
        "numCompras": 1,
        "email": "azazmica10@gmail.com",
        "genero": "M",
        "dataNasc": "02 Jul.",
        "telefone": "5511986923140",
        "ultInteracao": "Compra",
        "dataInteracao": "03/02/2025"
        },
        {
        "id": "600291007",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rodolfosiqueiras@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "03/02/2025"
        },
        {
        "id": "219479703",
        "name": "Marcos Antonio Ribeiro",
        "comPromocional": true,
        "numCompras": 4,
        "email": "marcos.ar.ribeiro@gmail.com",
        "genero": "M",
        "dataNasc": "25 Set.",
        "telefone": "35997478794",
        "ultInteracao": "Compra",
        "dataInteracao": "02/02/2025"
        },
        {
        "id": "172978069",
        "name": "Lazaro Antonio Pires Braga",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lazaronetym123@gmail.com",
        "genero": "M",
        "dataNasc": "21 Set.",
        "telefone": "31990208734",
        "ultInteracao": "Compra",
        "dataInteracao": "02/02/2025"
        },
        {
        "id": "75468445",
        "name": "Jessica de Souza Martins",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jessicamartins86@hotmail.com",
        "genero": "",
        "dataNasc": "22 Nov.",
        "telefone": "43999767835",
        "ultInteracao": "Compra",
        "dataInteracao": "01/02/2025"
        },
        {
        "id": "177691545",
        "name": "Ernesta Cristina Nazelli Souto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ernestasouto@yahoo.com.br",
        "genero": "",
        "dataNasc": "27 Abr.",
        "telefone": " 3191519022",
        "ultInteracao": "Compra",
        "dataInteracao": "01/02/2025"
        },
        {
        "id": "76550133",
        "name": "Aline Afonso de Sousa Lima",
        "comPromocional": true,
        "numCompras": 2,
        "email": "allinnyafonso@outlook.com",
        "genero": "",
        "dataNasc": "03 Mai.",
        "telefone": "37998369778",
        "ultInteracao": "Compra",
        "dataInteracao": "01/02/2025"
        },
        {
        "id": "139904237",
        "name": "Paulo Roberto Santos Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "paulocosta.aguiaservice@gmail.com",
        "genero": "M",
        "dataNasc": "02 Fev.",
        "telefone": " 73-30131619",
        "ultInteracao": "Compra",
        "dataInteracao": "31/01/2025"
        },
        {
        "id": "2243986498",
        "name": "Paulo Victor Barreiros Amoglia",
        "comPromocional": true,
        "numCompras": 5,
        "email": "pv_amoglia@hotmail.com",
        "genero": "M",
        "dataNasc": "04 Mai.",
        "telefone": "5532999133728",
        "ultInteracao": "Compra",
        "dataInteracao": "31/01/2025"
        },
        {
        "id": "137921736",
        "name": "Marcos Amancio Pinto Martins",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcosapmartins@gmail.com",
        "genero": "M",
        "dataNasc": "15 Ago.",
        "telefone": " 2188689959",
        "ultInteracao": "Compra",
        "dataInteracao": "31/01/2025"
        },
        {
        "id": "242996492",
        "name": "Agnaldo Ferreira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "professoraedivania75@hotmail.com",
        "genero": "M",
        "dataNasc": "11 Mai.",
        "telefone": "79988231813",
        "ultInteracao": "Compra",
        "dataInteracao": "28/01/2025"
        },
        {
        "id": "53095024",
        "name": "Breno Henrique Ferreira",
        "comPromocional": true,
        "numCompras": 2,
        "email": "breno-_-2006@hotmail.com",
        "genero": "M",
        "dataNasc": "07 Out.",
        "telefone": "03436627382",
        "ultInteracao": "Compra",
        "dataInteracao": "31/01/2025"
        },
        {
        "id": "2239514217",
        "name": "Renato Rodrigues Ribeiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "renato0204@hotmail.com",
        "genero": "M",
        "dataNasc": "02 Abr.",
        "telefone": "5531993886946",
        "ultInteracao": "Compra",
        "dataInteracao": "30/01/2025"
        },
        {
        "id": "130337782",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "propostawebbl@sorana.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "21415811",
        "ultInteracao": "Compra",
        "dataInteracao": "30/01/2025"
        },
        {
        "id": "78591368",
        "name": "Marcelo Jose Lustosa Amorim",
        "comPromocional": false,
        "numCompras": 1,
        "email": "marceloamorim21@hotmail.com",
        "genero": "M",
        "dataNasc": "21 Set.",
        "telefone": "021979684464",
        "ultInteracao": "Compra",
        "dataInteracao": "30/01/2025"
        },
        {
        "id": "104375967",
        "name": "Dario Monte",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dmalegre@gmail.com",
        "genero": "M",
        "dataNasc": "26 Fev.",
        "telefone": " 21983954679",
        "ultInteracao": "Compra",
        "dataInteracao": "29/01/2025"
        },
        {
        "id": "349509004",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pecasgerencia@mercantilatibaia.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "1144141406",
        "ultInteracao": "Compra",
        "dataInteracao": "29/01/2025"
        },
        {
        "id": "151217686",
        "name": "Marcelo Braulio Pedras",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcelo.braulio.si@gmail.com",
        "genero": "M",
        "dataNasc": "23 Abr.",
        "telefone": " (38) 98088008",
        "ultInteracao": "Compra",
        "dataInteracao": "29/01/2025"
        },
        {
        "id": "135112846",
        "name": "Daniele Fatima Santos Teixeira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "danyellefsantos@yahoo.com.br",
        "genero": "",
        "dataNasc": "14 Mai.",
        "telefone": " 88047043",
        "ultInteracao": "Compra",
        "dataInteracao": "29/01/2025"
        },
        {
        "id": "57178448",
        "name": "Sillas Ramos de Santana",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sillas.santana@hotmail.com",
        "genero": "M",
        "dataNasc": "25 Mar.",
        "telefone": " 7388465545",
        "ultInteracao": "Compra",
        "dataInteracao": "28/01/2025"
        },
        {
        "id": "271939278",
        "name": "Raphael Saidel da Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "aspr_saidel@hotmail.com",
        "genero": "M",
        "dataNasc": "21 Ago.",
        "telefone": "5521981694083",
        "ultInteracao": "Compra",
        "dataInteracao": "28/01/2025"
        },
        {
        "id": "1445292033",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "compras@cdaengenharia.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5547999363836",
        "ultInteracao": "Compra",
        "dataInteracao": "27/01/2025"
        },
        {
        "id": "53042196",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "renatinhomotores@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "1934512849",
        "ultInteracao": "Compra",
        "dataInteracao": "27/01/2025"
        },
        {
        "id": "309433136",
        "name": "Rayssa Coelho Albuquerque Loth",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rayssinhacoelho@hotmail.com",
        "genero": "",
        "dataNasc": "09 Ago.",
        "telefone": "5532999981769",
        "ultInteracao": "Compra",
        "dataInteracao": "27/01/2025"
        },
        {
        "id": "397842413",
        "name": "Daniel Castellan Tusillo",
        "comPromocional": false,
        "numCompras": 1,
        "email": "daniel.tusillo@gmail.com",
        "genero": "M",
        "dataNasc": "30 Mar.",
        "telefone": "16992285545",
        "ultInteracao": "Compra",
        "dataInteracao": "27/01/2025"
        },
        {
        "id": "222655293",
        "name": "Ernane Nonato da Costa",
        "comPromocional": false,
        "numCompras": 3,
        "email": "ernane.engenharia@hotmail.com",
        "genero": "",
        "dataNasc": "06 Mar.",
        "telefone": " 31996828393",
        "ultInteracao": "Compra",
        "dataInteracao": "27/01/2025"
        },
        {
        "id": "334691629",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "gilmaroliveira182009@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "27/01/2025"
        },
        {
        "id": "445886823",
        "name": "Aloisio Salgado Braga",
        "comPromocional": true,
        "numCompras": 1,
        "email": "asbraga63@gmail.com",
        "genero": "M",
        "dataNasc": "27 Dez.",
        "telefone": "5531984599919",
        "ultInteracao": "Compra",
        "dataInteracao": "27/01/2025"
        },
        {
        "id": "529084758",
        "name": "Luciano Dos Reis Alves da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lucianodosreisalves@gmail.com",
        "genero": "M",
        "dataNasc": "12 Ago.",
        "telefone": "49999238291",
        "ultInteracao": "Compra",
        "dataInteracao": "27/01/2025"
        },
        {
        "id": "1090803865",
        "name": "Leonardo Antonio Nogueira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leonogueira0313@outlook.com",
        "genero": "M",
        "dataNasc": "06 Jun.",
        "telefone": "5531999577198",
        "ultInteracao": "Compra",
        "dataInteracao": "26/01/2025"
        },
        {
        "id": "1558228589",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "guilherme1tavares@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531996057778",
        "ultInteracao": "Compra",
        "dataInteracao": "26/01/2025"
        },
        {
        "id": "51057015",
        "name": "Jose Claudio de Moraes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jcllaudioseguros@yahoo.com.br",
        "genero": "M",
        "dataNasc": "03 Fev.",
        "telefone": "03191151779",
        "ultInteracao": "Compra",
        "dataInteracao": "26/01/2025"
        },
        {
        "id": "160792167",
        "name": "Nalon de Souza E Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nalonsilva17@gmail.com",
        "genero": "",
        "dataNasc": "17 Mai.",
        "telefone": " 21997626284",
        "ultInteracao": "Compra",
        "dataInteracao": "25/01/2025"
        },
        {
        "id": "401985692",
        "name": "Hamilton Montagnini",
        "comPromocional": true,
        "numCompras": 1,
        "email": "hamilton.montagnini@gmail.com",
        "genero": "M",
        "dataNasc": "27 Jun.",
        "telefone": "5535991168249",
        "ultInteracao": "Compra",
        "dataInteracao": "25/01/2025"
        },
        {
        "id": "8221081",
        "name": "Claudia Cristina Sousa Castro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cpcastrome@hotmail.com",
        "genero": "",
        "dataNasc": "13 Out.",
        "telefone": "03837544142",
        "ultInteracao": "Compra",
        "dataInteracao": "24/01/2025"
        },
        {
        "id": "357079855",
        "name": "Shirley Lima Paluma",
        "comPromocional": true,
        "numCompras": 1,
        "email": "shirleypaluma@gmail.com",
        "genero": "",
        "dataNasc": "04 Fev.",
        "telefone": "5524998217797",
        "ultInteracao": "Compra",
        "dataInteracao": "24/01/2025"
        },
        {
        "id": "82935858",
        "name": "Geraldo Lucio Noronha Portilho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "geraldo.portilho@vallourec.com",
        "genero": "M",
        "dataNasc": "16 Out.",
        "telefone": "3199968-0950",
        "ultInteracao": "Compra",
        "dataInteracao": "24/01/2025"
        },
        {
        "id": "99993644",
        "name": "Rosana Aparecida da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rosanajhc@gmail.com",
        "genero": "",
        "dataNasc": "26 Ago.",
        "telefone": "1167223599",
        "ultInteracao": "Compra",
        "dataInteracao": "23/01/2025"
        },
        {
        "id": "63003868",
        "name": "Rafael Lima Santos",
        "comPromocional": true,
        "numCompras": 7,
        "email": "rafaelmedufba@gmail.com",
        "genero": "M",
        "dataNasc": "24 Out.",
        "telefone": "7133587778",
        "ultInteracao": "Compra",
        "dataInteracao": "23/01/2025"
        },
        {
        "id": "97940509",
        "name": "Guilherme Girardi Tolentino",
        "comPromocional": true,
        "numCompras": 1,
        "email": "guilhermegirarde@hotmail.com",
        "genero": "M",
        "dataNasc": "19 Mar.",
        "telefone": "03235326163",
        "ultInteracao": "Compra",
        "dataInteracao": "23/01/2025"
        },
        {
        "id": "78382286",
        "name": "Mauricio Ramos Fiochi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "maufioxi@hotmail.com",
        "genero": "M",
        "dataNasc": "05 Mar.",
        "telefone": "21996896412",
        "ultInteracao": "Compra",
        "dataInteracao": "23/01/2025"
        },
        {
        "id": "46641381",
        "name": "Luiz Carlos Franca de Melo",
        "comPromocional": false,
        "numCompras": 1,
        "email": "luizmelopb@hotmail.com",
        "genero": "M",
        "dataNasc": "29 Jun.",
        "telefone": "82988747854",
        "ultInteracao": "Compra",
        "dataInteracao": "22/01/2025"
        },
        {
        "id": "240341625",
        "name": "Adirce Nascimento Martins",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nascimentoadirce@gmail.com",
        "genero": "",
        "dataNasc": "25 Dez.",
        "telefone": " 31997885635",
        "ultInteracao": "Compra",
        "dataInteracao": "22/01/2025"
        },
        {
        "id": "131665738",
        "name": "Maurilio Felix",
        "comPromocional": true,
        "numCompras": 1,
        "email": "felixmarinha@gmail.com",
        "genero": "",
        "dataNasc": "11 Fev.",
        "telefone": "2137080500",
        "ultInteracao": "Compra",
        "dataInteracao": "22/01/2025"
        },
        {
        "id": "470956776",
        "name": "Maralane Ribeiro Maia",
        "comPromocional": true,
        "numCompras": 2,
        "email": "donabentarestaurante@hotmail.com",
        "genero": "",
        "dataNasc": "18 Jan.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "22/01/2025"
        },
        {
        "id": "308123073",
        "name": "Roberto Vilnei Posselt Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "vilnei71@gmail.com",
        "genero": "M",
        "dataNasc": "02 Mar.",
        "telefone": "63984344073",
        "ultInteracao": "Compra",
        "dataInteracao": "22/01/2025"
        },
        {
        "id": "163314834",
        "name": "Everton de Souza Semzack",
        "comPromocional": true,
        "numCompras": 1,
        "email": "evertonsemzack@gmail.com",
        "genero": "M",
        "dataNasc": "15 Ago.",
        "telefone": "67999156682",
        "ultInteracao": "Compra",
        "dataInteracao": "22/01/2025"
        },
        {
        "id": "2225253021",
        "name": "Mario Andreani de Almeida",
        "comPromocional": true,
        "numCompras": 1,
        "email": "andreanimario@hotmail.com",
        "genero": "M",
        "dataNasc": "29 Mai.",
        "telefone": "5535988484004",
        "ultInteracao": "Compra",
        "dataInteracao": "22/01/2025"
        },
        {
        "id": "39690913",
        "name": "Rogerio Fernandino Tinoco Silva",
        "comPromocional": true,
        "numCompras": 2,
        "email": "rogerioftinoco@gmail.com",
        "genero": "M",
        "dataNasc": "03 Abr.",
        "telefone": "31985431142",
        "ultInteracao": "Compra",
        "dataInteracao": "21/01/2025"
        },
        {
        "id": "2223895221",
        "name": "Helio Gargalaki Lopes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "heliolopes1234@gmail.com",
        "genero": "M",
        "dataNasc": "25 Set.",
        "telefone": "5511996437334",
        "ultInteracao": "Compra",
        "dataInteracao": "21/01/2025"
        },
        {
        "id": "98976432",
        "name": "Victor Gustavo Santos Vieira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "victor.gusttavo@hotmail.com",
        "genero": "M",
        "dataNasc": "17 Jun.",
        "telefone": "3138425506",
        "ultInteracao": "Compra",
        "dataInteracao": "21/01/2025"
        },
        {
        "id": "297951012",
        "name": "Luciane Buozi Martins Correia",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thiago.mcorreia123@gmail.com",
        "genero": "",
        "dataNasc": "25 Fev.",
        "telefone": "5511996597420",
        "ultInteracao": "Compra",
        "dataInteracao": "21/01/2025"
        },
        {
        "id": "182472728",
        "name": "Jose Mario Betochi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "josemario@jmbetochi.com",
        "genero": "M",
        "dataNasc": "03 Dez.",
        "telefone": "17 35641632",
        "ultInteracao": "Compra",
        "dataInteracao": "21/01/2025"
        },
        {
        "id": "80591955",
        "name": "Vagnaldo da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "vagnaldosilva@gmail.com",
        "genero": "M",
        "dataNasc": "19 Out.",
        "telefone": "1127223820",
        "ultInteracao": "Compra",
        "dataInteracao": "21/01/2025"
        },
        {
        "id": "731027295",
        "name": " ",
        "comPromocional": false,
        "numCompras": 2,
        "email": "siustecnica@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "24988111338",
        "ultInteracao": "Compra",
        "dataInteracao": "20/01/2025"
        },
        {
        "id": "282555760",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "chevrandduarte@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "20/01/2025"
        },
        {
        "id": "241472183",
        "name": "Arthur Prudente Junqueira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "g.eficazto@gmail.com",
        "genero": "M",
        "dataNasc": "02 Fev.",
        "telefone": " 6332131056",
        "ultInteracao": "Compra",
        "dataInteracao": "20/01/2025"
        },
        {
        "id": "676377514",
        "name": "Juliane Garcia Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fjulianegarcia@gmail.com",
        "genero": "",
        "dataNasc": "10 Set.",
        "telefone": "5517991446973",
        "ultInteracao": "Compra",
        "dataInteracao": "20/01/2025"
        },
        {
        "id": "498894009",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "caua.f@solarproengenharia.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "4733942600",
        "ultInteracao": "Compra",
        "dataInteracao": "20/01/2025"
        },
        {
        "id": "261949638",
        "name": "Clevane Augusto Pereira Junior",
        "comPromocional": false,
        "numCompras": 1,
        "email": "fsajuniorap01@gmail.com",
        "genero": "",
        "dataNasc": "05 Jul.",
        "telefone": "6198120084",
        "ultInteracao": "Compra",
        "dataInteracao": "20/01/2025"
        },
        {
        "id": "586682930",
        "name": "Darlline Isabelle Dos Santos Silva",
        "comPromocional": false,
        "numCompras": 1,
        "email": "isabelledarlline2@gmail.com",
        "genero": "",
        "dataNasc": "15 Abr.",
        "telefone": "5582987013385",
        "ultInteracao": "Compra",
        "dataInteracao": "20/01/2025"
        },
        {
        "id": "60641747",
        "name": "Franco Zanetich Filho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ozanetich@hotmail.com",
        "genero": "M",
        "dataNasc": "02 Mar.",
        "telefone": "1177201382",
        "ultInteracao": "Compra",
        "dataInteracao": "20/01/2025"
        },
        {
        "id": "101253347",
        "name": "Thopson Cardinot Jesus",
        "comPromocional": false,
        "numCompras": 1,
        "email": "thopson@uol.com.br",
        "genero": "",
        "dataNasc": "08 Dez.",
        "telefone": "21997042143",
        "ultInteracao": "Compra",
        "dataInteracao": "20/01/2025"
        },
        {
        "id": "69493953",
        "name": "Higo Oliveira Sousa Soares",
        "comPromocional": true,
        "numCompras": 1,
        "email": "higopezao@yahoo.com.br",
        "genero": "M",
        "dataNasc": "09 Mai.",
        "telefone": "03433115777",
        "ultInteracao": "Compra",
        "dataInteracao": "20/01/2025"
        },
        {
        "id": "2224097314",
        "name": "Davidson Cano Marques",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dcmarques07@gmail.com",
        "genero": "M",
        "dataNasc": "19 Jun.",
        "telefone": "5521974724182",
        "ultInteracao": "Compra",
        "dataInteracao": "20/01/2025"
        },
        {
        "id": "191681803",
        "name": "Givanildo Germano de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "givanildogermano@yahoo.com.br",
        "genero": "M",
        "dataNasc": "04 Jun.",
        "telefone": "32 988069284",
        "ultInteracao": "Compra",
        "dataInteracao": "20/01/2025"
        },
        {
        "id": "152715409",
        "name": " ",
        "comPromocional": true,
        "numCompras": 2,
        "email": "fernando.fcampos@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": " (31)93614702",
        "ultInteracao": "Compra",
        "dataInteracao": "19/01/2025"
        },
        {
        "id": "489921835",
        "name": "Paulo Henrique Mendes Rosa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "phmrgamer50@gmail.com",
        "genero": "M",
        "dataNasc": "11 Abr.",
        "telefone": "34998648444",
        "ultInteracao": "Compra",
        "dataInteracao": "19/01/2025"
        },
        {
        "id": "240769360",
        "name": "Anna Flavia Costa Sarmento",
        "comPromocional": true,
        "numCompras": 21,
        "email": "sarmento.flavia@hotmail.com",
        "genero": "",
        "dataNasc": "04 Dez.",
        "telefone": " 93991148659",
        "ultInteracao": "Compra",
        "dataInteracao": "18/01/2025"
        },
        {
        "id": "383464335",
        "name": "Matheus Phellipe Ferreira Sousa de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mtluizphellipe2020@gmail.com",
        "genero": "M",
        "dataNasc": "16 Jul.",
        "telefone": "21979849114",
        "ultInteracao": "Compra",
        "dataInteracao": "18/01/2025"
        },
        {
        "id": "338971191",
        "name": "Matheus da Silva Nogueira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nogueiramatheus553@gmail.com",
        "genero": "M",
        "dataNasc": "03 Jan.",
        "telefone": "5524999076293",
        "ultInteracao": "Compra",
        "dataInteracao": "17/01/2025"
        },
        {
        "id": "2220084136",
        "name": "Fabio Cardoso Lima",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fabiocardosolima84@gmail.com",
        "genero": "M",
        "dataNasc": "25 Abr.",
        "telefone": "5538984226210",
        "ultInteracao": "Compra",
        "dataInteracao": "17/01/2025"
        },
        {
        "id": "53408298",
        "name": "Thiago Nunes Lopes",
        "comPromocional": true,
        "numCompras": 2,
        "email": "thiagonuneslopes@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Mai.",
        "telefone": "038991797570",
        "ultInteracao": "Compra",
        "dataInteracao": "17/01/2025"
        },
        {
        "id": "43447772",
        "name": "Marcelo Laurett",
        "comPromocional": false,
        "numCompras": 1,
        "email": "marcelo.1620@hotmail.com",
        "genero": "M",
        "dataNasc": "17 Nov.",
        "telefone": "995815501",
        "ultInteracao": "Compra",
        "dataInteracao": "17/01/2025"
        },
        {
        "id": "700469093",
        "name": "Abdo Latif Fares",
        "comPromocional": true,
        "numCompras": 1,
        "email": "abdo.lf@gmail.com",
        "genero": "M",
        "dataNasc": "30 Jun.",
        "telefone": "5511965626060",
        "ultInteracao": "Compra",
        "dataInteracao": "17/01/2025"
        },
        {
        "id": "172235665",
        "name": "Martha Maria Pedrosa de Resende Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leonarrdopedrosa@gmail.com",
        "genero": "",
        "dataNasc": "17 Jul.",
        "telefone": " 31 32863014",
        "ultInteracao": "Compra",
        "dataInteracao": "17/01/2025"
        },
        {
        "id": "298668519",
        "name": "Wanderlei Silva Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wando_silva14@hotmail.com",
        "genero": "M",
        "dataNasc": "09 Nov.",
        "telefone": "87996049157",
        "ultInteracao": "Compra",
        "dataInteracao": "16/01/2025"
        },
        {
        "id": "144493012",
        "name": "Rodrigo Celestino Rufino",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rrufiino@hotmail.com",
        "genero": "M",
        "dataNasc": "21 Mai.",
        "telefone": "21998412911",
        "ultInteracao": "Compra",
        "dataInteracao": "17/01/2025"
        },
        {
        "id": "1176842111",
        "name": "Ketylin Fernandes Martins",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ketylin.fernandes.oficina@gmail.com",
        "genero": "",
        "dataNasc": "04 Jul.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "17/01/2025"
        },
        {
        "id": "2154207700",
        "name": "Victor Hugo Campos Alves Borges",
        "comPromocional": true,
        "numCompras": 1,
        "email": "vhcamposs96@gmail.com",
        "genero": "M",
        "dataNasc": "30 Jul.",
        "telefone": "5587988119492",
        "ultInteracao": "Compra",
        "dataInteracao": "17/01/2025"
        },
        {
        "id": "2216099487",
        "name": "Murilo Camara Couto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "muriloccouto@yahoo.com.br",
        "genero": "M",
        "dataNasc": "10 Nov.",
        "telefone": "5531991880118",
        "ultInteracao": "Compra",
        "dataInteracao": "17/01/2025"
        },
        {
        "id": "91530887",
        "name": "Leonardo Pacheco",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pacheco_801@hotmail.com",
        "genero": "M",
        "dataNasc": "14 Mai.",
        "telefone": "2422316212",
        "ultInteracao": "Compra",
        "dataInteracao": "17/01/2025"
        },
        {
        "id": "363055046",
        "name": "Jucimara Patricia Flores Sott",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jucisott@hotmail.com",
        "genero": "",
        "dataNasc": "07 Out.",
        "telefone": "5555997253067",
        "ultInteracao": "Compra",
        "dataInteracao": "15/01/2025"
        },
        {
        "id": "64057436",
        "name": "Ulisses Araujo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "uli.araujo@gmail.com",
        "genero": "M",
        "dataNasc": "16 Jul.",
        "telefone": "31996434191",
        "ultInteracao": "Compra",
        "dataInteracao": "16/01/2025"
        },
        {
        "id": "15020233",
        "name": "Ricardo Silva Villani",
        "comPromocional": true,
        "numCompras": 1,
        "email": "r.villani@hotmail.com",
        "genero": "M",
        "dataNasc": "08 Mai.",
        "telefone": "3132124000",
        "ultInteracao": "Compra",
        "dataInteracao": "16/01/2025"
        },
        {
        "id": "70034298",
        "name": "Adriano Torres Alves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "adrianotalves31@gmail.com",
        "genero": "M",
        "dataNasc": "08 Jan.",
        "telefone": " 3186008626",
        "ultInteracao": "Compra",
        "dataInteracao": "16/01/2025"
        },
        {
        "id": "243450794",
        "name": "Anderson Vilas Boas Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "inamarmultimarcas@hotmail.com",
        "genero": "M",
        "dataNasc": "04 Abr.",
        "telefone": " 1140592322",
        "ultInteracao": "Compra",
        "dataInteracao": "16/01/2025"
        },
        {
        "id": "263838374",
        "name": "Gisele Vizentin Sanguine",
        "comPromocional": true,
        "numCompras": 1,
        "email": "giselevizentin@gmail.com",
        "genero": "",
        "dataNasc": "24 Jun.",
        "telefone": "48-991067535",
        "ultInteracao": "Compra",
        "dataInteracao": "16/01/2025"
        },
        {
        "id": "1785819443",
        "name": "Daniel Pinto Melo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "melo_daniel1@icloud.com",
        "genero": "M",
        "dataNasc": "29 Mai.",
        "telefone": "5554997084464",
        "ultInteracao": "Compra",
        "dataInteracao": "16/01/2025"
        },
        {
        "id": "128326636",
        "name": "Jorge Takeshi Nakatake",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jorginho.nakatake@hotmail.com",
        "genero": "M",
        "dataNasc": "26 Dez.",
        "telefone": "11947339499",
        "ultInteracao": "Compra",
        "dataInteracao": "16/01/2025"
        },
        {
        "id": "222377020",
        "name": "Alberto Guimaraes Rodrigues",
        "comPromocional": true,
        "numCompras": 1,
        "email": "betoagr@gmail.com",
        "genero": "M",
        "dataNasc": "09 Mar.",
        "telefone": "988360903",
        "ultInteracao": "Compra",
        "dataInteracao": "16/01/2025"
        },
        {
        "id": "2217269638",
        "name": "Renato Rodrigues Pereira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "renatometal17@gmail.com",
        "genero": "M",
        "dataNasc": "08 Jul.",
        "telefone": "5531985683430",
        "ultInteracao": "Compra",
        "dataInteracao": "16/01/2025"
        },
        {
        "id": "176949529",
        "name": "Gabriel da Silva Gama",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gabrielgama33@gmail.com",
        "genero": "M",
        "dataNasc": "21 Mar.",
        "telefone": " 21969588151",
        "ultInteracao": "Compra",
        "dataInteracao": "16/01/2025"
        },
        {
        "id": "63628970",
        "name": "Andre Luiz Pereira de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "vendas@dfautocenter.com.br",
        "genero": "M",
        "dataNasc": "15 Mai.",
        "telefone": "6132452008",
        "ultInteracao": "Compra",
        "dataInteracao": "15/01/2025"
        },
        {
        "id": "65706611",
        "name": "Carlos Alberto Coelho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cacrj66@gmail.com",
        "genero": "M",
        "dataNasc": "24 Jul.",
        "telefone": "021996553366",
        "ultInteracao": "Compra",
        "dataInteracao": "15/01/2025"
        },
        {
        "id": "1897927738",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rodrigo@totalflexo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "5548999498679",
        "ultInteracao": "Compra",
        "dataInteracao": "15/01/2025"
        },
        {
        "id": "178446174",
        "name": "Oscimar Aparecido Gremon Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "oscimar.gremon.curso@gmail.com",
        "genero": "M",
        "dataNasc": "20 Jan.",
        "telefone": "17991554969",
        "ultInteracao": "Compra",
        "dataInteracao": "15/01/2025"
        },
        {
        "id": "276602730",
        "name": "Irene de Souza Bernardes",
        "comPromocional": false,
        "numCompras": 1,
        "email": "gladstonribeiro1990@gmail.com",
        "genero": "",
        "dataNasc": "25 Jun.",
        "telefone": "31 9 85291963",
        "ultInteracao": "Compra",
        "dataInteracao": "15/01/2025"
        },
        {
        "id": "707277219",
        "name": "Gabriel Margalhon Cerqueira Godinho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gabrielmcgodinho123@gmail.com",
        "genero": "M",
        "dataNasc": "13 Jan.",
        "telefone": "5521967551699",
        "ultInteracao": "Compra",
        "dataInteracao": "13/01/2025"
        },
        {
        "id": "99123182",
        "name": "Daniel Augusto de Albuquerque",
        "comPromocional": true,
        "numCompras": 1,
        "email": "daniel.jf2005@hotmail.com",
        "genero": "M",
        "dataNasc": "16 Jul.",
        "telefone": "35991661086",
        "ultInteracao": "Compra",
        "dataInteracao": "15/01/2025"
        },
        {
        "id": "74355425",
        "name": "Rogerio Rodrigues Bueno",
        "comPromocional": false,
        "numCompras": 1,
        "email": "roger_bueno3@hotmail.com",
        "genero": "M",
        "dataNasc": "30 Out.",
        "telefone": "4330200941",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "1118083486",
        "name": "Kethelyn Thaise Rodrigues de Castro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "compras@joyclubedebeneficios.com.br",
        "genero": "",
        "dataNasc": "31 Mai.",
        "telefone": "31998121827",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "1172691124",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "brenolanucidarochacampos@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531995760520",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "1505939154",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "xandsburguer33@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "32988042718",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "82152423",
        "name": "Vinicius Torres Guedes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "vncstorres@gmail.com",
        "genero": "M",
        "dataNasc": "26 Mar.",
        "telefone": "2292791003",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "44960828",
        "name": "Gabriel Angelo Dornellas de Souza",
        "comPromocional": false,
        "numCompras": 1,
        "email": "gabrielangelo2005@hotmail.com",
        "genero": "",
        "dataNasc": "23 Set.",
        "telefone": "31 993123742",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "170060541",
        "name": "Sebastiao Alexsandro Tavares de Araujo Junior",
        "comPromocional": true,
        "numCompras": 2,
        "email": "alexsandro.tavares9829@gmail.com",
        "genero": "M",
        "dataNasc": "20 Mai.",
        "telefone": "81997056515",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "95222528",
        "name": "Leonardo Barbosa da Silva Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lejrtec@gmail.com",
        "genero": "M",
        "dataNasc": "05 Mai.",
        "telefone": "2136596850",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "2213077314",
        "name": "Thiago Firmani de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thiagofirmani@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Mar.",
        "telefone": "5511947774155",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "2210063193",
        "name": "Wantuil Luiz Maia Neto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sabrinadinizdias@gmail.com",
        "genero": "M",
        "dataNasc": "13 Jan.",
        "telefone": "5535999761405",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "35373142",
        "name": "Joao Evangelista Lucas",
        "comPromocional": true,
        "numCompras": 2,
        "email": "llucasspaixao@gmail.com",
        "genero": "M",
        "dataNasc": "01 Fev.",
        "telefone": "31988288832",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "1711851250",
        "name": "Hugo Cesar Lima Chagas Araujo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "hugodocfts@gmail.com",
        "genero": "M",
        "dataNasc": "02 Jul.",
        "telefone": "5531992557784",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "2209882003",
        "name": "Rafael de Paula Paes Landim",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rafabandeirantes@gmail.com",
        "genero": "M",
        "dataNasc": "24 Nov.",
        "telefone": "5511953667643",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "1148713112",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "contato@careautomotive.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "11940302060",
        "ultInteracao": "Compra",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "68693823",
        "name": "Evandro Dias Do Prado",
        "comPromocional": true,
        "numCompras": 1,
        "email": "evandrodias79@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Fev.",
        "telefone": " 3183193558",
        "ultInteracao": "Compra",
        "dataInteracao": "13/01/2025"
        },
        {
        "id": "1136031136",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "casalvw0948@grupocasal.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "2221066009",
        "ultInteracao": "Compra",
        "dataInteracao": "13/01/2025"
        },
        {
        "id": "133495766",
        "name": "Rogerio Fernandes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rogerfer3852@gmail.com",
        "genero": "M",
        "dataNasc": "06 Nov.",
        "telefone": "11997347779",
        "ultInteracao": "Compra",
        "dataInteracao": "13/01/2025"
        },
        {
        "id": "129818470",
        "name": "Sandro Augusto da Silva Almeida",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sandroig70@yahoo.com.br",
        "genero": "M",
        "dataNasc": "10 Out.",
        "telefone": " 21 33636006",
        "ultInteracao": "Compra",
        "dataInteracao": "13/01/2025"
        },
        {
        "id": "96163741",
        "name": "Luiz Marcos Pereira Porto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luipp@uol.com.br",
        "genero": "M",
        "dataNasc": "05 Set.",
        "telefone": "24999886677",
        "ultInteracao": "Compra",
        "dataInteracao": "13/01/2025"
        },
        {
        "id": "2209756970",
        "name": "Tiago Cristiano Ribas",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tiagoribas@ymail.com",
        "genero": "M",
        "dataNasc": "14 Mar.",
        "telefone": "5531995278335",
        "ultInteracao": "Compra",
        "dataInteracao": "12/01/2025"
        },
        {
        "id": "46569505",
        "name": "Frederico Moreira Dabien Haddad",
        "comPromocional": true,
        "numCompras": 2,
        "email": "freddabienh@gmail.com",
        "genero": "M",
        "dataNasc": "08 Mar.",
        "telefone": "31982870505",
        "ultInteracao": "Compra",
        "dataInteracao": "12/01/2025"
        },
        {
        "id": "2074765734",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jlalves2606@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5535988298286",
        "ultInteracao": "Compra",
        "dataInteracao": "12/01/2025"
        },
        {
        "id": "65258947",
        "name": "Pedro Estevao de Souza Borges",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pedro.borges1@hotmail.com",
        "genero": "M",
        "dataNasc": "28 Jun.",
        "telefone": "24974018250",
        "ultInteracao": "Compra",
        "dataInteracao": "11/01/2025"
        },
        {
        "id": "198716059",
        "name": "Joao Gabriel Gaspar Vieira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "joaogabrielgasparvieira12@gmail.com",
        "genero": "M",
        "dataNasc": "27 Ago.",
        "telefone": "4999062437",
        "ultInteracao": "Compra",
        "dataInteracao": "11/01/2025"
        },
        {
        "id": "226134373",
        "name": "Marcio Aurelio Siqueira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcioconstruto@gmail.com",
        "genero": "M",
        "dataNasc": "03 Jun.",
        "telefone": " 22999880199",
        "ultInteracao": "Compra",
        "dataInteracao": "11/01/2025"
        },
        {
        "id": "605611978",
        "name": "Odair Vieira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "odairvieira300@gmail.com",
        "genero": "M",
        "dataNasc": "13 Mar.",
        "telefone": "15998430387",
        "ultInteracao": "Compra",
        "dataInteracao": "10/01/2025"
        },
        {
        "id": "48460936",
        "name": "Warlen Washington Chagas de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wweder@ig.com.br",
        "genero": "M",
        "dataNasc": "04 Nov.",
        "telefone": "3133514249",
        "ultInteracao": "Compra",
        "dataInteracao": "10/01/2025"
        },
        {
        "id": "2203549061",
        "name": "Bruno Dimas de Moraes E Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "brunodimas@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Dez.",
        "telefone": "5531991144878",
        "ultInteracao": "Compra",
        "dataInteracao": "10/01/2025"
        },
        {
        "id": "2206069282",
        "name": "Nilson Gomes Dos Reis Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "Agropecuariabemestar@gmail.com",
        "genero": "M",
        "dataNasc": "16 Mai.",
        "telefone": "5531998937021",
        "ultInteracao": "Compra",
        "dataInteracao": "10/01/2025"
        },
        {
        "id": "2206008768",
        "name": "Francisco Claudiomiro Andrade Soares",
        "comPromocional": false,
        "numCompras": 1,
        "email": "claudiomiromito@gmail.com",
        "genero": "M",
        "dataNasc": "27 Set.",
        "telefone": "5531986853070",
        "ultInteracao": "Compra",
        "dataInteracao": "10/01/2025"
        },
        {
        "id": "47071324",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "comercial@dimarcaambiental.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "2138823002",
        "ultInteracao": "Compra",
        "dataInteracao": "10/01/2025"
        },
        {
        "id": "193058381",
        "name": "Helena Truis Tavares Magrin",
        "comPromocional": true,
        "numCompras": 1,
        "email": "h.magrin@hotmail.com",
        "genero": "",
        "dataNasc": "30 Abr.",
        "telefone": " 43 35250291",
        "ultInteracao": "Compra",
        "dataInteracao": "10/01/2025"
        },
        {
        "id": "222251575",
        "name": "Andre Luis Alves Lopes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "andre.alveslopes0789@gmail.com",
        "genero": "M",
        "dataNasc": "07 Abr.",
        "telefone": "21991922870",
        "ultInteracao": "Compra",
        "dataInteracao": "09/01/2025"
        },
        {
        "id": "379743925",
        "name": "Marina Machado Fiuza Pequeno",
        "comPromocional": true,
        "numCompras": 1,
        "email": "maripek98@gmail.com",
        "genero": "",
        "dataNasc": "24 Ago.",
        "telefone": "21971269719",
        "ultInteracao": "Compra",
        "dataInteracao": "09/01/2025"
        },
        {
        "id": "573452338",
        "name": "Paulo Rostenis Magalhaes da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "paulorostenis@hotmail.com",
        "genero": "M",
        "dataNasc": "30 Jun.",
        "telefone": "5531996026851",
        "ultInteracao": "Compra",
        "dataInteracao": "09/01/2025"
        },
        {
        "id": "2160790143",
        "name": "Waldenir Clemente de Faria",
        "comPromocional": true,
        "numCompras": 1,
        "email": "trs.clemente@hotmail.com",
        "genero": "M",
        "dataNasc": "23 Nov.",
        "telefone": "5522999818479",
        "ultInteracao": "Compra",
        "dataInteracao": "09/01/2025"
        },
        {
        "id": "190902819",
        "name": "Thiago Braga Ferreira Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thiago134129@gmail.com",
        "genero": "M",
        "dataNasc": "29 Jan.",
        "telefone": " +55 31 84578762",
        "ultInteracao": "Compra",
        "dataInteracao": "09/01/2025"
        },
        {
        "id": "20297769",
        "name": "Gleison Elias Teixeira",
        "comPromocional": true,
        "numCompras": 2,
        "email": "gleysonsmc@hotmail.com",
        "genero": "M",
        "dataNasc": "06 Jul.",
        "telefone": "31971458491",
        "ultInteracao": "Compra",
        "dataInteracao": "09/01/2025"
        },
        {
        "id": "431488215",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "anabeatrizam100@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531998763702",
        "ultInteracao": "Compra",
        "dataInteracao": "09/01/2025"
        },
        {
        "id": "438910107",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "danubiacosta2009@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531991411511",
        "ultInteracao": "Compra",
        "dataInteracao": "09/01/2025"
        },
        {
        "id": "192715053",
        "name": "Henrique Dos Santos Meirelis",
        "comPromocional": true,
        "numCompras": 1,
        "email": "henryatalaia@hotmail.com",
        "genero": "M",
        "dataNasc": "16 Set.",
        "telefone": " 03175618429",
        "ultInteracao": "Compra",
        "dataInteracao": "09/01/2025"
        },
        {
        "id": "224994344",
        "name": "Xisto Leonardo Moreira",
        "comPromocional": true,
        "numCompras": 2,
        "email": "atendimento@popsupershop.com",
        "genero": "M",
        "dataNasc": "03 Jan.",
        "telefone": "31983844383",
        "ultInteracao": "Compra",
        "dataInteracao": "08/01/2025"
        },
        {
        "id": "1068067801",
        "name": "Carlos Seabra Alves Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carlosseabraalvesjr31@gmail.com",
        "genero": "M",
        "dataNasc": "31 Jan.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "08/01/2025"
        },
        {
        "id": "1817184645",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rorosss@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5511947280806",
        "ultInteracao": "Compra",
        "dataInteracao": "08/01/2025"
        },
        {
        "id": "98497598",
        "name": "Junio Rodrigues Matias",
        "comPromocional": true,
        "numCompras": 3,
        "email": "junio.rodriguess@hotmail.com",
        "genero": "M",
        "dataNasc": "19 Jun.",
        "telefone": "3136726970",
        "ultInteracao": "Compra",
        "dataInteracao": "08/01/2025"
        },
        {
        "id": "2199682349",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "claudiomiromito@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531986853070",
        "ultInteracao": "Compra",
        "dataInteracao": "08/01/2025"
        },
        {
        "id": "296598705",
        "name": "Joao Paulo Vieira Chaves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "joaopaulovieiradj@gmail.com",
        "genero": "M",
        "dataNasc": "13 Mai.",
        "telefone": "982705585",
        "ultInteracao": "Compra",
        "dataInteracao": "08/01/2025"
        },
        {
        "id": "151975366",
        "name": "Igor Lima Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "igorlima1979@gmail.com",
        "genero": "M",
        "dataNasc": "27 Dez.",
        "telefone": "21970217997",
        "ultInteracao": "Compra",
        "dataInteracao": "08/01/2025"
        },
        {
        "id": "300830051",
        "name": "Fernando Alves da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alvesfernandodasilva@gmail.com",
        "genero": "M",
        "dataNasc": "02 Ago.",
        "telefone": "21992337360",
        "ultInteracao": "Compra",
        "dataInteracao": "08/01/2025"
        },
        {
        "id": "2199136997",
        "name": "Rogerio Bento de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "prosperarveiculos@gmail.com",
        "genero": "M",
        "dataNasc": "11 Set.",
        "telefone": "5533999060646",
        "ultInteracao": "Compra",
        "dataInteracao": "08/01/2025"
        },
        {
        "id": "43459849",
        "name": "Carlos Alberto de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "casoal2@gmail.com",
        "genero": "M",
        "dataNasc": "12 Ago.",
        "telefone": "47997127634",
        "ultInteracao": "Compra",
        "dataInteracao": "07/01/2025"
        },
        {
        "id": "164829472",
        "name": "Alessandro Rocha Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alessandrorocha25@hotmail.com",
        "genero": "M",
        "dataNasc": "02 Ago.",
        "telefone": " 6284123896",
        "ultInteracao": "Compra",
        "dataInteracao": "07/01/2025"
        },
        {
        "id": "226396627",
        "name": "Galeno Vitoi Ribeiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "galenovitoi@gmail.com",
        "genero": "M",
        "dataNasc": "07 Jun.",
        "telefone": " 37 999413946",
        "ultInteracao": "Compra",
        "dataInteracao": "07/01/2025"
        },
        {
        "id": "379178238",
        "name": "Guilherme Monteiro de Castro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gmonteirodecastro73@gmail.com",
        "genero": "M",
        "dataNasc": "15 Jun.",
        "telefone": "5531994080479",
        "ultInteracao": "Compra",
        "dataInteracao": "07/01/2025"
        },
        {
        "id": "194384026",
        "name": "Renato de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "autocopacabana@gmail.com",
        "genero": "M",
        "dataNasc": "22 Mai.",
        "telefone": "11988686065",
        "ultInteracao": "Compra",
        "dataInteracao": "07/01/2025"
        },
        {
        "id": "160593685",
        "name": "Pedro Dos Santos Grandinetti de Barros",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pedro_suta@hotmail.com",
        "genero": "M",
        "dataNasc": "10 Mai.",
        "telefone": " (31)99785-1290",
        "ultInteracao": "Compra",
        "dataInteracao": "07/01/2025"
        },
        {
        "id": "36421487",
        "name": "Jefferson Tavares da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jts.jeffersontavares@gmail.com",
        "genero": "M",
        "dataNasc": "22 Ago.",
        "telefone": "21970271725",
        "ultInteracao": "Compra",
        "dataInteracao": "07/01/2025"
        },
        {
        "id": "229623584",
        "name": "Victor Dos Santos Rodrigues",
        "comPromocional": true,
        "numCompras": 1,
        "email": "victor.srbr@gmail.com",
        "genero": "M",
        "dataNasc": "24 Ago.",
        "telefone": "5579991567032",
        "ultInteracao": "Compra",
        "dataInteracao": "06/01/2025"
        },
        {
        "id": "1092977402",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "elias@centercat.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "5534999408128",
        "ultInteracao": "Compra",
        "dataInteracao": "06/01/2025"
        },
        {
        "id": "280258553",
        "name": "Maria Do Carmo Barros Peduti Junqueira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gabspdj@hotmail.com",
        "genero": "",
        "dataNasc": "21 Abr.",
        "telefone": "62999646410",
        "ultInteracao": "Compra",
        "dataInteracao": "06/01/2025"
        },
        {
        "id": "91146421",
        "name": "Deuzianny Lopes da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "deuzianny@yahoo.com.br",
        "genero": "",
        "dataNasc": "21 Jan.",
        "telefone": "6363984546894",
        "ultInteracao": "Compra",
        "dataInteracao": "06/01/2025"
        },
        {
        "id": "159622456",
        "name": "Tiago Alexandre Pereira Galdino",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tpgaldino@hotmail.com",
        "genero": "M",
        "dataNasc": "26 Ago.",
        "telefone": " 3561-0215 / 88110215",
        "ultInteracao": "Compra",
        "dataInteracao": "06/01/2025"
        },
        {
        "id": "126599668",
        "name": "Wilson de Souza Moreira Paixao",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wilsonspaixao@hotmail.com",
        "genero": "M",
        "dataNasc": "27 Out.",
        "telefone": "31992860932",
        "ultInteracao": "Compra",
        "dataInteracao": "06/01/2025"
        },
        {
        "id": "63444812",
        "name": "Felipe Dias Alvarenga",
        "comPromocional": true,
        "numCompras": 1,
        "email": "f.dias.a@gmail.com",
        "genero": "M",
        "dataNasc": "23 Jul.",
        "telefone": "3188888888",
        "ultInteracao": "Compra",
        "dataInteracao": "06/01/2025"
        },
        {
        "id": "427413671",
        "name": "Joao Bosco Fonseca Zanolla",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jbzanolla@hotmail.com",
        "genero": "M",
        "dataNasc": "30 Jul.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "06/01/2025"
        },
        {
        "id": "2188061573",
        "name": "Wagner Santos da Silveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wagneraliciar@gmail.com",
        "genero": "M",
        "dataNasc": "16 Ago.",
        "telefone": "553199348006",
        "ultInteracao": "Compra",
        "dataInteracao": "02/01/2025"
        },
        {
        "id": "707675937",
        "name": "Fernando Gomes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fuscagomes2017@gmail.com",
        "genero": "M",
        "dataNasc": "26 Fev.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "05/01/2025"
        },
        {
        "id": "134865014",
        "name": "Jesse Herculano",
        "comPromocional": true,
        "numCompras": 3,
        "email": "herculanojesse@hotmail.com",
        "genero": "M",
        "dataNasc": "14 Fev.",
        "telefone": "31996058348",
        "ultInteracao": "Compra",
        "dataInteracao": "05/01/2025"
        },
        {
        "id": "208307413",
        "name": "Peterson Ferreira Vieira de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "petersondesouza199735@gmail.com",
        "genero": "M",
        "dataNasc": "13 Nov.",
        "telefone": " 31992241548",
        "ultInteracao": "Compra",
        "dataInteracao": "05/01/2025"
        },
        {
        "id": "2196532280",
        "name": "Luiz Fernando Amaral Tonelli",
        "comPromocional": true,
        "numCompras": 1,
        "email": "diretoria@tcicontabilidade.com.br",
        "genero": "M",
        "dataNasc": "11 Dez.",
        "telefone": "5537984019383",
        "ultInteracao": "Compra",
        "dataInteracao": "05/01/2025"
        },
        {
        "id": "18251586",
        "name": "Jose Maria Domingos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nil.jm@hotmail.com",
        "genero": "M",
        "dataNasc": "04 Ago.",
        "telefone": "21997023724",
        "ultInteracao": "Compra",
        "dataInteracao": "05/01/2025"
        },
        {
        "id": "1362611146",
        "name": "Helder Coimbra de Sepulvida",
        "comPromocional": true,
        "numCompras": 4,
        "email": "heldercoimbra2020@gmail.com",
        "genero": "M",
        "dataNasc": "23 Out.",
        "telefone": "5586994374020",
        "ultInteracao": "Compra",
        "dataInteracao": "05/01/2025"
        },
        {
        "id": "48410757",
        "name": "Fernando Eduardo Correa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "peninha33@yahoo.com.br",
        "genero": "M",
        "dataNasc": "02 Ago.",
        "telefone": "2122887597",
        "ultInteracao": "Compra",
        "dataInteracao": "05/01/2025"
        },
        {
        "id": "2193154525",
        "name": "Daniel Augusto de Albuquerque",
        "comPromocional": true,
        "numCompras": 2,
        "email": "daniel.jf2005@gmail.com",
        "genero": "M",
        "dataNasc": "16 Jul.",
        "telefone": "5535991661086",
        "ultInteracao": "Compra",
        "dataInteracao": "05/01/2025"
        },
        {
        "id": "1506600651",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mateusflavia1989@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531996933920",
        "ultInteracao": "Compra",
        "dataInteracao": "04/01/2025"
        },
        {
        "id": "276868146",
        "name": "Victor Fernandes de Queiroz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "victoradmbh@hotmail.com",
        "genero": "M",
        "dataNasc": "25 Nov.",
        "telefone": "31993055015",
        "ultInteracao": "Compra",
        "dataInteracao": "04/01/2025"
        },
        {
        "id": "612818510",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "peterson.resende@hotmail.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "19996906222",
        "ultInteracao": "Compra",
        "dataInteracao": "04/01/2025"
        },
        {
        "id": "2192757905",
        "name": "Brenda Moreira Rodrigues",
        "comPromocional": false,
        "numCompras": 1,
        "email": "brenda.mrodrigues@hotmail.com",
        "genero": "",
        "dataNasc": "09 Out.",
        "telefone": "5531984648345",
        "ultInteracao": "Compra",
        "dataInteracao": "04/01/2025"
        },
        {
        "id": "160995751",
        "name": "Carlos Alberto Marino Braz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "brazlena@yahoo.com.br",
        "genero": "M",
        "dataNasc": "20 Jun.",
        "telefone": "31986592101",
        "ultInteracao": "Compra",
        "dataInteracao": "04/01/2025"
        },
        {
        "id": "451987649",
        "name": "Paulo Sergio Dias de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ps1976.dias@gmail.com",
        "genero": "M",
        "dataNasc": "04 Mar.",
        "telefone": "31986129693",
        "ultInteracao": "Compra",
        "dataInteracao": "04/01/2025"
        },
        {
        "id": "111426335",
        "name": "Tiago Pereira Aledi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tiagoaledi@hotmail.com",
        "genero": "M",
        "dataNasc": "19 Nov.",
        "telefone": " (28)98862456",
        "ultInteracao": "Compra",
        "dataInteracao": "04/01/2025"
        },
        {
        "id": "144807464",
        "name": "Fabio Rodrigues da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fabiosushidara@gmail.com",
        "genero": "M",
        "dataNasc": "05 Mai.",
        "telefone": " 2182116681",
        "ultInteracao": "Compra",
        "dataInteracao": "03/01/2025"
        },
        {
        "id": "246087032",
        "name": "Hector Emanuel Ferreira Batista",
        "comPromocional": true,
        "numCompras": 5,
        "email": "hectorfbatista@gmail.com",
        "genero": "M",
        "dataNasc": "01 Abr.",
        "telefone": "31973113919",
        "ultInteracao": "Compra",
        "dataInteracao": "03/01/2025"
        },
        {
        "id": "2190090695",
        "name": "Karil Diah Volante",
        "comPromocional": true,
        "numCompras": 1,
        "email": "karilvolante@yahoo.com.br",
        "genero": "",
        "dataNasc": "22 Nov.",
        "telefone": "5519981363386",
        "ultInteracao": "Compra",
        "dataInteracao": "03/01/2025"
        },
        {
        "id": "35423084",
        "name": "Fabio Lima",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fabiolima.eng@gmail.com",
        "genero": "M",
        "dataNasc": "28 Out.",
        "telefone": "1197531215",
        "ultInteracao": "Compra",
        "dataInteracao": "03/01/2025"
        },
        {
        "id": "2190035963",
        "name": "Jarbas Costa",
        "comPromocional": true,
        "numCompras": 2,
        "email": "jarbascosta45@gmail.com",
        "genero": "M",
        "dataNasc": "17 Abr.",
        "telefone": "5531988752722",
        "ultInteracao": "Compra",
        "dataInteracao": "03/01/2025"
        },
        {
        "id": "179154563",
        "name": "Claudinei da Silva Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "claud-inei@hotmail.com",
        "genero": "M",
        "dataNasc": "05 Ago.",
        "telefone": " 3488392425",
        "ultInteracao": "Compra",
        "dataInteracao": "02/01/2025"
        },
        {
        "id": "615281628",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dinizotavio@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "02/01/2025"
        },
        {
        "id": "123551030",
        "name": "Adolfo Junio Batista Pereira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "junio.batistap@gmail.com",
        "genero": "M",
        "dataNasc": "05 Jun.",
        "telefone": "31992086990",
        "ultInteracao": "Compra",
        "dataInteracao": "02/01/2025"
        },
        {
        "id": "206039884",
        "name": "Antonio Carlos da Silveira II",
        "comPromocional": true,
        "numCompras": 1,
        "email": "antonio_silveira@live.com",
        "genero": "M",
        "dataNasc": "31 Dez.",
        "telefone": " 34991978621",
        "ultInteracao": "Compra",
        "dataInteracao": "02/01/2025"
        },
        {
        "id": "2188046243",
        "name": "Maria Auxiliadora de Almeida Chaves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "Guilherme.corporativo@hotmail.com",
        "genero": "",
        "dataNasc": "03 Fev.",
        "telefone": "5531989362695",
        "ultInteracao": "Compra",
        "dataInteracao": "02/01/2025"
        },
        {
        "id": "2190489",
        "name": "Iago Dos Santos Peres",
        "comPromocional": true,
        "numCompras": 1,
        "email": "iagoperes@yahoo.com.br",
        "genero": "M",
        "dataNasc": "16 Jun.",
        "telefone": "2133425193",
        "ultInteracao": "Compra",
        "dataInteracao": "31/12/2024"
        },
        {
        "id": "269107415",
        "name": "Marcos Rodrigues de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcosurciana@hotmail.com",
        "genero": "M",
        "dataNasc": "02 Out.",
        "telefone": "34 988520318",
        "ultInteracao": "Compra",
        "dataInteracao": "30/12/2024"
        },
        {
        "id": "2180026439",
        "name": "Danny de Oliveira Goncalves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "danny-og@hotmail.com",
        "genero": "",
        "dataNasc": "05 Abr.",
        "telefone": "5534988084384",
        "ultInteracao": "Compra",
        "dataInteracao": "27/12/2024"
        },
        {
        "id": "2187548270",
        "name": "Dilma de Oliveira Fernandes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "Joicejoyjoy148@gmail.com",
        "genero": "",
        "dataNasc": "06 Jan.",
        "telefone": "5531975789530",
        "ultInteracao": "Compra",
        "dataInteracao": "30/12/2024"
        },
        {
        "id": "520965702",
        "name": "Guilherme Freitas Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "guilhermeshit777@gmail.com",
        "genero": "M",
        "dataNasc": "05 Jan.",
        "telefone": "5571988733555",
        "ultInteracao": "Compra",
        "dataInteracao": "30/12/2024"
        },
        {
        "id": "32077241",
        "name": "Tiago Rodrigues Machado",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ama.advogados@globo.com",
        "genero": "M",
        "dataNasc": "09 Mar.",
        "telefone": "318825-0000",
        "ultInteracao": "Compra",
        "dataInteracao": "30/12/2024"
        },
        {
        "id": "1201652603",
        "name": "Danilo de Matos Pereira",
        "comPromocional": true,
        "numCompras": 2,
        "email": "danilop92@hotmail.com",
        "genero": "M",
        "dataNasc": "02 Out.",
        "telefone": "34996777177",
        "ultInteracao": "Compra",
        "dataInteracao": "30/12/2024"
        },
        {
        "id": "294647137",
        "name": "Marchejanes Oliveira de Carvalho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marchejanes.oliveira@gmail.com",
        "genero": "",
        "dataNasc": "25 Jun.",
        "telefone": "11949274393",
        "ultInteracao": "Compra",
        "dataInteracao": "29/12/2024"
        },
        {
        "id": "272632208",
        "name": "Celio de Oliveira Almeida",
        "comPromocional": true,
        "numCompras": 1,
        "email": "celioalmeida2015@gmail.com",
        "genero": "M",
        "dataNasc": "24 Mar.",
        "telefone": "31 9 96560184",
        "ultInteracao": "Compra",
        "dataInteracao": "29/12/2024"
        },
        {
        "id": "84607612",
        "name": "Emerson Mendes Trindade",
        "comPromocional": true,
        "numCompras": 1,
        "email": "emersontrindade@yahoo.com.br",
        "genero": "M",
        "dataNasc": "12 Abr.",
        "telefone": "3133816361",
        "ultInteracao": "Compra",
        "dataInteracao": "28/12/2024"
        },
        {
        "id": "7495715",
        "name": "Carlos Alberto de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eletronicateleriacho@gmail.com",
        "genero": "M",
        "dataNasc": "01 Jul.",
        "telefone": "031996088989",
        "ultInteracao": "Compra",
        "dataInteracao": "28/12/2024"
        },
        {
        "id": "269422750",
        "name": "Helder de Oliveira",
        "comPromocional": true,
        "numCompras": 2,
        "email": "hdr.olv@gmail.com",
        "genero": "M",
        "dataNasc": "27 Jul.",
        "telefone": "11972632760",
        "ultInteracao": "Compra",
        "dataInteracao": "28/12/2024"
        },
        {
        "id": "85123057",
        "name": "Laio Aguiar Amancio Bahia",
        "comPromocional": true,
        "numCompras": 1,
        "email": "laio_10@hotmail.com",
        "genero": "M",
        "dataNasc": "02 Mar.",
        "telefone": "33984326216",
        "ultInteracao": "Compra",
        "dataInteracao": "27/12/2024"
        },
        {
        "id": "623778692",
        "name": "Ricardo Campos de Freitas",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ricardocamposfreitas68@gmail.com",
        "genero": "M",
        "dataNasc": "16 Fev.",
        "telefone": "5531988846555",
        "ultInteracao": "Compra",
        "dataInteracao": "27/12/2024"
        },
        {
        "id": "735030521",
        "name": "Nicholas Nelson da Silva Vieira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nicolasnelsonvieira@hotmail.com",
        "genero": "M",
        "dataNasc": "09 Nov.",
        "telefone": "31999319765",
        "ultInteracao": "Compra",
        "dataInteracao": "25/12/2024"
        },
        {
        "id": "614199430",
        "name": "Valter Rezende Pereira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "douglasamaral2030@outlook.com",
        "genero": "M",
        "dataNasc": "28 Dez.",
        "telefone": "33984446288",
        "ultInteracao": "Compra",
        "dataInteracao": "25/12/2024"
        },
        {
        "id": "85625092",
        "name": " ",
        "comPromocional": false,
        "numCompras": 2,
        "email": "gsmcaixeta@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "6181146476",
        "ultInteracao": "Compra",
        "dataInteracao": "24/12/2024"
        },
        {
        "id": "347765794",
        "name": "Frederico Dos Santos Pereira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "fredbass1987@gmail.com",
        "genero": "M",
        "dataNasc": "01 Mai.",
        "telefone": "5531981046553",
        "ultInteracao": "Compra",
        "dataInteracao": "24/12/2024"
        },
        {
        "id": "86862441",
        "name": "Ricardo Jose Bastos Guimaraes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "guimaraes4324@yahoo.com.br",
        "genero": "M",
        "dataNasc": "19 Mar.",
        "telefone": "21999778078",
        "ultInteracao": "Compra",
        "dataInteracao": "23/12/2024"
        },
        {
        "id": "2174714641",
        "name": "Cassio Jossan Mendes Vieira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cassiojossan@hotmail.com",
        "genero": "M",
        "dataNasc": "01 Nov.",
        "telefone": "5533991190067",
        "ultInteracao": "Compra",
        "dataInteracao": "23/12/2024"
        },
        {
        "id": "4961874",
        "name": "Leandro Barbosa de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leandrogmcar@gmail.com",
        "genero": "M",
        "dataNasc": "17 Ago.",
        "telefone": " 35-32227055",
        "ultInteracao": "Compra",
        "dataInteracao": "23/12/2024"
        },
        {
        "id": "75321243",
        "name": "Lauro Biolchini",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lbiolchini@hotmail.com",
        "genero": "M",
        "dataNasc": "06 Dez.",
        "telefone": "2196715064",
        "ultInteracao": "Compra",
        "dataInteracao": "23/12/2024"
        },
        {
        "id": "72184934",
        "name": "Claudineia Faria de Carvalho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "calcadosclaudiacarvalho@hotmail.com",
        "genero": "",
        "dataNasc": "12 Dez.",
        "telefone": "3599132768",
        "ultInteracao": "Compra",
        "dataInteracao": "22/12/2024"
        },
        {
        "id": "2174875116",
        "name": "Daniele Grisolia Dualibi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "danidual@hotmail.com",
        "genero": "",
        "dataNasc": "08 Abr.",
        "telefone": "5514996912117",
        "ultInteracao": "Compra",
        "dataInteracao": "21/12/2024"
        },
        {
        "id": "2174009952",
        "name": "Ytalo Arthur Araujo Macedo",
        "comPromocional": false,
        "numCompras": 1,
        "email": "ytaloaarthur@mail.com",
        "genero": "M",
        "dataNasc": "25 Out.",
        "telefone": "5531993919697",
        "ultInteracao": "Compra",
        "dataInteracao": "21/12/2024"
        },
        {
        "id": "334797919",
        "name": "Virgilio Hasenclever Faria Dos Reis",
        "comPromocional": true,
        "numCompras": 1,
        "email": "virgiliofaria@nutribemrefeicoescoletivas.com.br",
        "genero": "M",
        "dataNasc": "13 Jul.",
        "telefone": "38999051441",
        "ultInteracao": "Compra",
        "dataInteracao": "21/12/2024"
        },
        {
        "id": "234471659",
        "name": "Richard Franzoi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "richardfranzoi@hotmail.com",
        "genero": "",
        "dataNasc": "19 Set.",
        "telefone": "11996690583",
        "ultInteracao": "Compra",
        "dataInteracao": "20/12/2024"
        },
        {
        "id": "226887838",
        "name": "Cassio Andre Santos de Oliveira",
        "comPromocional": true,
        "numCompras": 2,
        "email": "cassiosantosoliveira@gmail.com",
        "genero": "M",
        "dataNasc": "21 Mar.",
        "telefone": "75991555322",
        "ultInteracao": "Compra",
        "dataInteracao": "20/12/2024"
        },
        {
        "id": "134304472",
        "name": "Erick Oliveira Lopes Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "erickousborne@hotmail.com",
        "genero": "M",
        "dataNasc": "13 Out.",
        "telefone": " 3187774503",
        "ultInteracao": "Compra",
        "dataInteracao": "20/12/2024"
        },
        {
        "id": "304680127",
        "name": "Thales Igor Oliveira Pereira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thalesigor15@hotmail.com",
        "genero": "M",
        "dataNasc": "30 Jul.",
        "telefone": "5531993967202",
        "ultInteracao": "Compra",
        "dataInteracao": "20/12/2024"
        },
        {
        "id": "2172096480",
        "name": "Sandro Moreira de Melo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sandromelo_14@hotmail.com",
        "genero": "M",
        "dataNasc": "14 Jul.",
        "telefone": "5561996121745",
        "ultInteracao": "Compra",
        "dataInteracao": "20/12/2024"
        },
        {
        "id": "384782213",
        "name": "Ricardo Vinicius Lupatelli",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lupatelliricardo@gmail.com",
        "genero": "M",
        "dataNasc": "27 Jul.",
        "telefone": "11999840279",
        "ultInteracao": "Compra",
        "dataInteracao": "20/12/2024"
        },
        {
        "id": "280836956",
        "name": "Izac Dos Santos Burmann",
        "comPromocional": true,
        "numCompras": 1,
        "email": "izacburmann123@gmail.com",
        "genero": "M",
        "dataNasc": "19 Ago.",
        "telefone": "5531988439479",
        "ultInteracao": "Compra",
        "dataInteracao": "20/12/2024"
        },
        {
        "id": "101402702",
        "name": "Leticia de Paiva Silva Freitas",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leticiadps@yahoo.com.br",
        "genero": "",
        "dataNasc": "15 Jun.",
        "telefone": " 3588170747",
        "ultInteracao": "Compra",
        "dataInteracao": "19/12/2024"
        },
        {
        "id": "134894681",
        "name": "Charles Mayke da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "charles_mayke@hotmail.com",
        "genero": "M",
        "dataNasc": "25 Mar.",
        "telefone": " 97177711",
        "ultInteracao": "Compra",
        "dataInteracao": "19/12/2024"
        },
        {
        "id": "204078990",
        "name": "Ismael Carlos Xavier da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ismaelcarlos2013@hotmail.com",
        "genero": "M",
        "dataNasc": "10 Jun.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "19/12/2024"
        },
        {
        "id": "718790887",
        "name": "Saulo Lopes Rocha",
        "comPromocional": true,
        "numCompras": 4,
        "email": "piabadiv@gmail.com",
        "genero": "M",
        "dataNasc": "15 Jul.",
        "telefone": "37991730073",
        "ultInteracao": "Compra",
        "dataInteracao": "19/12/2024"
        },
        {
        "id": "1026177329",
        "name": "Cleonaldo de Souza Oliveira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "cleonaldooliveira9@gmail.com",
        "genero": "M",
        "dataNasc": "19 Fev.",
        "telefone": "5521970131593",
        "ultInteracao": "Compra",
        "dataInteracao": "19/12/2024"
        },
        {
        "id": "22613356",
        "name": "Wilton Moreira da Silva",
        "comPromocional": true,
        "numCompras": 4,
        "email": "wiltonmg@hotmail.com",
        "genero": "M",
        "dataNasc": "13 Dez.",
        "telefone": "3198812542",
        "ultInteracao": "Compra",
        "dataInteracao": "19/12/2024"
        },
        {
        "id": "1156929994",
        "name": "Jose Rubens Monteiro Teixeira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jrubensmt@ifba.edu.br",
        "genero": "M",
        "dataNasc": "11 Ago.",
        "telefone": "5571988632433",
        "ultInteracao": "Compra",
        "dataInteracao": "19/12/2024"
        },
        {
        "id": "147586239",
        "name": "Thales Justino de Brito",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thalesbritto@me.com",
        "genero": "M",
        "dataNasc": "14 Jul.",
        "telefone": " 3188769515",
        "ultInteracao": "Compra",
        "dataInteracao": "18/12/2024"
        },
        {
        "id": "167743144",
        "name": "Wanber Alexandre da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wanber@outlook.com",
        "genero": "",
        "dataNasc": "20 Ago.",
        "telefone": "31989663532",
        "ultInteracao": "Compra",
        "dataInteracao": "18/12/2024"
        },
        {
        "id": "240480085",
        "name": "Victor Samuel Machado Amado",
        "comPromocional": true,
        "numCompras": 1,
        "email": "vitinho_334@hotmail.com",
        "genero": "M",
        "dataNasc": "22 Abr.",
        "telefone": "5519998622764",
        "ultInteracao": "Compra",
        "dataInteracao": "18/12/2024"
        },
        {
        "id": "204970077",
        "name": "Carlos Jose de Oliveira Almeida",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carlos.almeid@yahoo.com.br",
        "genero": "M",
        "dataNasc": "16 Mar.",
        "telefone": " 31 - 30536419",
        "ultInteracao": "Compra",
        "dataInteracao": "17/12/2024"
        },
        {
        "id": "80144616",
        "name": "Gabriel Silva Finger",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gabriel.finger@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Abr.",
        "telefone": "4747991622721",
        "ultInteracao": "Compra",
        "dataInteracao": "17/12/2024"
        },
        {
        "id": "488314211",
        "name": "Tiago Soares de Gois Filho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "soarestiago505@gmail.com",
        "genero": "M",
        "dataNasc": "31 Dez.",
        "telefone": "5521977226648",
        "ultInteracao": "Compra",
        "dataInteracao": "17/12/2024"
        },
        {
        "id": "1092870739",
        "name": "Alexsandro Pedro Ferreira",
        "comPromocional": false,
        "numCompras": 2,
        "email": "alexpinturasmais@gmail.com",
        "genero": "M",
        "dataNasc": "29 Jun.",
        "telefone": "5538988118385",
        "ultInteracao": "Compra",
        "dataInteracao": "17/12/2024"
        },
        {
        "id": "280154238",
        "name": "Patricia Vital Moreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "patriciavital_m@hotmail.com",
        "genero": "",
        "dataNasc": "04 Abr.",
        "telefone": "37991220003",
        "ultInteracao": "Compra",
        "dataInteracao": "17/12/2024"
        },
        {
        "id": "603757370",
        "name": "Tales Nicolau de Araujo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "talles.n.araujo@gmail.com",
        "genero": "",
        "dataNasc": "02 Jan.",
        "telefone": "5531996439644",
        "ultInteracao": "Compra",
        "dataInteracao": "16/12/2024"
        },
        {
        "id": "376718755",
        "name": "Valter Do Nascimento Claudino",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nacimentovalter@yahoo.com.br",
        "genero": "M",
        "dataNasc": "25 Dez.",
        "telefone": "31933001340",
        "ultInteracao": "Compra",
        "dataInteracao": "16/12/2024"
        },
        {
        "id": "82367285",
        "name": "Michael Nascimento da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mayko_9@hotmail.com",
        "genero": "M",
        "dataNasc": "09 Set.",
        "telefone": "6181771137",
        "ultInteracao": "Compra",
        "dataInteracao": "16/12/2024"
        },
        {
        "id": "71417533",
        "name": "Renata Lopes Martelo Teixeira",
        "comPromocional": true,
        "numCompras": 2,
        "email": "renatalmt@gmail.com",
        "genero": "",
        "dataNasc": "07 Fev.",
        "telefone": "( 021) 964522273",
        "ultInteracao": "Compra",
        "dataInteracao": "16/12/2024"
        },
        {
        "id": "93549368",
        "name": "Gustavo Paiva de Amorim",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gustavopamorim@gmail.com",
        "genero": "M",
        "dataNasc": "16 Nov.",
        "telefone": "6191460321",
        "ultInteracao": "Compra",
        "dataInteracao": "16/12/2024"
        },
        {
        "id": "422312441",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cleidejteixeira@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "16/12/2024"
        },
        {
        "id": "140251590",
        "name": "Jolindo Francisco Kuhn",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jolindofrancisco@hotmail.com",
        "genero": "M",
        "dataNasc": "16 Abr.",
        "telefone": " 2799983992",
        "ultInteracao": "Compra",
        "dataInteracao": "15/12/2024"
        },
        {
        "id": "305409400",
        "name": "Jefferson Gomes Dos Santos",
        "comPromocional": false,
        "numCompras": 1,
        "email": "j17santos@hotmail.com",
        "genero": "M",
        "dataNasc": "17 Abr.",
        "telefone": "5517996354554",
        "ultInteracao": "Compra",
        "dataInteracao": "15/12/2024"
        },
        {
        "id": "449420678",
        "name": "Carlem Neyliane Souza Barros",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carlem18neyliane@hotmail.com",
        "genero": "",
        "dataNasc": "01 Dez.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "15/12/2024"
        },
        {
        "id": "742560728",
        "name": "Fabio Pereira Traspadini",
        "comPromocional": true,
        "numCompras": 1,
        "email": "traspadinifabiop@gmail.com",
        "genero": "M",
        "dataNasc": "21 Out.",
        "telefone": "5527998319762",
        "ultInteracao": "Compra",
        "dataInteracao": "15/12/2024"
        },
        {
        "id": "1641014729",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "renato.mourafe1@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5589999001857",
        "ultInteracao": "Compra",
        "dataInteracao": "15/12/2024"
        },
        {
        "id": "114064235",
        "name": "Admilson Oliveira Chaves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "admilsonstreet@gmail.com",
        "genero": "M",
        "dataNasc": "16 Jun.",
        "telefone": " 86591838",
        "ultInteracao": "Compra",
        "dataInteracao": "15/12/2024"
        },
        {
        "id": "26482488",
        "name": "Raphael Mendes de Sa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "raphaelmendesdesa@outlook.com",
        "genero": "M",
        "dataNasc": "15 Out.",
        "telefone": "21971449538",
        "ultInteracao": "Compra",
        "dataInteracao": "14/12/2024"
        },
        {
        "id": "1338036085",
        "name": "Ademir de Lima Silva",
        "comPromocional": true,
        "numCompras": 2,
        "email": "ademirlima1978@hotmail.com",
        "genero": "M",
        "dataNasc": "03 Jun.",
        "telefone": "5571988628500",
        "ultInteracao": "Compra",
        "dataInteracao": "13/12/2024"
        },
        {
        "id": "337915959",
        "name": "Italo Henrique Araujo Andrade",
        "comPromocional": false,
        "numCompras": 1,
        "email": "italoandrade92@yahoo.com.br",
        "genero": "M",
        "dataNasc": "23 Jul.",
        "telefone": "5531992832444",
        "ultInteracao": "Compra",
        "dataInteracao": "13/12/2024"
        },
        {
        "id": "718508965",
        "name": "Pedro Miguel Cota",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pcota2079@gmail.com",
        "genero": "M",
        "dataNasc": "26 Out.",
        "telefone": "31999744099",
        "ultInteracao": "Compra",
        "dataInteracao": "13/12/2024"
        },
        {
        "id": "1180174051",
        "name": "Bruno de Jesus Lima",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lima.bruno2705@gmail.com",
        "genero": "M",
        "dataNasc": "27 Mai.",
        "telefone": "5511982637918",
        "ultInteracao": "Compra",
        "dataInteracao": "13/12/2024"
        },
        {
        "id": "467137853",
        "name": "Paulo Cesar da Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dacostapaulocesar096@gmail.com",
        "genero": "",
        "dataNasc": "01 Fev.",
        "telefone": "5541992179560",
        "ultInteracao": "Compra",
        "dataInteracao": "13/12/2024"
        },
        {
        "id": "1002813701",
        "name": "Luis Alexandre Lopes",
        "comPromocional": false,
        "numCompras": 1,
        "email": "alexandre.lps74@icloud.com",
        "genero": "M",
        "dataNasc": "30 Out.",
        "telefone": "5519983994999",
        "ultInteracao": "Compra",
        "dataInteracao": "12/12/2024"
        },
        {
        "id": "2149672397",
        "name": "Bernardo Rodrigues Fenelon",
        "comPromocional": false,
        "numCompras": 1,
        "email": "fenelonbe@gmail.com",
        "genero": "M",
        "dataNasc": "03 Jan.",
        "telefone": "5531984150298",
        "ultInteracao": "Compra",
        "dataInteracao": "11/12/2024"
        },
        {
        "id": "95245397",
        "name": "Julia Patricia Cota",
        "comPromocional": true,
        "numCompras": 1,
        "email": "juliacotageo@gmail.com",
        "genero": "",
        "dataNasc": "17 Mar.",
        "telefone": "3188979620",
        "ultInteracao": "Compra",
        "dataInteracao": "11/12/2024"
        },
        {
        "id": "158419430",
        "name": "Marcelino Pereira Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "emilianoratti@yahoo.com.br",
        "genero": "M",
        "dataNasc": "17 Set.",
        "telefone": " 31 35921692",
        "ultInteracao": "Compra",
        "dataInteracao": "11/12/2024"
        },
        {
        "id": "217132170",
        "name": "Cesar Augusto Hamacek de Paiva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "hama21domi14@gmail.com",
        "genero": "M",
        "dataNasc": "21 Jun.",
        "telefone": " 31992316812",
        "ultInteracao": "Compra",
        "dataInteracao": "10/12/2024"
        },
        {
        "id": "1052132434",
        "name": "Jose Pires",
        "comPromocional": true,
        "numCompras": 1,
        "email": "josepires3394@gmail.com",
        "genero": "M",
        "dataNasc": "16 Mar.",
        "telefone": "5535998279366",
        "ultInteracao": "Compra",
        "dataInteracao": "10/12/2024"
        },
        {
        "id": "2150339000",
        "name": "Varlei Eustaquio Pinto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "varleipinto@gmail.com",
        "genero": "",
        "dataNasc": "31 Out.",
        "telefone": "5531997987607",
        "ultInteracao": "Compra",
        "dataInteracao": "10/12/2024"
        },
        {
        "id": "432964028",
        "name": "Rafaella de Paula Pereira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dudica_depaula@hotmail.com",
        "genero": "",
        "dataNasc": "22 Mai.",
        "telefone": "5541991099466",
        "ultInteracao": "Compra",
        "dataInteracao": "10/12/2024"
        },
        {
        "id": "164680497",
        "name": "Israel Estolano de Arruda",
        "comPromocional": true,
        "numCompras": 1,
        "email": "estolano2014@gmail.com",
        "genero": "",
        "dataNasc": "22 Jul.",
        "telefone": " 21 33507898",
        "ultInteracao": "Compra",
        "dataInteracao": "09/12/2024"
        },
        {
        "id": "714286930",
        "name": "Ana Paula Soares de Paula",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ana.psoares@pbh.gov.br",
        "genero": "",
        "dataNasc": "26 Nov.",
        "telefone": "5531992831738",
        "ultInteracao": "Compra",
        "dataInteracao": "09/12/2024"
        },
        {
        "id": "117904443",
        "name": "Marlon Ozanan da Fonseca",
        "comPromocional": true,
        "numCompras": 3,
        "email": "marlonfonseca78@gmail.com",
        "genero": "M",
        "dataNasc": "28 Jun.",
        "telefone": "31995215492",
        "ultInteracao": "Compra",
        "dataInteracao": "09/12/2024"
        },
        {
        "id": "2146041426",
        "name": "Claudio Junior Andrade Ribeiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "claudio.ribeiro@ifmg.edu.br",
        "genero": "M",
        "dataNasc": "02 Mar.",
        "telefone": "5531989567716",
        "ultInteracao": "Compra",
        "dataInteracao": "08/12/2024"
        },
        {
        "id": "24170929",
        "name": "Rafael Correia Gaiba",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rafael@printvisual.com.br",
        "genero": "M",
        "dataNasc": "16 Mar.",
        "telefone": "27998985958",
        "ultInteracao": "Compra",
        "dataInteracao": "08/12/2024"
        },
        {
        "id": "2088746858",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cca.pagamentos@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "07/12/2024"
        },
        {
        "id": "2139832801",
        "name": "Irineu Shigueru Shintani",
        "comPromocional": true,
        "numCompras": 1,
        "email": "isshintani@hotmail.com",
        "genero": "M",
        "dataNasc": "12 Dez.",
        "telefone": "5544998991778",
        "ultInteracao": "Compra",
        "dataInteracao": "06/12/2024"
        },
        {
        "id": "98532200",
        "name": "Alisson Antonio Rodrigues Vieira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "bunecomoc@yahoo.com.br",
        "genero": "M",
        "dataNasc": "26 Fev.",
        "telefone": "33988710969",
        "ultInteracao": "Compra",
        "dataInteracao": "06/12/2024"
        },
        {
        "id": "347524287",
        "name": "Jose Fernandes Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jfernandes992438312@gmail.com",
        "genero": "M",
        "dataNasc": "09 Jun.",
        "telefone": "31973443604",
        "ultInteracao": "Compra",
        "dataInteracao": "06/12/2024"
        },
        {
        "id": "181661695",
        "name": "Rodrigo Duque Estrada Tenorio Cavalcanti Fernandes",
        "comPromocional": true,
        "numCompras": 2,
        "email": "duque.siespbprv@gmail.com",
        "genero": "M",
        "dataNasc": "25 Mar.",
        "telefone": " 21964073346",
        "ultInteracao": "Compra",
        "dataInteracao": "06/12/2024"
        },
        {
        "id": "159450982",
        "name": "Jean Maico de Mora Santin",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jean_maico_jp@hotmail.com",
        "genero": "M",
        "dataNasc": "07 Out.",
        "telefone": " 41995820551",
        "ultInteracao": "Compra",
        "dataInteracao": "06/12/2024"
        },
        {
        "id": "2139226267",
        "name": "Rosilene Alves de Souza Lemos",
        "comPromocional": false,
        "numCompras": 1,
        "email": "lpagrace10@hotmail.com",
        "genero": "",
        "dataNasc": "31 Ago.",
        "telefone": "5521984848426",
        "ultInteracao": "Compra",
        "dataInteracao": "06/12/2024"
        },
        {
        "id": "137695510",
        "name": "Marco Antonio Bernardes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcoab@hotmail.com",
        "genero": "M",
        "dataNasc": "30 Ago.",
        "telefone": " 37-99562220",
        "ultInteracao": "Compra",
        "dataInteracao": "06/12/2024"
        },
        {
        "id": "187318272",
        "name": "Silvia Martins Reis Aip",
        "comPromocional": false,
        "numCompras": 1,
        "email": "sissivet@gmail.com",
        "genero": "",
        "dataNasc": "22 Fev.",
        "telefone": " 15981009334",
        "ultInteracao": "Compra",
        "dataInteracao": "06/12/2024"
        },
        {
        "id": "184942667",
        "name": "Valeria Costa Viana",
        "comPromocional": true,
        "numCompras": 1,
        "email": "valeria.cviana@hotmail.com",
        "genero": "",
        "dataNasc": "20 Jul.",
        "telefone": " (31)94191419",
        "ultInteracao": "Compra",
        "dataInteracao": "05/12/2024"
        },
        {
        "id": "1378714224",
        "name": "Diana Djanira Pedro",
        "comPromocional": false,
        "numCompras": 1,
        "email": "diana.legacy@alterdata.com.br",
        "genero": "",
        "dataNasc": "26 Dez.",
        "telefone": "5535991460846",
        "ultInteracao": "Compra",
        "dataInteracao": "05/12/2024"
        },
        {
        "id": "5307190",
        "name": "Dennis Bernardino Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dennisbernardino@gmail.com",
        "genero": "M",
        "dataNasc": "03 Jun.",
        "telefone": "1124524047",
        "ultInteracao": "Compra",
        "dataInteracao": "05/12/2024"
        },
        {
        "id": "2138781588",
        "name": "Helbert Ferreira Olimpio",
        "comPromocional": false,
        "numCompras": 2,
        "email": "helbert.olimpio@gmail.com",
        "genero": "M",
        "dataNasc": "19 Dez.",
        "telefone": "5511995500091",
        "ultInteracao": "Compra",
        "dataInteracao": "04/12/2024"
        },
        {
        "id": "336367334",
        "name": "Fabricio Santos Cardoso",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sfabricio53@yahoo.com",
        "genero": "M",
        "dataNasc": "22 Dez.",
        "telefone": "5593992013360",
        "ultInteracao": "Compra",
        "dataInteracao": "04/12/2024"
        },
        {
        "id": "345232134",
        "name": "Carlos Silvares Feio Neto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carlossilvares07@gmail.com",
        "genero": "M",
        "dataNasc": "17 Dez.",
        "telefone": "5521973915497",
        "ultInteracao": "Compra",
        "dataInteracao": "04/12/2024"
        },
        {
        "id": "188765804",
        "name": "Ozimar Franca da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mazinhofranca39@gmail.com",
        "genero": "M",
        "dataNasc": "05 Mar.",
        "telefone": "6999971298",
        "ultInteracao": "Compra",
        "dataInteracao": "04/12/2024"
        },
        {
        "id": "358811593",
        "name": "Clemente Goncalves Dos Santos Rocha",
        "comPromocional": true,
        "numCompras": 1,
        "email": "kale160349@gmail.com",
        "genero": "M",
        "dataNasc": "03 Nov.",
        "telefone": "33998635548",
        "ultInteracao": "Compra",
        "dataInteracao": "04/12/2024"
        },
        {
        "id": "99172028",
        "name": "Emmerson Bandeira Bernardino",
        "comPromocional": true,
        "numCompras": 1,
        "email": "emerson@contabilidademaster.com.br",
        "genero": "M",
        "dataNasc": "05 Jan.",
        "telefone": "03132734341",
        "ultInteracao": "Compra",
        "dataInteracao": "04/12/2024"
        },
        {
        "id": "238394123",
        "name": "Diogo Barros Gutterres",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dbgutterres@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Out.",
        "telefone": " 22 998629378",
        "ultInteracao": "Compra",
        "dataInteracao": "03/12/2024"
        },
        {
        "id": "2135952220",
        "name": "Samea Rodrigues de Souza Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "samea.ferreira@gmail.com",
        "genero": "",
        "dataNasc": "20 Jul.",
        "telefone": "5531999415878",
        "ultInteracao": "Compra",
        "dataInteracao": "03/12/2024"
        },
        {
        "id": "50460562",
        "name": "Alex Sandro Aguiar",
        "comPromocional": true,
        "numCompras": 1,
        "email": "repautoimports@gmail.com",
        "genero": "M",
        "dataNasc": "12 Abr.",
        "telefone": "1143621018",
        "ultInteracao": "Compra",
        "dataInteracao": "03/12/2024"
        },
        {
        "id": "182770794",
        "name": "Daniel Anthony Rocha da Fonseca",
        "comPromocional": true,
        "numCompras": 1,
        "email": "danthonyf@live.com",
        "genero": "M",
        "dataNasc": "13 Jun.",
        "telefone": " 31989875696",
        "ultInteracao": "Compra",
        "dataInteracao": "03/12/2024"
        },
        {
        "id": "229171365",
        "name": "Maria Do Socorro Gomes Coelho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mariaagbezerra@gmail.com",
        "genero": "",
        "dataNasc": "01 Mai.",
        "telefone": " 87988151514",
        "ultInteracao": "Compra",
        "dataInteracao": "02/12/2024"
        },
        {
        "id": "37392037",
        "name": "Alison Hideo Kohatsu",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alisonkohatsu@hotmail.com",
        "genero": "M",
        "dataNasc": "29 Mai.",
        "telefone": "4191284140",
        "ultInteracao": "Compra",
        "dataInteracao": "02/12/2024"
        },
        {
        "id": "247329328",
        "name": "Marley Carvalho Antunes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marleycantunes@gmail.com",
        "genero": "",
        "dataNasc": "15 Dez.",
        "telefone": " 21995445495",
        "ultInteracao": "Compra",
        "dataInteracao": "02/12/2024"
        },
        {
        "id": "2126307589",
        "name": "Fabio Alexandre Kim",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dronekim1978@gmail.com",
        "genero": "M",
        "dataNasc": "18 Mar.",
        "telefone": "5511947266270",
        "ultInteracao": "Compra",
        "dataInteracao": "02/12/2024"
        },
        {
        "id": "258199706",
        "name": "Luis Henrique Vieira Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luis.henrique.santos87@gmail.com",
        "genero": "M",
        "dataNasc": "16 Jun.",
        "telefone": " 31988691506",
        "ultInteracao": "Compra",
        "dataInteracao": "02/12/2024"
        },
        {
        "id": "2130286471",
        "name": "Rubens Gomes E Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rstransporte.bsb@gmail.com",
        "genero": "M",
        "dataNasc": "16 Fev.",
        "telefone": "5561981090298",
        "ultInteracao": "Compra",
        "dataInteracao": "02/12/2024"
        },
        {
        "id": "23233643",
        "name": "Francisco Machado de Assuncao",
        "comPromocional": true,
        "numCompras": 1,
        "email": "francisco9651@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Mar.",
        "telefone": "02133927046",
        "ultInteracao": "Compra",
        "dataInteracao": "02/12/2024"
        },
        {
        "id": "79804324",
        "name": "Guilherme Terra Rodrigues",
        "comPromocional": true,
        "numCompras": 1,
        "email": "guilhermeterrarodrigues27@gmail.com",
        "genero": "M",
        "dataNasc": "27 Ago.",
        "telefone": "31991305003",
        "ultInteracao": "Compra",
        "dataInteracao": "01/12/2024"
        },
        {
        "id": "482421393",
        "name": "Victor Hugo de Oliveira Neves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "victorrosneves@gmail.com",
        "genero": "M",
        "dataNasc": "19 Jun.",
        "telefone": "5521967222616",
        "ultInteracao": "Compra",
        "dataInteracao": "01/12/2024"
        },
        {
        "id": "161405180",
        "name": "Lucas Gomes de Melo Fiuza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lucasgmfiuza@gmail.com",
        "genero": "M",
        "dataNasc": "11 Dez.",
        "telefone": " 31991327479",
        "ultInteracao": "Compra",
        "dataInteracao": "01/12/2024"
        },
        {
        "id": "73873421",
        "name": "Rafael Costga",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rafa_fly55@hotmail.com",
        "genero": "M",
        "dataNasc": "18 Dez.",
        "telefone": "1143576916",
        "ultInteracao": "Compra",
        "dataInteracao": "01/12/2024"
        },
        {
        "id": "134316343",
        "name": "Alexandre Almeida de Moraes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alexandremoraes@moraesemoraes.adv.br",
        "genero": "M",
        "dataNasc": "17 Jul.",
        "telefone": "21988978550",
        "ultInteracao": "Compra",
        "dataInteracao": "30/11/2024"
        },
        {
        "id": "2124971721",
        "name": "Diego Magnago Gualberto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "diego.mgualberto@yahoo.com.br",
        "genero": "M",
        "dataNasc": "18 Jul.",
        "telefone": "5531989500418",
        "ultInteracao": "Compra",
        "dataInteracao": "29/11/2024"
        },
        {
        "id": "2127431822",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "josecarlossbaraglini@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5514991959687",
        "ultInteracao": "Compra",
        "dataInteracao": "29/11/2024"
        },
        {
        "id": "293935488",
        "name": "Rafael Soares Dos Anjos",
        "comPromocional": false,
        "numCompras": 1,
        "email": "a.soaresrafael@outlook.com.br",
        "genero": "M",
        "dataNasc": "19 Ago.",
        "telefone": "43996233128",
        "ultInteracao": "Compra",
        "dataInteracao": "28/11/2024"
        },
        {
        "id": "329457549",
        "name": "Eustaquio Alexandre Resende",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eustaquioar@gmail.com",
        "genero": "M",
        "dataNasc": "03 Nov.",
        "telefone": "5531972362662",
        "ultInteracao": "Compra",
        "dataInteracao": "28/11/2024"
        },
        {
        "id": "84157349",
        "name": "Carlos Henrique Melo Ruivo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carlosmeloruivo@gmail.com",
        "genero": "M",
        "dataNasc": "21 Mai.",
        "telefone": "37999542052",
        "ultInteracao": "Compra",
        "dataInteracao": "28/11/2024"
        },
        {
        "id": "263014484",
        "name": "Igor Martins Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "igormartins260@gmail.com",
        "genero": "M",
        "dataNasc": "15 Jul.",
        "telefone": "31994451829",
        "ultInteracao": "Compra",
        "dataInteracao": "28/11/2024"
        },
        {
        "id": "1355669146",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "adm@tptlog.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "5511946160030",
        "ultInteracao": "Compra",
        "dataInteracao": "27/11/2024"
        },
        {
        "id": "48361169",
        "name": "Walter Sebastiao Maciel",
        "comPromocional": true,
        "numCompras": 1,
        "email": "macielws@yahoo.com.br",
        "genero": "M",
        "dataNasc": "20 Abr.",
        "telefone": "3199881904",
        "ultInteracao": "Compra",
        "dataInteracao": "28/11/2024"
        },
        {
        "id": "457507138",
        "name": "Waldeci Bananeira da Silva",
        "comPromocional": false,
        "numCompras": 1,
        "email": "irmaosbananeira2@gmail.com",
        "genero": "M",
        "dataNasc": "16 Mai.",
        "telefone": "13991515111",
        "ultInteracao": "Compra",
        "dataInteracao": "28/11/2024"
        },
        {
        "id": "249727526",
        "name": "Roberto Luiz Drummond Gosling",
        "comPromocional": true,
        "numCompras": 1,
        "email": "robertoldgosling@yahoo.com.br",
        "genero": "M",
        "dataNasc": "18 Abr.",
        "telefone": "5531991367577",
        "ultInteracao": "Compra",
        "dataInteracao": "28/11/2024"
        },
        {
        "id": "204345846",
        "name": "Melani de Freitas Dos Reis",
        "comPromocional": true,
        "numCompras": 1,
        "email": "melanifreitas2013@hotmail.com",
        "genero": "",
        "dataNasc": "02 Jan.",
        "telefone": " 55999307126",
        "ultInteracao": "Compra",
        "dataInteracao": "28/11/2024"
        },
        {
        "id": "154670269",
        "name": "Larissa Guedes Batista",
        "comPromocional": true,
        "numCompras": 1,
        "email": "larissa-guedes2007@outlook.com",
        "genero": "",
        "dataNasc": "04 Jan.",
        "telefone": " 3198034391",
        "ultInteracao": "Compra",
        "dataInteracao": "28/11/2024"
        },
        {
        "id": "267526049",
        "name": "Maristela Rodrigues de Camargo Almeida",
        "comPromocional": true,
        "numCompras": 1,
        "email": "maristelacamargo@outlook.com",
        "genero": "",
        "dataNasc": "08 Out.",
        "telefone": "15997713285",
        "ultInteracao": "Compra",
        "dataInteracao": "28/11/2024"
        },
        {
        "id": "66822136",
        "name": "Pablo Davidson da Rocha Rodrigues",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pablodavidson@hotmail.com",
        "genero": "M",
        "dataNasc": "09 Nov.",
        "telefone": "31991503157",
        "ultInteracao": "Compra",
        "dataInteracao": "27/11/2024"
        },
        {
        "id": "1211436588",
        "name": "Jonathan Ribeiro Milani",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jonathanrmilani@gmail.com",
        "genero": "M",
        "dataNasc": "20 Nov.",
        "telefone": "5565992455164",
        "ultInteracao": "Compra",
        "dataInteracao": "27/11/2024"
        },
        {
        "id": "27030398",
        "name": "Pedro Henrique Frois Araujo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pedrohenriquefroisaraujo@hotmail.com",
        "genero": "M",
        "dataNasc": "01 Out.",
        "telefone": "3199640443",
        "ultInteracao": "Compra",
        "dataInteracao": "27/11/2024"
        },
        {
        "id": "247724478",
        "name": "Sabrina Pereira de Sousa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sabrina.sousa07@hotmail.com",
        "genero": "",
        "dataNasc": "27 Jan.",
        "telefone": " 31984645062",
        "ultInteracao": "Compra",
        "dataInteracao": "27/11/2024"
        },
        {
        "id": "77221909",
        "name": "Marcelo Jose Oliveira Yared",
        "comPromocional": false,
        "numCompras": 1,
        "email": "marceloyared@yahoo.com.br",
        "genero": "M",
        "dataNasc": "24 Jun.",
        "telefone": "6133802680",
        "ultInteracao": "Compra",
        "dataInteracao": "27/11/2024"
        },
        {
        "id": "2119281981",
        "name": "Reginaldo Cassezi de Castro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cassezi@hotmail.com",
        "genero": "M",
        "dataNasc": "04 Abr.",
        "telefone": "5516997311911",
        "ultInteracao": "Compra",
        "dataInteracao": "27/11/2024"
        },
        {
        "id": "130430406",
        "name": "Eduardo Gabriel Ferreira Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "edu10mg@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Nov.",
        "telefone": "11912022904",
        "ultInteracao": "Compra",
        "dataInteracao": "26/11/2024"
        },
        {
        "id": "143204348",
        "name": "Ana Carolina de Sousa Martins",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carolmartins_89@hotmail.com",
        "genero": "",
        "dataNasc": "23 Set.",
        "telefone": " 86993",
        "ultInteracao": "Compra",
        "dataInteracao": "26/11/2024"
        },
        {
        "id": "227121791",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "camila.azevedo.leao@outlook.com",
        "genero": "",
        "dataNasc": "",
        "telefone": " 31997454724",
        "ultInteracao": "Compra",
        "dataInteracao": "23/11/2024"
        },
        {
        "id": "94447384",
        "name": "Juliano Cavalheiro de Lima",
        "comPromocional": true,
        "numCompras": 1,
        "email": "juliano.caju@hotmail.com",
        "genero": "M",
        "dataNasc": "05 Set.",
        "telefone": "4134322351",
        "ultInteracao": "Compra",
        "dataInteracao": "23/11/2024"
        },
        {
        "id": "130948311",
        "name": "Alvaro Guilherme Cicoti de Melo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "erenicicoti@hotmail.com",
        "genero": "M",
        "dataNasc": "23 Fev.",
        "telefone": " 31999555784",
        "ultInteracao": "Compra",
        "dataInteracao": "23/11/2024"
        },
        {
        "id": "1038280663",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eventoaprov@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5548996192084",
        "ultInteracao": "Compra",
        "dataInteracao": "22/11/2024"
        },
        {
        "id": "203621546",
        "name": "Braz Jose da Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "brazcost@globo.com",
        "genero": "M",
        "dataNasc": "15 Fev.",
        "telefone": " 21 99299-0742",
        "ultInteracao": "Compra",
        "dataInteracao": "22/11/2024"
        },
        {
        "id": "2114210192",
        "name": "Thiago Santos de Andrade",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thiandradex@gmail.com",
        "genero": "M",
        "dataNasc": "01 Jul.",
        "telefone": "5511958560047",
        "ultInteracao": "Compra",
        "dataInteracao": "22/11/2024"
        },
        {
        "id": "172618885",
        "name": "Ayda Jamile Neves de Araujo Brito",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ayda.jamile@hotmail.com",
        "genero": "",
        "dataNasc": "20 Out.",
        "telefone": " 73999056770",
        "ultInteracao": "Compra",
        "dataInteracao": "22/11/2024"
        },
        {
        "id": "1021639808",
        "name": "Felipe Santos Arruda",
        "comPromocional": true,
        "numCompras": 1,
        "email": "felipearruda.adv@outlook.com",
        "genero": "M",
        "dataNasc": "07 Dez.",
        "telefone": "5565999950461",
        "ultInteracao": "Compra",
        "dataInteracao": "22/11/2024"
        },
        {
        "id": "2111026247",
        "name": "Verlaine Germano Martins",
        "comPromocional": true,
        "numCompras": 1,
        "email": "verlainemartins07@gmail.com",
        "genero": "",
        "dataNasc": "07 Mai.",
        "telefone": "5531997038949",
        "ultInteracao": "Compra",
        "dataInteracao": "22/11/2024"
        },
        {
        "id": "61173299",
        "name": "Tereza Rosaria da Conceicao Mendes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "t.mendes2011@hotmail.com",
        "genero": "",
        "dataNasc": "04 Set.",
        "telefone": "02136410763",
        "ultInteracao": "Compra",
        "dataInteracao": "22/11/2024"
        },
        {
        "id": "2109633397",
        "name": "Rosangela Maracci Zahler",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rosangela_maracci@yahoo.com.br",
        "genero": "",
        "dataNasc": "10 Ago.",
        "telefone": "5561999613720",
        "ultInteracao": "Compra",
        "dataInteracao": "21/11/2024"
        },
        {
        "id": "183573735",
        "name": "Gustavo de Almeida Lima",
        "comPromocional": false,
        "numCompras": 1,
        "email": "gutoaudi@hotmail.com",
        "genero": "M",
        "dataNasc": "17 Jul.",
        "telefone": "11940228161",
        "ultInteracao": "Compra",
        "dataInteracao": "21/11/2024"
        },
        {
        "id": "16853425",
        "name": "Roosevelt Nascentes Sobrinho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "quitandinha2009@hotmail.com",
        "genero": "M",
        "dataNasc": "26 Nov.",
        "telefone": "35998604870",
        "ultInteracao": "Compra",
        "dataInteracao": "21/11/2024"
        },
        {
        "id": "230791983",
        "name": "Marcos Vinicius Teixeira de Queiroz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tsumaaperformance@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Jun.",
        "telefone": "31992226040",
        "ultInteracao": "Compra",
        "dataInteracao": "21/11/2024"
        },
        {
        "id": "168877951",
        "name": "Aline Conceicao Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alinesantostq@yahoo.com.br",
        "genero": "",
        "dataNasc": "02 Jul.",
        "telefone": " 3199672373",
        "ultInteracao": "Compra",
        "dataInteracao": "21/11/2024"
        },
        {
        "id": "2111552802",
        "name": "Breno Pimenta Diniz Rezende",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nfe@nortesulmg.com.br",
        "genero": "M",
        "dataNasc": "11 Abr.",
        "telefone": "5531995876870",
        "ultInteracao": "Compra",
        "dataInteracao": "21/11/2024"
        },
        {
        "id": "80566386",
        "name": "Leandro Henrique da Silva Telles",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leandrotelles2.0@gmail.com",
        "genero": "M",
        "dataNasc": "25 Fev.",
        "telefone": "2126045639",
        "ultInteracao": "Compra",
        "dataInteracao": "21/11/2024"
        },
        {
        "id": "185546983",
        "name": "Carlos Alexandre Pereira Silva",
        "comPromocional": false,
        "numCompras": 1,
        "email": "carlos.alexandre9927@gmail.com",
        "genero": "M",
        "dataNasc": "09 Nov.",
        "telefone": " 31 87039836",
        "ultInteracao": "Compra",
        "dataInteracao": "20/11/2024"
        },
        {
        "id": "702212862",
        "name": "Hellen Kassia Souza de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "hellenksoliveira@hotmail.com",
        "genero": "",
        "dataNasc": "19 Mai.",
        "telefone": "5531987889371",
        "ultInteracao": "Compra",
        "dataInteracao": "20/11/2024"
        },
        {
        "id": "364115287",
        "name": "Leonelson Aquino de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leonelsonaquino320@gmail.com",
        "genero": "",
        "dataNasc": "04 Mar.",
        "telefone": "66999623179",
        "ultInteracao": "Compra",
        "dataInteracao": "20/11/2024"
        },
        {
        "id": "188388983",
        "name": "Andre Felipe de Souza Fernandes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "andrefernandesbbg@gmail.com",
        "genero": "M",
        "dataNasc": "24 Out.",
        "telefone": "4199093442",
        "ultInteracao": "Compra",
        "dataInteracao": "19/11/2024"
        },
        {
        "id": "2106671488",
        "name": "Camila Dos Santos Noel",
        "comPromocional": true,
        "numCompras": 1,
        "email": "camilas.noel@gmail.com",
        "genero": "",
        "dataNasc": "18 Ago.",
        "telefone": "5524988487040",
        "ultInteracao": "Compra",
        "dataInteracao": "18/11/2024"
        },
        {
        "id": "375862365",
        "name": "Wagner Duarte Parada",
        "comPromocional": true,
        "numCompras": 1,
        "email": "paradabhz@gmail.com",
        "genero": "M",
        "dataNasc": "12 Out.",
        "telefone": "5531998581412",
        "ultInteracao": "Compra",
        "dataInteracao": "18/11/2024"
        },
        {
        "id": "171199387",
        "name": "Leticia Lopes Piantino",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leticia.piantino@gmail.com",
        "genero": "",
        "dataNasc": "17 Mai.",
        "telefone": "3130243040",
        "ultInteracao": "Compra",
        "dataInteracao": "18/11/2024"
        },
        {
        "id": "1253585896",
        "name": "Glaucio Vitor Galvao",
        "comPromocional": true,
        "numCompras": 1,
        "email": "glaucioandrade149@gmail.com",
        "genero": "M",
        "dataNasc": "05 Fev.",
        "telefone": "5535998336881",
        "ultInteracao": "Compra",
        "dataInteracao": "16/11/2024"
        },
        {
        "id": "181528461",
        "name": "Danilo Boni Campos",
        "comPromocional": false,
        "numCompras": 1,
        "email": "bonicampos@hotmail.com",
        "genero": "M",
        "dataNasc": "07 Dez.",
        "telefone": "31984839627",
        "ultInteracao": "Compra",
        "dataInteracao": "16/11/2024"
        },
        {
        "id": "73821671",
        "name": "Matheus de Oliveira Rocha",
        "comPromocional": true,
        "numCompras": 1,
        "email": "matheusoliveirarocha@gmail.com",
        "genero": "M",
        "dataNasc": "03 Out.",
        "telefone": "3191618675",
        "ultInteracao": "Compra",
        "dataInteracao": "15/11/2024"
        },
        {
        "id": "148933622",
        "name": "Herconio Goncalves Coimbra",
        "comPromocional": true,
        "numCompras": 1,
        "email": "herconiocoimbra@yahoo.com.br",
        "genero": "",
        "dataNasc": "21 Abr.",
        "telefone": "31991417592",
        "ultInteracao": "Compra",
        "dataInteracao": "15/11/2024"
        },
        {
        "id": "62104018",
        "name": "Lucas de Carvalho Linhares",
        "comPromocional": true,
        "numCompras": 2,
        "email": "linhareslukaos@outlook.com",
        "genero": "M",
        "dataNasc": "03 Fev.",
        "telefone": "031975030098",
        "ultInteracao": "Compra",
        "dataInteracao": "14/11/2024"
        },
        {
        "id": "29856753",
        "name": "Mauricio Baeta Amorim",
        "comPromocional": false,
        "numCompras": 2,
        "email": "mbalafaiete@yahoo.com.br",
        "genero": "M",
        "dataNasc": "05 Jul.",
        "telefone": "3187754303",
        "ultInteracao": "Compra",
        "dataInteracao": "14/11/2024"
        },
        {
        "id": "205729992",
        "name": "Tania Faria Dias Campos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "taniafaria.dias@gmail.com",
        "genero": "",
        "dataNasc": "15 Set.",
        "telefone": " 31993216656",
        "ultInteracao": "Compra",
        "dataInteracao": "14/11/2024"
        },
        {
        "id": "1784707531",
        "name": "Joao Paulo de Lazari Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "joaopaulolazarif@live.com",
        "genero": "M",
        "dataNasc": "31 Mai.",
        "telefone": "5531994504507",
        "ultInteracao": "Compra",
        "dataInteracao": "13/11/2024"
        },
        {
        "id": "221580617",
        "name": "Rodrigo Damasceno Bento",
        "comPromocional": true,
        "numCompras": 1,
        "email": "drigoxedagm222@gmail.com",
        "genero": "M",
        "dataNasc": "30 Jul.",
        "telefone": "5531987480782",
        "ultInteracao": "Compra",
        "dataInteracao": "13/11/2024"
        },
        {
        "id": "47783683",
        "name": "Edgard Junior Pereira de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ejpostyle@gmail.com",
        "genero": "M",
        "dataNasc": "17 Nov.",
        "telefone": "35988442293",
        "ultInteracao": "Compra",
        "dataInteracao": "13/11/2024"
        },
        {
        "id": "712135908",
        "name": "Claudineia Mendes de Sa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "neiabaiano109@gmail.com",
        "genero": "",
        "dataNasc": "15 Out.",
        "telefone": "5538999537576",
        "ultInteracao": "Compra",
        "dataInteracao": "13/11/2024"
        },
        {
        "id": "1420593204",
        "name": "Sophia Oliveira da Silva Julio",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sophiaoliveirasilva2023@gmail.com",
        "genero": "",
        "dataNasc": "10 Fev.",
        "telefone": "5521996005150",
        "ultInteracao": "Compra",
        "dataInteracao": "13/11/2024"
        },
        {
        "id": "178906318",
        "name": "Vanderlei Rubin Ferreira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "marcenariarubin@gmail.com",
        "genero": "M",
        "dataNasc": "27 Out.",
        "telefone": " 6792447728",
        "ultInteracao": "Compra",
        "dataInteracao": "13/11/2024"
        },
        {
        "id": "684724218",
        "name": "Glauber da Silva Corlaite",
        "comPromocional": true,
        "numCompras": 1,
        "email": "glaubercorlaite@gmail.com",
        "genero": "M",
        "dataNasc": "18 Nov.",
        "telefone": "5531997984618",
        "ultInteracao": "Compra",
        "dataInteracao": "12/11/2024"
        },
        {
        "id": "2094419680",
        "name": "Jansem da Silva Delamare Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jansem_delamare@hotmail.com",
        "genero": "M",
        "dataNasc": "09 Abr.",
        "telefone": "5531992600260",
        "ultInteracao": "Compra",
        "dataInteracao": "12/11/2024"
        },
        {
        "id": "56891226",
        "name": "Carlota Virginia Pereira Alves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cvp.alves@gmail.com",
        "genero": "",
        "dataNasc": "02 Out.",
        "telefone": "3134628427",
        "ultInteracao": "Compra",
        "dataInteracao": "12/11/2024"
        },
        {
        "id": "260279698",
        "name": "Marcelo Augusto Alves da Silva",
        "comPromocional": true,
        "numCompras": 5,
        "email": "marceloaa.silva93@gmail.com",
        "genero": "M",
        "dataNasc": "11 Jan.",
        "telefone": "31999982834",
        "ultInteracao": "Compra",
        "dataInteracao": "12/11/2024"
        },
        {
        "id": "549148353",
        "name": "Solange Queiroz Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "solangematcien@gmail.com",
        "genero": "",
        "dataNasc": "04 Jan.",
        "telefone": "5531996252343",
        "ultInteracao": "Compra",
        "dataInteracao": "12/11/2024"
        },
        {
        "id": "92872656",
        "name": "Luiz Carlos Ferreira Filho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lui_pessoa@hotmail.com",
        "genero": "M",
        "dataNasc": "07 Abr.",
        "telefone": "03132277186",
        "ultInteracao": "Compra",
        "dataInteracao": "12/11/2024"
        },
        {
        "id": "2093292868",
        "name": "Ricardo Alcerito Antunes Roque",
        "comPromocional": false,
        "numCompras": 1,
        "email": "alcerito@gmail.com",
        "genero": "M",
        "dataNasc": "05 Jul.",
        "telefone": "5511981335546",
        "ultInteracao": "Compra",
        "dataInteracao": "11/11/2024"
        },
        {
        "id": "249921247",
        "name": "Jose Luis Renteria Platero Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "joseluisrenteria78@gmail.com",
        "genero": "M",
        "dataNasc": "23 Jul.",
        "telefone": " (27)996013710",
        "ultInteracao": "Compra",
        "dataInteracao": "11/11/2024"
        },
        {
        "id": "32075531",
        "name": "Thais Stefania Gomes da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thays.stefania@yahoo.com.br",
        "genero": "",
        "dataNasc": "12 Jun.",
        "telefone": "3134538452",
        "ultInteracao": "Compra",
        "dataInteracao": "11/11/2024"
        },
        {
        "id": "2089458661",
        "name": "Fabriner Silva Gomes Rosa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fabrinerrosa@gmail.com",
        "genero": "",
        "dataNasc": "28 Mar.",
        "telefone": "5531985844550",
        "ultInteracao": "Compra",
        "dataInteracao": "11/11/2024"
        },
        {
        "id": "222586203",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eng.frederico@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": " 31996347577",
        "ultInteracao": "Compra",
        "dataInteracao": "10/11/2024"
        },
        {
        "id": "182240313",
        "name": "Fabio Pereira de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fabio-autoeletrica@hotmail.com",
        "genero": "M",
        "dataNasc": "21 Nov.",
        "telefone": "18996936320",
        "ultInteracao": "Compra",
        "dataInteracao": "10/11/2024"
        },
        {
        "id": "1297231984",
        "name": "Raimundo Rodrigues de Souza Filho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rodrigo09081950@gmail.com",
        "genero": "M",
        "dataNasc": "09 Ago.",
        "telefone": "5561998609036",
        "ultInteracao": "Compra",
        "dataInteracao": "10/11/2024"
        },
        {
        "id": "62961841",
        "name": "Edivaldo Rogerio de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "erogersz@yahoo.com.br",
        "genero": "",
        "dataNasc": "24 Jun.",
        "telefone": " 84432009",
        "ultInteracao": "Compra",
        "dataInteracao": "10/11/2024"
        },
        {
        "id": "33384052",
        "name": "Adelcio Ferreira Dias",
        "comPromocional": false,
        "numCompras": 1,
        "email": "adelciodede@yahoo.com.br",
        "genero": "M",
        "dataNasc": "22 Nov.",
        "telefone": "31998643679",
        "ultInteracao": "Compra",
        "dataInteracao": "10/11/2024"
        },
        {
        "id": "1585887704",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "barbarabhcor@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531987599881",
        "ultInteracao": "Compra",
        "dataInteracao": "10/11/2024"
        },
        {
        "id": "261124992",
        "name": "Abraao de Oliveira Freitas",
        "comPromocional": true,
        "numCompras": 1,
        "email": "abraaofreitas01@gmail.com",
        "genero": "M",
        "dataNasc": "16 Jan.",
        "telefone": "31971679516",
        "ultInteracao": "Compra",
        "dataInteracao": "09/11/2024"
        },
        {
        "id": "160317710",
        "name": "Carlos Eduardo Ferreira de Aguiar",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carfaguiar@gmail.com",
        "genero": "M",
        "dataNasc": "30 Dez.",
        "telefone": " 31 91726541",
        "ultInteracao": "Compra",
        "dataInteracao": "09/11/2024"
        },
        {
        "id": "176233654",
        "name": "Paulo Aparecido de Lima",
        "comPromocional": true,
        "numCompras": 1,
        "email": "paulolima.nsa@hotmail.com",
        "genero": "",
        "dataNasc": "27 Nov.",
        "telefone": " 41 91283638",
        "ultInteracao": "Compra",
        "dataInteracao": "09/11/2024"
        },
        {
        "id": "10604854",
        "name": "Edgard Felipe de Macedo Silva Vieira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "edgard.vieira@gmail.com",
        "genero": "M",
        "dataNasc": "03 Ago.",
        "telefone": "03131984249070",
        "ultInteracao": "Compra",
        "dataInteracao": "09/11/2024"
        },
        {
        "id": "2084766361",
        "name": "Joao Alfredo Tourinho de Oliveira Junior",
        "comPromocional": false,
        "numCompras": 1,
        "email": "jatoj2014@gmail.com",
        "genero": "M",
        "dataNasc": "09 Fev.",
        "telefone": "5521987845929",
        "ultInteracao": "Compra",
        "dataInteracao": "08/11/2024"
        },
        {
        "id": "725527453",
        "name": "Joao Vitor Souza Magalhaes Veronez",
        "comPromocional": true,
        "numCompras": 1,
        "email": "joaoveronez520@gmail.com",
        "genero": "M",
        "dataNasc": "08 Dez.",
        "telefone": "5511953188227",
        "ultInteracao": "Compra",
        "dataInteracao": "08/11/2024"
        },
        {
        "id": "2081640121",
        "name": "Guilherme Viana Oliveira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "guilherme.viana.96@gmail.com",
        "genero": "M",
        "dataNasc": "09 Fev.",
        "telefone": "5531975959735",
        "ultInteracao": "Compra",
        "dataInteracao": "07/11/2024"
        },
        {
        "id": "155750992",
        "name": "Franz Muller Dos Reis Goncalves Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "franzferreira@gmail.com",
        "genero": "M",
        "dataNasc": "29 Mai.",
        "telefone": " (32)9804-8218",
        "ultInteracao": "Compra",
        "dataInteracao": "06/11/2024"
        },
        {
        "id": "2083070560",
        "name": "Fernando Antonio de Almeida Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "faao52@gmail.com",
        "genero": "M",
        "dataNasc": "25 Jul.",
        "telefone": "5521996320535",
        "ultInteracao": "Compra",
        "dataInteracao": "06/11/2024"
        },
        {
        "id": "108338389",
        "name": " ",
        "comPromocional": true,
        "numCompras": 2,
        "email": "liamarccia@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "24-998845976",
        "ultInteracao": "Compra",
        "dataInteracao": "06/11/2024"
        },
        {
        "id": "260264420",
        "name": "Tarcis Alexandre Januario Raimundi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tarcisajr@hotmail.com",
        "genero": "M",
        "dataNasc": "14 Set.",
        "telefone": " 31 9 83775571",
        "ultInteracao": "Compra",
        "dataInteracao": "06/11/2024"
        },
        {
        "id": "71954012",
        "name": "Luciano Lopes Vieira",
        "comPromocional": true,
        "numCompras": 3,
        "email": "luciano.lvieira@yahoo.com.br",
        "genero": "M",
        "dataNasc": "30 Nov.",
        "telefone": " 31-9629-2272",
        "ultInteracao": "Compra",
        "dataInteracao": "06/11/2024"
        },
        {
        "id": "416886813",
        "name": "Rafael Ramalho da Silva",
        "comPromocional": false,
        "numCompras": 1,
        "email": "rra7a8l@gmail.com",
        "genero": "M",
        "dataNasc": "13 Out.",
        "telefone": "19991282579",
        "ultInteracao": "Compra",
        "dataInteracao": "05/11/2024"
        },
        {
        "id": "262309674",
        "name": "David Monteiro Correa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "david.mcorreaa@gmail.com",
        "genero": "M",
        "dataNasc": "14 Set.",
        "telefone": "11940315675",
        "ultInteracao": "Compra",
        "dataInteracao": "05/11/2024"
        },
        {
        "id": "306746450",
        "name": "Jessica Manoel Machado",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jessika-mm@hotmail.com",
        "genero": "",
        "dataNasc": "16 Abr.",
        "telefone": "5547999992928",
        "ultInteracao": "Compra",
        "dataInteracao": "05/11/2024"
        },
        {
        "id": "28488792",
        "name": "Carlos Roberto Ferreira Hartl",
        "comPromocional": true,
        "numCompras": 1,
        "email": "hartl_81@hotmail.com",
        "genero": "M",
        "dataNasc": "30 Abr.",
        "telefone": "3188312448",
        "ultInteracao": "Compra",
        "dataInteracao": "05/11/2024"
        },
        {
        "id": "143510428",
        "name": "Luiz Fernando Godinho de Almeida",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luiz-godin@hotmail.com",
        "genero": "M",
        "dataNasc": "04 Out.",
        "telefone": " 31-9318-6163",
        "ultInteracao": "Compra",
        "dataInteracao": "04/11/2024"
        },
        {
        "id": "476085860",
        "name": "Leandro Mauricio Pena",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leandromauriciop23@gmail.com",
        "genero": "M",
        "dataNasc": "23 Jan.",
        "telefone": "5533988374558",
        "ultInteracao": "Compra",
        "dataInteracao": "04/11/2024"
        },
        {
        "id": "45900931",
        "name": "Oderli Sergio Garcia",
        "comPromocional": false,
        "numCompras": 1,
        "email": "oderlisergio@hotmail.com",
        "genero": "",
        "dataNasc": "01 Out.",
        "telefone": "1791488355",
        "ultInteracao": "Compra",
        "dataInteracao": "04/11/2024"
        },
        {
        "id": "83415095",
        "name": "Douglas Ferreira Linhares",
        "comPromocional": true,
        "numCompras": 1,
        "email": "linharesd14@yahoo.com.br",
        "genero": "M",
        "dataNasc": "12 Abr.",
        "telefone": "3187875605",
        "ultInteracao": "Compra",
        "dataInteracao": "04/11/2024"
        },
        {
        "id": "330730900",
        "name": "Saul Silva de Lima",
        "comPromocional": true,
        "numCompras": 1,
        "email": "saullima88@gmail.com",
        "genero": "M",
        "dataNasc": "18 Out.",
        "telefone": "5535991338726",
        "ultInteracao": "Compra",
        "dataInteracao": "04/11/2024"
        },
        {
        "id": "2074992674",
        "name": "Pedro Henrique de Aquino Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "Aquinophas@gmail.com",
        "genero": "M",
        "dataNasc": "17 Mai.",
        "telefone": "5531987731896",
        "ultInteracao": "Compra",
        "dataInteracao": "02/11/2024"
        },
        {
        "id": "216354362",
        "name": "Vitor da Cruz Conceicao",
        "comPromocional": true,
        "numCompras": 1,
        "email": "vitor.cruz.investimentos@gmail.com",
        "genero": "M",
        "dataNasc": "03 Jun.",
        "telefone": "21985190456",
        "ultInteracao": "Compra",
        "dataInteracao": "02/11/2024"
        },
        {
        "id": "140897145",
        "name": "Aercio de Jesus Muniz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "aerciomuniz@hotmail.com",
        "genero": "M",
        "dataNasc": "11 Out.",
        "telefone": " 73-8172-8751",
        "ultInteracao": "Compra",
        "dataInteracao": "02/11/2024"
        },
        {
        "id": "415129295",
        "name": "Sebastiao Raimundo Mariano",
        "comPromocional": true,
        "numCompras": 1,
        "email": "seblamim@yahoo.com.br",
        "genero": "M",
        "dataNasc": "20 Ago.",
        "telefone": "5531984893921",
        "ultInteracao": "Compra",
        "dataInteracao": "01/11/2024"
        },
        {
        "id": "703969",
        "name": "Pablo Lucio de Moraes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "plmoraesrj@gmail.com",
        "genero": "M",
        "dataNasc": "16 Abr.",
        "telefone": "21998568069",
        "ultInteracao": "Compra",
        "dataInteracao": "01/11/2024"
        },
        {
        "id": "107660079",
        "name": "Allan Eustaquio Alves da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "allaneustaquioalvesdasilva6@gmail.com",
        "genero": "",
        "dataNasc": "05 Jun.",
        "telefone": " 3888170566",
        "ultInteracao": "Compra",
        "dataInteracao": "31/10/2024"
        },
        {
        "id": "542619578",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "megasolarac@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "31/10/2024"
        },
        {
        "id": "1058775057",
        "name": "Sidinei Aparecido Caetano",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sidineiaparecido158@gmail.com",
        "genero": "M",
        "dataNasc": "11 Ago.",
        "telefone": "5531971459026",
        "ultInteracao": "Compra",
        "dataInteracao": "31/10/2024"
        },
        {
        "id": "29253768",
        "name": "Jose Tadeo Hidaka",
        "comPromocional": true,
        "numCompras": 1,
        "email": "hyromotors@hotmail.com",
        "genero": "M",
        "dataNasc": "28 Jul.",
        "telefone": "45544853 - 940040483",
        "ultInteracao": "Compra",
        "dataInteracao": "31/10/2024"
        },
        {
        "id": "158436033",
        "name": "Lucas Dos Santos Ribeiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lucasribeiro63@live.com",
        "genero": "M",
        "dataNasc": "21 Dez.",
        "telefone": " 3196185688",
        "ultInteracao": "Compra",
        "dataInteracao": "30/10/2024"
        },
        {
        "id": "277122870",
        "name": "Bruna Suellen Stefanie Do Amaral",
        "comPromocional": true,
        "numCompras": 1,
        "email": "amaral_brunasuellen@hotmail.com",
        "genero": "",
        "dataNasc": "01 Out.",
        "telefone": "5531988181687",
        "ultInteracao": "Compra",
        "dataInteracao": "30/10/2024"
        },
        {
        "id": "2065409319",
        "name": "Wanderson Mendes Ribeiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wandinhoribeiro@hotmail.com",
        "genero": "M",
        "dataNasc": "12 Jan.",
        "telefone": "5531991913510",
        "ultInteracao": "Compra",
        "dataInteracao": "30/10/2024"
        },
        {
        "id": "79330101",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rai.virtual@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "15991781828",
        "ultInteracao": "Compra",
        "dataInteracao": "30/10/2024"
        },
        {
        "id": "594039511",
        "name": "Miguel Do Carmo Almeida Torres",
        "comPromocional": true,
        "numCompras": 1,
        "email": "migue.almeida.torres@gmail.com",
        "genero": "M",
        "dataNasc": "27 Abr.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "30/10/2024"
        },
        {
        "id": "4782304",
        "name": "Vitor Gomes Marques",
        "comPromocional": false,
        "numCompras": 1,
        "email": "vitorgomesmarques@gmail.com",
        "genero": "M",
        "dataNasc": "12 Mar.",
        "telefone": "31982900144",
        "ultInteracao": "Compra",
        "dataInteracao": "30/10/2024"
        },
        {
        "id": "1212969122",
        "name": "Marcos Paulo da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rosesenha31@gmail.com",
        "genero": "M",
        "dataNasc": "02 Jul.",
        "telefone": "44999373930",
        "ultInteracao": "Compra",
        "dataInteracao": "30/10/2024"
        },
        {
        "id": "391232991",
        "name": "Toni Ramos Ferreira",
        "comPromocional": true,
        "numCompras": 5,
        "email": "toni.vw@yahoo.com",
        "genero": "M",
        "dataNasc": "13 Jul.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "29/10/2024"
        },
        {
        "id": "1228155469",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jlcrental.junior@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531999536206",
        "ultInteracao": "Compra",
        "dataInteracao": "28/10/2024"
        },
        {
        "id": "657316389",
        "name": "Luiz Carlos Simoes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lcsimoes11@hotmail.com",
        "genero": "M",
        "dataNasc": "11 Nov.",
        "telefone": " 21996499360",
        "ultInteracao": "Compra",
        "dataInteracao": "28/10/2024"
        },
        {
        "id": "517642653",
        "name": "Celestino de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "centralrefrigeracao2016@gmail.com",
        "genero": "M",
        "dataNasc": "27 Ago.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "23/10/2024"
        },
        {
        "id": "101257575",
        "name": "Gilmar Serafim de Paiva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gilmarserafim@unipac.br",
        "genero": "M",
        "dataNasc": "31 Dez.",
        "telefone": " 32 88214140",
        "ultInteracao": "Compra",
        "dataInteracao": "27/10/2024"
        },
        {
        "id": "242711524",
        "name": "Lucas Ferreira Faria",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lucas.seintrha.pmcg@gmail.com",
        "genero": "M",
        "dataNasc": "06 Abr.",
        "telefone": " 67 991745799",
        "ultInteracao": "Compra",
        "dataInteracao": "27/10/2024"
        },
        {
        "id": "39160003",
        "name": "Lincoln Baracho Pires de Paula",
        "comPromocional": true,
        "numCompras": 2,
        "email": "tstlincoln@yahoo.com.br",
        "genero": "M",
        "dataNasc": "20 Fev.",
        "telefone": "03187278597",
        "ultInteracao": "Compra",
        "dataInteracao": "27/10/2024"
        },
        {
        "id": "85212201",
        "name": "Rafael Henrique Rabelo Vasconcelos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rafael_.adm@hotmail.com",
        "genero": "M",
        "dataNasc": "07 Jan.",
        "telefone": "31998308866",
        "ultInteracao": "Compra",
        "dataInteracao": "26/10/2024"
        },
        {
        "id": "1709557030",
        "name": "Cleiton Ribeiro da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cleitonribeirodasilva2023@gmail.com",
        "genero": "M",
        "dataNasc": "11 Out.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "26/10/2024"
        },
        {
        "id": "86863106",
        "name": "Alberto Carlos da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alberto_carlos33@yahoo.com",
        "genero": "M",
        "dataNasc": "08 Jan.",
        "telefone": "(3288170793",
        "ultInteracao": "Compra",
        "dataInteracao": "25/10/2024"
        },
        {
        "id": "623815161",
        "name": "Jaime Luis de Oliveira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "jaimeluisfh4@gmail.com",
        "genero": "M",
        "dataNasc": "16 Abr.",
        "telefone": "5567996438400",
        "ultInteracao": "Compra",
        "dataInteracao": "25/10/2024"
        },
        {
        "id": "216823590",
        "name": "Wenderson Marcelino Martins",
        "comPromocional": true,
        "numCompras": 1,
        "email": "deborah.bhorta@hotmail.com",
        "genero": "M",
        "dataNasc": "02 Jun.",
        "telefone": " 31988241920",
        "ultInteracao": "Compra",
        "dataInteracao": "25/10/2024"
        },
        {
        "id": "101881491",
        "name": "Marcelo Goncalves Lourenco",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcelo.goncalves.lourenco@gmail.com",
        "genero": "M",
        "dataNasc": "28 Nov.",
        "telefone": "(21)91040950",
        "ultInteracao": "Compra",
        "dataInteracao": "25/10/2024"
        },
        {
        "id": "35144557",
        "name": "Deilton Ribeiro Campos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "benaldoreformadora@gmail.com",
        "genero": "M",
        "dataNasc": "22 Abr.",
        "telefone": "2127345544",
        "ultInteracao": "Compra",
        "dataInteracao": "25/10/2024"
        },
        {
        "id": "455333068",
        "name": "Dyego Soares Farias",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dyegofariass03@gmail.com",
        "genero": "M",
        "dataNasc": "03 Mar.",
        "telefone": "5583999364923",
        "ultInteracao": "Compra",
        "dataInteracao": "24/10/2024"
        },
        {
        "id": "187815063",
        "name": "Jose Luiz de Magalhaes Ianelli",
        "comPromocional": true,
        "numCompras": 2,
        "email": "tlmq7092@gmail.com",
        "genero": "M",
        "dataNasc": "20 Mai.",
        "telefone": " 31991957226",
        "ultInteracao": "Compra",
        "dataInteracao": "24/10/2024"
        },
        {
        "id": "23804452",
        "name": "Claudio de Oliveira Lacerda",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lacerdaclaudio@yahoo.com.br",
        "genero": "M",
        "dataNasc": "12 Out.",
        "telefone": "03134441386",
        "ultInteracao": "Compra",
        "dataInteracao": "24/10/2024"
        },
        {
        "id": "2054345781",
        "name": "Guilherme Ernesto da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "hernesto.dasilva@gmail.com",
        "genero": "M",
        "dataNasc": "10 Jun.",
        "telefone": "5531991094959",
        "ultInteracao": "Compra",
        "dataInteracao": "24/10/2024"
        },
        {
        "id": "146718699",
        "name": "Eduardo de Queiroz Rocha",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eduardoqrocha@gmail.com",
        "genero": "M",
        "dataNasc": "19 Mai.",
        "telefone": " (31)91589942",
        "ultInteracao": "Compra",
        "dataInteracao": "24/10/2024"
        },
        {
        "id": "140806337",
        "name": "Rogerio de Sousa Coelho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "roger.scoelho@bol.com.br",
        "genero": "M",
        "dataNasc": "28 Mai.",
        "telefone": "11940228978",
        "ultInteracao": "Compra",
        "dataInteracao": "23/10/2024"
        },
        {
        "id": "473001959",
        "name": "Renato Marques de Aguiar",
        "comPromocional": false,
        "numCompras": 1,
        "email": "renatoaguiar0307@gmail.com",
        "genero": "M",
        "dataNasc": "03 Mar.",
        "telefone": "28999174360",
        "ultInteracao": "Compra",
        "dataInteracao": "23/10/2024"
        },
        {
        "id": "2052342469",
        "name": "Thomaz Sales Teixeira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thomazsales@hotmail.com",
        "genero": "M",
        "dataNasc": "28 Mai.",
        "telefone": "5531997527900",
        "ultInteracao": "Compra",
        "dataInteracao": "23/10/2024"
        },
        {
        "id": "2053374684",
        "name": " ",
        "comPromocional": true,
        "numCompras": 4,
        "email": "jbrant@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5521999669090",
        "ultInteracao": "Compra",
        "dataInteracao": "22/10/2024"
        },
        {
        "id": "2053366670",
        "name": "Danilo Borges de Castro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carboteck.boschservice@gmail.com",
        "genero": "M",
        "dataNasc": "08 Fev.",
        "telefone": "55379983-0167",
        "ultInteracao": "Compra",
        "dataInteracao": "22/10/2024"
        },
        {
        "id": "183250545",
        "name": "Leticia Costa Maia",
        "comPromocional": true,
        "numCompras": 2,
        "email": "lehcmaya@hotmail.com",
        "genero": "",
        "dataNasc": "25 Fev.",
        "telefone": "31395896689",
        "ultInteracao": "Compra",
        "dataInteracao": "22/10/2024"
        },
        {
        "id": "781223001",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "financeiro@sn.ind.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "3135124200",
        "ultInteracao": "Compra",
        "dataInteracao": "22/10/2024"
        },
        {
        "id": "79084984",
        "name": "Rodolfo Guillermo Kam Chings Vielma",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rododina@hotmail.com",
        "genero": "M",
        "dataNasc": "21 Dez.",
        "telefone": "11940301755",
        "ultInteracao": "Compra",
        "dataInteracao": "22/10/2024"
        },
        {
        "id": "239473817",
        "name": " ",
        "comPromocional": true,
        "numCompras": 2,
        "email": "kerolaynefelipe_15@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": " 024992564897",
        "ultInteracao": "Compra",
        "dataInteracao": "22/10/2024"
        },
        {
        "id": "203855898",
        "name": "Danielli Santos Souza",
        "comPromocional": true,
        "numCompras": 2,
        "email": "dani.souza@outlook.com.br",
        "genero": "",
        "dataNasc": "17 Ago.",
        "telefone": " 04299911746",
        "ultInteracao": "Compra",
        "dataInteracao": "21/10/2024"
        },
        {
        "id": "154075056",
        "name": "Bruno Cesar Viana Barbosa",
        "comPromocional": true,
        "numCompras": 2,
        "email": "autosocorrobrunoard@hotmail.com",
        "genero": "M",
        "dataNasc": "05 Fev.",
        "telefone": " (32)84227646",
        "ultInteracao": "Compra",
        "dataInteracao": "21/10/2024"
        },
        {
        "id": "81183667",
        "name": "Silvano Nogueira de Faria",
        "comPromocional": true,
        "numCompras": 1,
        "email": "noguedefaria@hotmail.com",
        "genero": "M",
        "dataNasc": "07 Set.",
        "telefone": "3184267140",
        "ultInteracao": "Compra",
        "dataInteracao": "20/10/2024"
        },
        {
        "id": "128616626",
        "name": "Wagner Eustaquio Dias",
        "comPromocional": true,
        "numCompras": 1,
        "email": "prevwagner1@hotmail.com",
        "genero": "M",
        "dataNasc": "12 Mai.",
        "telefone": " 525336",
        "ultInteracao": "Compra",
        "dataInteracao": "19/10/2024"
        },
        {
        "id": "1698455271",
        "name": "Leonardo Sergio Moreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leonardosergiomoreira8@gmail.com",
        "genero": "M",
        "dataNasc": "01 Mar.",
        "telefone": "5535998427974",
        "ultInteracao": "Compra",
        "dataInteracao": "17/10/2024"
        },
        {
        "id": "385249687",
        "name": "Ilaci Lopes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "produtosdelimpeza2016@gmail.com",
        "genero": "",
        "dataNasc": "31 Ago.",
        "telefone": "5531984201415",
        "ultInteracao": "Compra",
        "dataInteracao": "17/10/2024"
        },
        {
        "id": "66413900",
        "name": "Markus Vinicius Faria Gomes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "markusvinicius@windowslive.com",
        "genero": "M",
        "dataNasc": "31 Jan.",
        "telefone": "31991069936",
        "ultInteracao": "Compra",
        "dataInteracao": "17/10/2024"
        },
        {
        "id": "52333724",
        "name": "Jeferson Mariano de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jefersonmariano84@hotmail.com",
        "genero": "M",
        "dataNasc": "16 Mai.",
        "telefone": "3131998846658",
        "ultInteracao": "Compra",
        "dataInteracao": "16/10/2024"
        },
        {
        "id": "206476299",
        "name": "Marcos Jeani Fabro",
        "comPromocional": true,
        "numCompras": 2,
        "email": "marcos.fabro123@gmail.com",
        "genero": "M",
        "dataNasc": "03 Jun.",
        "telefone": " 043 99792208",
        "ultInteracao": "Compra",
        "dataInteracao": "16/10/2024"
        },
        {
        "id": "153073504",
        "name": "Jose Julio de Melo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "melo.jjm@gmail.com",
        "genero": "M",
        "dataNasc": "10 Jun.",
        "telefone": " 31 71305469",
        "ultInteracao": "Compra",
        "dataInteracao": "16/10/2024"
        },
        {
        "id": "201475062",
        "name": "Marcio Eugenio de Barros Paz",
        "comPromocional": false,
        "numCompras": 1,
        "email": "marcioebp@gmail.com",
        "genero": "M",
        "dataNasc": "13 Mar.",
        "telefone": " 87 98812-3980",
        "ultInteracao": "Compra",
        "dataInteracao": "16/10/2024"
        },
        {
        "id": "147140932",
        "name": "Luzinete Assis Chaves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luzineteassischaves@yahoo.com.br",
        "genero": "",
        "dataNasc": "16 Mai.",
        "telefone": " 3191209478",
        "ultInteracao": "Compra",
        "dataInteracao": "15/10/2024"
        },
        {
        "id": "378098848",
        "name": "Edilson Andrade Diniz",
        "comPromocional": false,
        "numCompras": 1,
        "email": "edilson3andrade@gmail.com",
        "genero": "M",
        "dataNasc": "28 Out.",
        "telefone": "5531996611082",
        "ultInteracao": "Compra",
        "dataInteracao": "15/10/2024"
        },
        {
        "id": "567540755",
        "name": "Mirian Pereira Viana Queiroz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "viana.mirian93@gmail.com",
        "genero": "",
        "dataNasc": "09 Jun.",
        "telefone": "92994443990",
        "ultInteracao": "Compra",
        "dataInteracao": "15/10/2024"
        },
        {
        "id": "327102200",
        "name": "Remulo Magalhaes Correia",
        "comPromocional": true,
        "numCompras": 1,
        "email": "remulomagalhaes@gmail.com",
        "genero": "M",
        "dataNasc": "16 Dez.",
        "telefone": "5531987490743",
        "ultInteracao": "Compra",
        "dataInteracao": "15/10/2024"
        },
        {
        "id": "271393271",
        "name": "Osni Vergilio",
        "comPromocional": true,
        "numCompras": 1,
        "email": "osni.vergilio1@gmail.com",
        "genero": "M",
        "dataNasc": "10 Ago.",
        "telefone": "5511995387986",
        "ultInteracao": "Compra",
        "dataInteracao": "14/10/2024"
        },
        {
        "id": "91037263",
        "name": "Vinicius Sales Wardi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "viniciuswardi@yahoo.com.br",
        "genero": "M",
        "dataNasc": "03 Abr.",
        "telefone": "3135417308",
        "ultInteracao": "Compra",
        "dataInteracao": "14/10/2024"
        },
        {
        "id": "99506823",
        "name": "Pablo Andreolli Ferreira Alves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "andreolli17@hotmail.com",
        "genero": "M",
        "dataNasc": "26 Ago.",
        "telefone": "03136721151",
        "ultInteracao": "Compra",
        "dataInteracao": "13/10/2024"
        },
        {
        "id": "767605401",
        "name": "Roseli Ferreira Vargas da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rovargasterapias@gmail.com",
        "genero": "",
        "dataNasc": "08 Out.",
        "telefone": "5521992284399",
        "ultInteracao": "Compra",
        "dataInteracao": "13/10/2024"
        },
        {
        "id": "147749938",
        "name": "Luis Henrique Bonamigo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luis_bonamigo@hotmail.com",
        "genero": "",
        "dataNasc": "17 Nov.",
        "telefone": " 54 91252468",
        "ultInteracao": "Compra",
        "dataInteracao": "12/10/2024"
        },
        {
        "id": "32882756",
        "name": "Crislande Pimentel Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cris_lande@hotmail.com",
        "genero": "",
        "dataNasc": "13 Nov.",
        "telefone": "075999289094",
        "ultInteracao": "Compra",
        "dataInteracao": "12/10/2024"
        },
        {
        "id": "490035068",
        "name": "Jose Pereira de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jjbbir@gmail.com",
        "genero": "M",
        "dataNasc": "03 Mai.",
        "telefone": "21976175779",
        "ultInteracao": "Compra",
        "dataInteracao": "12/10/2024"
        },
        {
        "id": "1430108444",
        "name": "Luiz Carlos Alves Fernandes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lufcarlcaf@gmail.com",
        "genero": "M",
        "dataNasc": "08 Out.",
        "telefone": "5521964181887",
        "ultInteracao": "Compra",
        "dataInteracao": "11/10/2024"
        },
        {
        "id": "586115217",
        "name": " ",
        "comPromocional": false,
        "numCompras": 1,
        "email": "etipessoa@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "5585996130051",
        "ultInteracao": "Compra",
        "dataInteracao": "11/10/2024"
        },
        {
        "id": "239782819",
        "name": "Douglas Nascimento Tavares Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "douglas.nts@hotmail.com",
        "genero": "M",
        "dataNasc": "03 Ago.",
        "telefone": "5562991508275",
        "ultInteracao": "Compra",
        "dataInteracao": "11/10/2024"
        },
        {
        "id": "48677471",
        "name": "Raul Amaro de Oliveira Lanari",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ralanari@gmail.com",
        "genero": "M",
        "dataNasc": "14 Nov.",
        "telefone": "3132822698",
        "ultInteracao": "Compra",
        "dataInteracao": "10/10/2024"
        },
        {
        "id": "243454866",
        "name": "Patricia de Castro Rispoli Alves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "patyrispoli@yahoo.com.br",
        "genero": "",
        "dataNasc": "21 Mar.",
        "telefone": "34984029494",
        "ultInteracao": "Compra",
        "dataInteracao": "10/10/2024"
        },
        {
        "id": "130849176",
        "name": "Fernando Alex Geraldo da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fernandoalex17@gmail.com",
        "genero": "M",
        "dataNasc": "28 Ago.",
        "telefone": " 3235514501",
        "ultInteracao": "Compra",
        "dataInteracao": "10/10/2024"
        },
        {
        "id": "450681648",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "financeiro@clubetcar.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "77999135420",
        "ultInteracao": "Compra",
        "dataInteracao": "07/10/2024"
        },
        {
        "id": "2029457718",
        "name": "Lucio de Barros Machado Quintao",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lucioquintao@gmail.com",
        "genero": "M",
        "dataNasc": "01 Mai.",
        "telefone": "5531994963336",
        "ultInteracao": "Compra",
        "dataInteracao": "09/10/2024"
        },
        {
        "id": "59195532",
        "name": "Iago Luiz Honorio de Carvalho",
        "comPromocional": false,
        "numCompras": 1,
        "email": "iagoluiz_10@hotmail.com",
        "genero": "M",
        "dataNasc": "30 Mar.",
        "telefone": "03488235450",
        "ultInteracao": "Compra",
        "dataInteracao": "09/10/2024"
        },
        {
        "id": "422447015",
        "name": "Helbert Rezende Soares Filho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "helbert.rezende2000@gmail.com",
        "genero": "M",
        "dataNasc": "28 Dez.",
        "telefone": "5531997398309",
        "ultInteracao": "Compra",
        "dataInteracao": "09/10/2024"
        },
        {
        "id": "35066673",
        "name": "Paulo Alexandre da Silva Vasconcelos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alexandre_scot@hotmail.com",
        "genero": "M",
        "dataNasc": "11 Ago.",
        "telefone": "31997788472",
        "ultInteracao": "Compra",
        "dataInteracao": "09/10/2024"
        },
        {
        "id": "162551080",
        "name": "Rogerio da Silva Mendes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "uccmp3@gmail.com",
        "genero": "M",
        "dataNasc": "14 Mai.",
        "telefone": " (15)981112828",
        "ultInteracao": "Compra",
        "dataInteracao": "08/10/2024"
        },
        {
        "id": "345172699",
        "name": "Simone de Araujo Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "simonedearaujo75@gmail.com",
        "genero": "",
        "dataNasc": "21 Jun.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "08/10/2024"
        },
        {
        "id": "159223491",
        "name": "Moises Cassio de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "moisescassio@yahoo.com.br",
        "genero": "M",
        "dataNasc": "08 Jun.",
        "telefone": " 3197743401",
        "ultInteracao": "Compra",
        "dataInteracao": "08/10/2024"
        },
        {
        "id": "238430997",
        "name": "Rafael Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rafaelbhboy@hotmail.com",
        "genero": "M",
        "dataNasc": "08 Nov.",
        "telefone": " 31991235883",
        "ultInteracao": "Compra",
        "dataInteracao": "07/10/2024"
        },
        {
        "id": "71271839",
        "name": "Wilson de Freitas Abreu",
        "comPromocional": true,
        "numCompras": 2,
        "email": "wilsonbhmg@hotmail.com",
        "genero": "M",
        "dataNasc": "17 Fev.",
        "telefone": "31987075754",
        "ultInteracao": "Compra",
        "dataInteracao": "07/10/2024"
        },
        {
        "id": "202626967",
        "name": "Claudinei de Paiva Barbosa",
        "comPromocional": true,
        "numCompras": 2,
        "email": "claudineibarbosa22@gmail.com",
        "genero": "M",
        "dataNasc": "15 Abr.",
        "telefone": " 31982329943",
        "ultInteracao": "Compra",
        "dataInteracao": "07/10/2024"
        },
        {
        "id": "215148456",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dv_br@yahoo.com",
        "genero": "",
        "dataNasc": "",
        "telefone": " 12 9 81274797",
        "ultInteracao": "Compra",
        "dataInteracao": "06/10/2024"
        },
        {
        "id": "98033985",
        "name": "Marcelo Gualberto Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcelogualbertosilva@yahoo.com.br",
        "genero": "M",
        "dataNasc": "31 Dez.",
        "telefone": "3134281747",
        "ultInteracao": "Compra",
        "dataInteracao": "06/10/2024"
        },
        {
        "id": "54000992",
        "name": "Elias Jose de Faria",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eliasnorcfaria@gmail.com",
        "genero": "M",
        "dataNasc": "25 Out.",
        "telefone": "31992184747",
        "ultInteracao": "Compra",
        "dataInteracao": "04/10/2024"
        },
        {
        "id": "5816193",
        "name": "Thiago Daniel Baltazar de Souza Pinto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thiago.daniel@icloud.com",
        "genero": "M",
        "dataNasc": "20 Jun.",
        "telefone": "12981751869",
        "ultInteracao": "Compra",
        "dataInteracao": "03/10/2024"
        },
        {
        "id": "120605211",
        "name": "Gilcimar Fidelis da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gilcimarfidelis@gmail.com",
        "genero": "",
        "dataNasc": "22 Dez.",
        "telefone": " 3191950018",
        "ultInteracao": "Compra",
        "dataInteracao": "03/10/2024"
        },
        {
        "id": "432040215",
        "name": "Weslley Henrique de Freitas",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wfreitas878@gmail.com",
        "genero": "M",
        "dataNasc": "12 Jan.",
        "telefone": "19989683355",
        "ultInteracao": "Compra",
        "dataInteracao": "03/10/2024"
        },
        {
        "id": "142830324",
        "name": "Fernanda Miranda Carvalho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fe.miranda@yahoo.com.br",
        "genero": "",
        "dataNasc": "02 Abr.",
        "telefone": " 3188392065",
        "ultInteracao": "Compra",
        "dataInteracao": "03/10/2024"
        },
        {
        "id": "257976055",
        "name": "Mario Cicero Moreira Meirelles",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mcmmeireles@gmail.com",
        "genero": "M",
        "dataNasc": "29 Nov.",
        "telefone": "31 9 98670388",
        "ultInteracao": "Compra",
        "dataInteracao": "03/10/2024"
        },
        {
        "id": "2018360766",
        "name": "Sergio Fernando Ewald",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sfeewald@uol.com.br",
        "genero": "M",
        "dataNasc": "12 Jan.",
        "telefone": "5527981110874",
        "ultInteracao": "Compra",
        "dataInteracao": "02/10/2024"
        },
        {
        "id": "2015549939",
        "name": "Jose Ignacio Vega Fernandez",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nachovf@gmail.com",
        "genero": "M",
        "dataNasc": "22 Ago.",
        "telefone": "5581996600801",
        "ultInteracao": "Compra",
        "dataInteracao": "02/10/2024"
        },
        {
        "id": "2017971034",
        "name": "Filipe de Oliveira Rosa da Silva",
        "comPromocional": true,
        "numCompras": 2,
        "email": "filipeo.rosa@gmail.com",
        "genero": "M",
        "dataNasc": "25 Fev.",
        "telefone": "5531986284070",
        "ultInteracao": "Compra",
        "dataInteracao": "02/10/2024"
        },
        {
        "id": "2016230490",
        "name": "Antonio Carlos de Figueiredo Ferraz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "acfigueiredoferraz@gmail.com",
        "genero": "M",
        "dataNasc": "07 Mai.",
        "telefone": "551982249672",
        "ultInteracao": "Compra",
        "dataInteracao": "01/10/2024"
        },
        {
        "id": "176351920",
        "name": "Daniele Zacheo Polim",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rodricarpinturas@hotmail.com",
        "genero": "",
        "dataNasc": "21 Jun.",
        "telefone": "16981545329",
        "ultInteracao": "Compra",
        "dataInteracao": "01/10/2024"
        },
        {
        "id": "2012737307",
        "name": " ",
        "comPromocional": false,
        "numCompras": 4,
        "email": "jairpedrozasantanna@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5533991541685",
        "ultInteracao": "Compra",
        "dataInteracao": "30/09/2024"
        },
        {
        "id": "2015238060",
        "name": "Paula Charnaux Macedo",
        "comPromocional": false,
        "numCompras": 1,
        "email": "paulacharnaux@gmail.com",
        "genero": "",
        "dataNasc": "02 Mai.",
        "telefone": "5521987417021",
        "ultInteracao": "Compra",
        "dataInteracao": "30/09/2024"
        },
        {
        "id": "471188597",
        "name": "Juliana Aparecida Trentini Maroni",
        "comPromocional": true,
        "numCompras": 1,
        "email": "julianamaroni.10@gmail.com",
        "genero": "",
        "dataNasc": "03 Fev.",
        "telefone": "5528999959198",
        "ultInteracao": "Compra",
        "dataInteracao": "30/09/2024"
        },
        {
        "id": "96086508",
        "name": "Andre Luiz Fernandes Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "andrevop@gmail.com",
        "genero": "M",
        "dataNasc": "28 Fev.",
        "telefone": "288112 8544",
        "ultInteracao": "Compra",
        "dataInteracao": "29/09/2024"
        },
        {
        "id": "796324400",
        "name": "Jonathan Barreto de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jbarretooliveira@gmail.com",
        "genero": "M",
        "dataNasc": "13 Mar.",
        "telefone": "5511994946788",
        "ultInteracao": "Compra",
        "dataInteracao": "29/09/2024"
        },
        {
        "id": "317054822",
        "name": "Pedro Jacintho Candini Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pedrocandinij@gmail.com",
        "genero": "M",
        "dataNasc": "30 Jun.",
        "telefone": "5531991674138",
        "ultInteracao": "Compra",
        "dataInteracao": "28/09/2024"
        },
        {
        "id": "225043213",
        "name": "Fabricio Silva de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eletricaurbana@gmail.com",
        "genero": "M",
        "dataNasc": "15 Jul.",
        "telefone": " 3237284638",
        "ultInteracao": "Compra",
        "dataInteracao": "28/09/2024"
        },
        {
        "id": "103400143",
        "name": "Sidnei de Oliveira Rodrigues",
        "comPromocional": false,
        "numCompras": 1,
        "email": "sidnei.o.rodrigues@gmail.com",
        "genero": "M",
        "dataNasc": "06 Fev.",
        "telefone": "61 996447772",
        "ultInteracao": "Compra",
        "dataInteracao": "28/09/2024"
        },
        {
        "id": "442043061",
        "name": "Rosane Heusner Marcus",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rosaneheusnermarcus467@gmail.com",
        "genero": "",
        "dataNasc": "18 Fev.",
        "telefone": "67998662831",
        "ultInteracao": "Compra",
        "dataInteracao": "26/09/2024"
        },
        {
        "id": "140480250",
        "name": "Fabio Luther",
        "comPromocional": false,
        "numCompras": 1,
        "email": "fabioluther@yahoo.com.br",
        "genero": "M",
        "dataNasc": "20 Fev.",
        "telefone": "11947585700",
        "ultInteracao": "Compra",
        "dataInteracao": "26/09/2024"
        },
        {
        "id": "42882976",
        "name": "David Alexandre Nazareth",
        "comPromocional": true,
        "numCompras": 1,
        "email": "familianazareth@gmail.com",
        "genero": "M",
        "dataNasc": "04 Nov.",
        "telefone": "3131971767449",
        "ultInteracao": "Compra",
        "dataInteracao": "26/09/2024"
        },
        {
        "id": "617914870",
        "name": "Pierre Emmanuel Felix",
        "comPromocional": true,
        "numCompras": 6,
        "email": "pierresiny@gmail.com",
        "genero": "M",
        "dataNasc": "01 Abr.",
        "telefone": "21991207508",
        "ultInteracao": "Compra",
        "dataInteracao": "25/09/2024"
        },
        {
        "id": "178756715",
        "name": "Robson Deorce Alves",
        "comPromocional": true,
        "numCompras": 4,
        "email": "robsondeorce@gmail.com",
        "genero": "M",
        "dataNasc": "17 Out.",
        "telefone": "27999538948",
        "ultInteracao": "Compra",
        "dataInteracao": "25/09/2024"
        },
        {
        "id": "114809802",
        "name": "Rodrigo Souza",
        "comPromocional": false,
        "numCompras": 1,
        "email": "digofutshow7@gmail.com",
        "genero": "M",
        "dataNasc": "09 Jan.",
        "telefone": " (48) 8436-6569",
        "ultInteracao": "Compra",
        "dataInteracao": "25/09/2024"
        },
        {
        "id": "320601452",
        "name": "Adriana Aparecida de Brito",
        "comPromocional": true,
        "numCompras": 2,
        "email": "adrianabritojm@yahoo.com.br",
        "genero": "",
        "dataNasc": "07 Mai.",
        "telefone": "31985083604",
        "ultInteracao": "Compra",
        "dataInteracao": "25/09/2024"
        },
        {
        "id": "713607126",
        "name": "Pedro Henrique Damasceno Dias",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pedro.hdias@outlook.com",
        "genero": "M",
        "dataNasc": "01 Dez.",
        "telefone": "5531995770590",
        "ultInteracao": "Compra",
        "dataInteracao": "24/09/2024"
        },
        {
        "id": "134982276",
        "name": "Dyego Cimino Belo",
        "comPromocional": true,
        "numCompras": 2,
        "email": "dyegocimino@hotmail.com",
        "genero": "M",
        "dataNasc": "25 Out.",
        "telefone": " 031 85620062",
        "ultInteracao": "Compra",
        "dataInteracao": "24/09/2024"
        },
        {
        "id": "193638545",
        "name": "Felipe Aparecido Ito Lima",
        "comPromocional": true,
        "numCompras": 2,
        "email": "limaitof@outlook.com",
        "genero": "M",
        "dataNasc": "27 Fev.",
        "telefone": "18996451634",
        "ultInteracao": "Compra",
        "dataInteracao": "23/09/2024"
        },
        {
        "id": "274397782",
        "name": "Mateus Conde Dos Reis",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mateuscondereis241294@gmail.com",
        "genero": "M",
        "dataNasc": "24 Dez.",
        "telefone": "32999244246",
        "ultInteracao": "Compra",
        "dataInteracao": "23/09/2024"
        },
        {
        "id": "93583761",
        "name": "Thiago Paschoal Leite Scopacasa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thiagoscopacasa@gmail.com",
        "genero": "M",
        "dataNasc": "27 Jun.",
        "telefone": "1100000000000000",
        "ultInteracao": "Compra",
        "dataInteracao": "22/09/2024"
        },
        {
        "id": "1937577715",
        "name": "Milton Stok",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ucrarru@gmail.com",
        "genero": "M",
        "dataNasc": "17 Ago.",
        "telefone": "5511939024630",
        "ultInteracao": "Compra",
        "dataInteracao": "22/09/2024"
        },
        {
        "id": "14660251",
        "name": "Paulo Matheus Rios Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "matheus.rioos@gmail.com",
        "genero": "",
        "dataNasc": "22 Jul.",
        "telefone": "( 11) 99740 0875",
        "ultInteracao": "Compra",
        "dataInteracao": "20/09/2024"
        },
        {
        "id": "32219825",
        "name": "Ederlanio Correia Leite",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eder@vimara.com.br",
        "genero": "",
        "dataNasc": "19 Jan.",
        "telefone": "11940118013",
        "ultInteracao": "Compra",
        "dataInteracao": "20/09/2024"
        },
        {
        "id": "162936928",
        "name": "Wanderlei Antonio Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wander19702@hotmail.com",
        "genero": "M",
        "dataNasc": "27 Out.",
        "telefone": " 6183420272",
        "ultInteracao": "Compra",
        "dataInteracao": "19/09/2024"
        },
        {
        "id": "145194961",
        "name": "Adilson Lobato de Faria",
        "comPromocional": true,
        "numCompras": 1,
        "email": "adilsonlobato@hotmail.com",
        "genero": "M",
        "dataNasc": "06 Out.",
        "telefone": " 31-96041114",
        "ultInteracao": "Compra",
        "dataInteracao": "19/09/2024"
        },
        {
        "id": "21549171",
        "name": "Pedro Henrique Manteufel Elian",
        "comPromocional": false,
        "numCompras": 2,
        "email": "ph.elian@hotmail.com",
        "genero": "M",
        "dataNasc": "31 Mar.",
        "telefone": "01531988026270",
        "ultInteracao": "Compra",
        "dataInteracao": "19/09/2024"
        },
        {
        "id": "1996434865",
        "name": " ",
        "comPromocional": true,
        "numCompras": 4,
        "email": "thiagoomb@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5531996205616",
        "ultInteracao": "Compra",
        "dataInteracao": "19/09/2024"
        },
        {
        "id": "1214558762",
        "name": "Edimar Jose Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dadaltoaltonivel@gmail.com",
        "genero": "M",
        "dataNasc": "12 Fev.",
        "telefone": "5527999220350",
        "ultInteracao": "Compra",
        "dataInteracao": "19/09/2024"
        },
        {
        "id": "729868887",
        "name": "Heldo Dos Santos de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "heldosantos24@gmail.com",
        "genero": "M",
        "dataNasc": "22 Set.",
        "telefone": "5543999781045",
        "ultInteracao": "Compra",
        "dataInteracao": "18/09/2024"
        },
        {
        "id": "149043518",
        "name": "Laiza Aparecida Gomes Medeiros",
        "comPromocional": true,
        "numCompras": 1,
        "email": "laizamedeiros-adm@hotmail.com",
        "genero": "",
        "dataNasc": "12 Out.",
        "telefone": " 3185902356",
        "ultInteracao": "Compra",
        "dataInteracao": "18/09/2024"
        },
        {
        "id": "139912537",
        "name": "Helen Octaviani Barbosa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "helenoctavianib@gmail.com",
        "genero": "",
        "dataNasc": "11 Out.",
        "telefone": " 31 9756-3054",
        "ultInteracao": "Compra",
        "dataInteracao": "18/09/2024"
        },
        {
        "id": "1994948793",
        "name": "Andreia Almeida Gomes de Queiroz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "queiroz-andreia@hotmail.com",
        "genero": "",
        "dataNasc": "21 Jul.",
        "telefone": "5531984897845",
        "ultInteracao": "Compra",
        "dataInteracao": "18/09/2024"
        },
        {
        "id": "130459388",
        "name": "Agnaldo Reis Esteves",
        "comPromocional": true,
        "numCompras": 3,
        "email": "agnaldo-reis@live.com",
        "genero": "M",
        "dataNasc": "06 Fev.",
        "telefone": " 3197491580",
        "ultInteracao": "Compra",
        "dataInteracao": "17/09/2024"
        },
        {
        "id": "153541805",
        "name": "Bruna Klippel Stein de Magalhaes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alex.columaxx@hotmail.com",
        "genero": "",
        "dataNasc": "29 Set.",
        "telefone": "27998573147",
        "ultInteracao": "Compra",
        "dataInteracao": "17/09/2024"
        },
        {
        "id": "509134363",
        "name": "Carlos Augusto Rezende de Mattos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "guto0404rezende@gmail.com",
        "genero": "M",
        "dataNasc": "04 Abr.",
        "telefone": "5531992122305",
        "ultInteracao": "Compra",
        "dataInteracao": "17/09/2024"
        },
        {
        "id": "281055269",
        "name": "Rodrigo de Freitas Lopes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rodrigolopes32@hotmail.com",
        "genero": "M",
        "dataNasc": "01 Out.",
        "telefone": "031992397816",
        "ultInteracao": "Compra",
        "dataInteracao": "16/09/2024"
        },
        {
        "id": "187781468",
        "name": "Rafael Das Neves Pereira de Almeida",
        "comPromocional": false,
        "numCompras": 1,
        "email": "spfc.rafael@gmail.com",
        "genero": "M",
        "dataNasc": "18 Jan.",
        "telefone": "5567992459689",
        "ultInteracao": "Compra",
        "dataInteracao": "16/09/2024"
        },
        {
        "id": "176147924",
        "name": "Robson Alberico",
        "comPromocional": true,
        "numCompras": 1,
        "email": "albericorobson7@gmail.com",
        "genero": "M",
        "dataNasc": "12 Mar.",
        "telefone": "15988119020",
        "ultInteracao": "Compra",
        "dataInteracao": "16/09/2024"
        },
        {
        "id": "74743368",
        "name": "Paul Guibson Viegas da Fonseca",
        "comPromocional": true,
        "numCompras": 4,
        "email": "paul_viegas@hotmail.com",
        "genero": "M",
        "dataNasc": "21 Jun.",
        "telefone": "31 8908-2129",
        "ultInteracao": "Compra",
        "dataInteracao": "12/09/2024"
        },
        {
        "id": "203625693",
        "name": "Wagton Elias de Araujo Almeida",
        "comPromocional": true,
        "numCompras": 1,
        "email": "automecanicava@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Jul.",
        "telefone": " 33 34151563",
        "ultInteracao": "Compra",
        "dataInteracao": "11/09/2024"
        },
        {
        "id": "236425470",
        "name": "Carlos Antonio Pena de Paula",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carlosppaula289@gmail.com",
        "genero": "M",
        "dataNasc": "20 Out.",
        "telefone": " 21985188983",
        "ultInteracao": "Compra",
        "dataInteracao": "11/09/2024"
        },
        {
        "id": "1133040312",
        "name": "Francisco Carlos Carvalho Fernandes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carlinhosleiloeiro56@gmail.com",
        "genero": "M",
        "dataNasc": "09 Out.",
        "telefone": "35987053957",
        "ultInteracao": "Compra",
        "dataInteracao": "10/09/2024"
        },
        {
        "id": "38777265",
        "name": "Luciano Biscardi Duarte",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lucianobiscardi@hotmail.com",
        "genero": "M",
        "dataNasc": "26 Jan.",
        "telefone": "3136546771",
        "ultInteracao": "Compra",
        "dataInteracao": "10/09/2024"
        },
        {
        "id": "109494530",
        "name": "Matheus de Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "matheuscs_55@hotmail.com",
        "genero": "M",
        "dataNasc": "06 Nov.",
        "telefone": " 03187029387",
        "ultInteracao": "Compra",
        "dataInteracao": "10/09/2024"
        },
        {
        "id": "78481297",
        "name": "Felipe Gabriel de Araujo",
        "comPromocional": true,
        "numCompras": 3,
        "email": "felipegabrielaraujo319@gmail.com",
        "genero": "M",
        "dataNasc": "21 Nov.",
        "telefone": "2137783975",
        "ultInteracao": "Compra",
        "dataInteracao": "10/09/2024"
        },
        {
        "id": "46550995",
        "name": "Emanuel Neto Lamounier de Carvalho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "neocarv@gmail.com",
        "genero": "M",
        "dataNasc": "25 Jul.",
        "telefone": "32991229551",
        "ultInteracao": "Compra",
        "dataInteracao": "10/09/2024"
        },
        {
        "id": "99720197",
        "name": "Emerson Alexandre Zago",
        "comPromocional": true,
        "numCompras": 1,
        "email": "emerson.ale.zago@gmail.com",
        "genero": "M",
        "dataNasc": "03 Jul.",
        "telefone": " (11) 99964-2818",
        "ultInteracao": "Compra",
        "dataInteracao": "09/09/2024"
        },
        {
        "id": "1982322701",
        "name": "Marcia Valeria Mesquita de Almeida",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marciavmesquita@yahoo.com.br",
        "genero": "",
        "dataNasc": "09 Jan.",
        "telefone": "5521997231616",
        "ultInteracao": "Compra",
        "dataInteracao": "09/09/2024"
        },
        {
        "id": "839564166",
        "name": "Rodrigo Maia de Padua",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mpadua@hotmail.com",
        "genero": "M",
        "dataNasc": "14 Fev.",
        "telefone": "5531985247137",
        "ultInteracao": "Compra",
        "dataInteracao": "09/09/2024"
        },
        {
        "id": "180785537",
        "name": "Marcos Pinheiro de Azevedo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcospinheiroazevedo@gmail.com",
        "genero": "M",
        "dataNasc": "25 Mar.",
        "telefone": "33999002628",
        "ultInteracao": "Compra",
        "dataInteracao": "09/09/2024"
        },
        {
        "id": "187266647",
        "name": "Rafael Silveira Martins Alves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "serafinsassistencia@gmail.com",
        "genero": "M",
        "dataNasc": "18 Jul.",
        "telefone": "24998693727",
        "ultInteracao": "Compra",
        "dataInteracao": "09/09/2024"
        },
        {
        "id": "1253379605",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "diogooliver123@icloud.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "09/09/2024"
        },
        {
        "id": "1984331134",
        "name": "Carlos Nascimento",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cn170366@gmail.com",
        "genero": "M",
        "dataNasc": "17 Mar.",
        "telefone": "5531991801861",
        "ultInteracao": "Compra",
        "dataInteracao": "09/09/2024"
        },
        {
        "id": "47695121",
        "name": "Fabricio Magalhaes de Lima",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fabricio.fml@hotmail.com",
        "genero": "M",
        "dataNasc": "31 Mar.",
        "telefone": "1939226347",
        "ultInteracao": "Compra",
        "dataInteracao": "07/09/2024"
        },
        {
        "id": "335445872",
        "name": "Camila de Souza Paganucci",
        "comPromocional": true,
        "numCompras": 1,
        "email": "milapaganucci@gmail.com",
        "genero": "",
        "dataNasc": "16 Jul.",
        "telefone": "5567998817342",
        "ultInteracao": "Compra",
        "dataInteracao": "07/09/2024"
        },
        {
        "id": "750502267",
        "name": "Wilmon Caldas Triani",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wilmontriani@gmail.com",
        "genero": "M",
        "dataNasc": "30 Set.",
        "telefone": "5533987021846",
        "ultInteracao": "Compra",
        "dataInteracao": "06/09/2024"
        },
        {
        "id": "235815385",
        "name": "Claudia Valeria Larrubia Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "clarrubia19@gmail.com",
        "genero": "",
        "dataNasc": "19 Nov.",
        "telefone": " 21987477406",
        "ultInteracao": "Compra",
        "dataInteracao": "06/09/2024"
        },
        {
        "id": "204838520",
        "name": "Laisa Oliveira Dias",
        "comPromocional": true,
        "numCompras": 1,
        "email": "laisa.dias16@gmail.com",
        "genero": "",
        "dataNasc": "16 Jul.",
        "telefone": "11987789587",
        "ultInteracao": "Compra",
        "dataInteracao": "05/09/2024"
        },
        {
        "id": "210073063",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "shopstorevendas@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "35999714050",
        "ultInteracao": "Compra",
        "dataInteracao": "05/09/2024"
        },
        {
        "id": "186927037",
        "name": "Joao Victor",
        "comPromocional": true,
        "numCompras": 1,
        "email": "joaovictorsilva98@outlook.com",
        "genero": "M",
        "dataNasc": "12 Jan.",
        "telefone": " 98 991273712",
        "ultInteracao": "Compra",
        "dataInteracao": "04/09/2024"
        },
        {
        "id": "2138800",
        "name": "Mauro Sergio Constantino",
        "comPromocional": true,
        "numCompras": 1,
        "email": "constantinomaurovh@gmail.com",
        "genero": "M",
        "dataNasc": "15 Mar.",
        "telefone": "21999619609",
        "ultInteracao": "Compra",
        "dataInteracao": "03/09/2024"
        },
        {
        "id": "664088721",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "financeiro@guardiaoprotecaoveicular.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "03/09/2024"
        },
        {
        "id": "1974972108",
        "name": "Nelma Marcolino Resende",
        "comPromocional": false,
        "numCompras": 1,
        "email": "nelmamresende2@gmail.com",
        "genero": "",
        "dataNasc": "08 Fev.",
        "telefone": "5532999757278",
        "ultInteracao": "Compra",
        "dataInteracao": "02/09/2024"
        },
        {
        "id": "282059255",
        "name": "Luiz Carlos Cintra Vasconcelos",
        "comPromocional": true,
        "numCompras": 2,
        "email": "cintrafab1969@gmail.com",
        "genero": "M",
        "dataNasc": "03 Fev.",
        "telefone": "5521983157282",
        "ultInteracao": "Compra",
        "dataInteracao": "02/09/2024"
        },
        {
        "id": "5294292",
        "name": "Eduardo Martins Machado",
        "comPromocional": true,
        "numCompras": 1,
        "email": "eduardo.machado@gmail.com",
        "genero": "M",
        "dataNasc": "18 Jun.",
        "telefone": "21968175360",
        "ultInteracao": "Compra",
        "dataInteracao": "02/09/2024"
        },
        {
        "id": "158965934",
        "name": "Leandro Paulo Nogueira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leandropaulo1990@hotmail.com",
        "genero": "M",
        "dataNasc": "02 Abr.",
        "telefone": " 3198404150",
        "ultInteracao": "Compra",
        "dataInteracao": "02/09/2024"
        },
        {
        "id": "144482005",
        "name": "Wisley Pereira da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wisley@outlook.com",
        "genero": "M",
        "dataNasc": "18 Mar.",
        "telefone": " (11)996918790",
        "ultInteracao": "Compra",
        "dataInteracao": "02/09/2024"
        },
        {
        "id": "64439127",
        "name": "Gilberto Guizelini Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "doctors_giba@yahoo.com.br",
        "genero": "M",
        "dataNasc": "09 Set.",
        "telefone": "011967335145",
        "ultInteracao": "Compra",
        "dataInteracao": "02/09/2024"
        },
        {
        "id": "1973427332",
        "name": "Tulio Rafael Guerra Avellar",
        "comPromocional": false,
        "numCompras": 1,
        "email": "tuliorafaelga@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Fev.",
        "telefone": "5545991016667",
        "ultInteracao": "Compra",
        "dataInteracao": "01/09/2024"
        },
        {
        "id": "151584718",
        "name": "Leandro Luiz Alves Castro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leandrocastro65@gmail.com",
        "genero": "M",
        "dataNasc": "08 Mai.",
        "telefone": "21982422752",
        "ultInteracao": "Compra",
        "dataInteracao": "01/09/2024"
        },
        {
        "id": "124945467",
        "name": "Jhonathan Cancela Correa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jhex0707@hotmail.com",
        "genero": "M",
        "dataNasc": "07 Jul.",
        "telefone": "32999186932",
        "ultInteracao": "Compra",
        "dataInteracao": "31/08/2024"
        },
        {
        "id": "216749867",
        "name": "Renaldo da Cruz Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "renal2souza@gmail.com",
        "genero": "M",
        "dataNasc": "07 Mar.",
        "telefone": " 3133979632",
        "ultInteracao": "Compra",
        "dataInteracao": "31/08/2024"
        },
        {
        "id": "1650314020",
        "name": "Tainara Andressa Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tainaradossantos796@gmail.com",
        "genero": "",
        "dataNasc": "16 Set.",
        "telefone": "5549999141926",
        "ultInteracao": "Compra",
        "dataInteracao": "30/08/2024"
        },
        {
        "id": "1969285502",
        "name": "Luciano Setsuo Sakamoto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lucianosakamoto74@gmail.com",
        "genero": "M",
        "dataNasc": "11 Jan.",
        "telefone": "5515997894831",
        "ultInteracao": "Compra",
        "dataInteracao": "29/08/2024"
        },
        {
        "id": "66734344",
        "name": "Ricardo Alexandre Bertulussi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ricardobertulussi@hotmail.com",
        "genero": "M",
        "dataNasc": "31 Ago.",
        "telefone": "1936310497",
        "ultInteracao": "Compra",
        "dataInteracao": "29/08/2024"
        },
        {
        "id": "1969074970",
        "name": "Marli de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marli.academia@hotmail.com",
        "genero": "",
        "dataNasc": "25 Abr.",
        "telefone": "5531996989232",
        "ultInteracao": "Compra",
        "dataInteracao": "29/08/2024"
        },
        {
        "id": "145695832",
        "name": "Gilberto Miranda",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gilbertomiranda68@yahoo.com",
        "genero": "M",
        "dataNasc": "30 Jul.",
        "telefone": " 31984279539",
        "ultInteracao": "Compra",
        "dataInteracao": "29/08/2024"
        },
        {
        "id": "263560332",
        "name": "Richard Ferreira de Lana",
        "comPromocional": true,
        "numCompras": 1,
        "email": "richardlana.1997@gmail.com",
        "genero": "M",
        "dataNasc": "23 Fev.",
        "telefone": "31980208253",
        "ultInteracao": "Compra",
        "dataInteracao": "29/08/2024"
        },
        {
        "id": "70214098",
        "name": "Eder Jose Fontanive",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fontaniveeder@hotmail.com",
        "genero": "M",
        "dataNasc": "29 Abr.",
        "telefone": "4635322492",
        "ultInteracao": "Compra",
        "dataInteracao": "28/08/2024"
        },
        {
        "id": "355908081",
        "name": "Felipe Domingues Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "contato@clickfrotas.com.br",
        "genero": "M",
        "dataNasc": "23 Mar.",
        "telefone": "11997244948",
        "ultInteracao": "Compra",
        "dataInteracao": "28/08/2024"
        },
        {
        "id": "132069718",
        "name": "Sergio Augusto de Oliveira Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "serginhojunior01@hotmail.com",
        "genero": "M",
        "dataNasc": "01 Jul.",
        "telefone": " 3188185342",
        "ultInteracao": "Compra",
        "dataInteracao": "28/08/2024"
        },
        {
        "id": "120191911",
        "name": "Jefferson Anderson da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "j.ander.s@hotmail.com",
        "genero": "M",
        "dataNasc": "21 Dez.",
        "telefone": "61992459196",
        "ultInteracao": "Compra",
        "dataInteracao": "27/08/2024"
        },
        {
        "id": "224444472",
        "name": "Andreza Cristina Pereira de Lima",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fisiodeza@gmail.com",
        "genero": "",
        "dataNasc": "09 Nov.",
        "telefone": "31971041349",
        "ultInteracao": "Compra",
        "dataInteracao": "27/08/2024"
        },
        {
        "id": "139959806",
        "name": "Luiz Claudio Negrao",
        "comPromocional": true,
        "numCompras": 4,
        "email": "lc.negrao@hotmail.com",
        "genero": "M",
        "dataNasc": "30 Jan.",
        "telefone": " 34-99742213",
        "ultInteracao": "Compra",
        "dataInteracao": "27/08/2024"
        },
        {
        "id": "343928179",
        "name": "Vanessa Werneck Bartoli Pires Grossi",
        "comPromocional": true,
        "numCompras": 1,
        "email": "vwgrossi@gmail.com",
        "genero": "",
        "dataNasc": "15 Mar.",
        "telefone": "5531993837733",
        "ultInteracao": "Compra",
        "dataInteracao": "27/08/2024"
        },
        {
        "id": "520841336",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rekawamoto1@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "15996657788",
        "ultInteracao": "Compra",
        "dataInteracao": "26/08/2024"
        },
        {
        "id": "118254561",
        "name": "Marcos Andre da Silva Siqueira",
        "comPromocional": false,
        "numCompras": 1,
        "email": "marcosgadita_bzs@hotmail.com",
        "genero": "M",
        "dataNasc": "14 Nov.",
        "telefone": "2226231344",
        "ultInteracao": "Compra",
        "dataInteracao": "26/08/2024"
        },
        {
        "id": "1645543331",
        "name": "Thayna da Silva Rodrigues",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thayna16s@hotmail.com",
        "genero": "",
        "dataNasc": "08 Mai.",
        "telefone": "5519996647407",
        "ultInteracao": "Compra",
        "dataInteracao": "24/08/2024"
        },
        {
        "id": "58619727",
        "name": "Ivana de Resende Mendes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ivymendess@yahoo.com.br",
        "genero": "",
        "dataNasc": "07 Dez.",
        "telefone": "31991146408",
        "ultInteracao": "Compra",
        "dataInteracao": "23/08/2024"
        },
        {
        "id": "1960838110",
        "name": "Geraldo Magela da Silva Neto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gemasine@gmail.com",
        "genero": "M",
        "dataNasc": "30 Dez.",
        "telefone": "5531996354506",
        "ultInteracao": "Compra",
        "dataInteracao": "23/08/2024"
        },
        {
        "id": "22749322",
        "name": "Rogerio Pereira Germano",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rogeracao80@gmail.com",
        "genero": "M",
        "dataNasc": "21 Jun.",
        "telefone": "2433433099",
        "ultInteracao": "Compra",
        "dataInteracao": "22/08/2024"
        },
        {
        "id": "167598430",
        "name": "Geraldo Aparecido David",
        "comPromocional": true,
        "numCompras": 1,
        "email": "oficinairmaosdavid@bol.com.br",
        "genero": "M",
        "dataNasc": "27 Nov.",
        "telefone": " 1178676206",
        "ultInteracao": "Compra",
        "dataInteracao": "22/08/2024"
        },
        {
        "id": "257811960",
        "name": "Priscila Marques Cardozo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "priscilamarques27@gmail.com",
        "genero": "",
        "dataNasc": "14 Mai.",
        "telefone": "13988281289",
        "ultInteracao": "Compra",
        "dataInteracao": "22/08/2024"
        },
        {
        "id": "141666524",
        "name": "Luiz Felipe Teixeira Fialho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lftf94@hotmail.com",
        "genero": "M",
        "dataNasc": "26 Jan.",
        "telefone": "21976255718",
        "ultInteracao": "Compra",
        "dataInteracao": "22/08/2024"
        },
        {
        "id": "76222470",
        "name": "Rafael Figueiredo Chagas",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rafaelfchagas@gmail.com",
        "genero": "M",
        "dataNasc": "07 Dez.",
        "telefone": "22997010070",
        "ultInteracao": "Compra",
        "dataInteracao": "21/08/2024"
        },
        {
        "id": "241978715",
        "name": "Pedro Henrique Leao",
        "comPromocional": true,
        "numCompras": 1,
        "email": "inovaautoeletrica@yahoo.com.br",
        "genero": "M",
        "dataNasc": "22 Jul.",
        "telefone": " 33 3412 2682",
        "ultInteracao": "Compra",
        "dataInteracao": "21/08/2024"
        },
        {
        "id": "183625088",
        "name": "Renato Cirino Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "renatocirino8@gmail.com",
        "genero": "M",
        "dataNasc": "29 Mai.",
        "telefone": "13974168469",
        "ultInteracao": "Compra",
        "dataInteracao": "20/08/2024"
        },
        {
        "id": "63302753",
        "name": "Ranniery Felix Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rannierylevita@hotmail.com",
        "genero": "M",
        "dataNasc": "25 Jan.",
        "telefone": "83991667022",
        "ultInteracao": "Compra",
        "dataInteracao": "20/08/2024"
        },
        {
        "id": "278023356",
        "name": "Bruno Gabriel Andrade Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "andradegabriel685@gmail.com",
        "genero": "M",
        "dataNasc": "18 Mai.",
        "telefone": "5521996808236",
        "ultInteracao": "Compra",
        "dataInteracao": "20/08/2024"
        },
        {
        "id": "1955548070",
        "name": "Rodrigo Lino de Freitas",
        "comPromocional": true,
        "numCompras": 1,
        "email": "RODRICAROFICINA@BOL.COM.BR",
        "genero": "M",
        "dataNasc": "05 Jan.",
        "telefone": "5531939124819",
        "ultInteracao": "Compra",
        "dataInteracao": "20/08/2024"
        },
        {
        "id": "101189850",
        "name": "Fabricio de Jesus Pereira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fabriciotkdvp97@gmail.com",
        "genero": "M",
        "dataNasc": "08 Dez.",
        "telefone": "11963691625",
        "ultInteracao": "Compra",
        "dataInteracao": "19/08/2024"
        },
        {
        "id": "325922497",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "oficinagrnovaera@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "3139611733",
        "ultInteracao": "Compra",
        "dataInteracao": "19/08/2024"
        },
        {
        "id": "139064380",
        "name": "Fabio Jose Rodrigues Fritz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "motocar.cr@gmail.com",
        "genero": "M",
        "dataNasc": "08 Nov.",
        "telefone": " 24 22425033",
        "ultInteracao": "Compra",
        "dataInteracao": "19/08/2024"
        },
        {
        "id": "683686949",
        "name": "Jose Augusto Barbosa Neto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "joseaugustto12@gmail.com",
        "genero": "M",
        "dataNasc": "12 Jun.",
        "telefone": "5512997397800",
        "ultInteracao": "Compra",
        "dataInteracao": "18/08/2024"
        },
        {
        "id": "322643179",
        "name": "Gabriel Viana Nunes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gabrielv.nunes@hotmail.com",
        "genero": "M",
        "dataNasc": "05 Jan.",
        "telefone": "5531983107579",
        "ultInteracao": "Compra",
        "dataInteracao": "17/08/2024"
        },
        {
        "id": "1950202670",
        "name": "Gabriel Angelo Ruggio Starling",
        "comPromocional": false,
        "numCompras": 1,
        "email": "gabrielruggio@hotmail.com",
        "genero": "M",
        "dataNasc": "08 Jul.",
        "telefone": "5531987758453",
        "ultInteracao": "Compra",
        "dataInteracao": "16/08/2024"
        },
        {
        "id": "68475718",
        "name": "Ronan Adriano Costa Rocha",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ronan.acr@hotmail.com",
        "genero": "M",
        "dataNasc": "28 Ago.",
        "telefone": " 36431685",
        "ultInteracao": "Compra",
        "dataInteracao": "16/08/2024"
        },
        {
        "id": "128454869",
        "name": "Newton Ney Schmitt Costa Reis",
        "comPromocional": true,
        "numCompras": 1,
        "email": "newton.schmitt59@gmail.com",
        "genero": "M",
        "dataNasc": "29 Jun.",
        "telefone": " 3132140585",
        "ultInteracao": "Compra",
        "dataInteracao": "16/08/2024"
        },
        {
        "id": "532851377",
        "name": "Romildo de Almeida Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rokafe@rokafe.com.br",
        "genero": "M",
        "dataNasc": "02 Abr.",
        "telefone": "1158413472",
        "ultInteracao": "Compra",
        "dataInteracao": "15/08/2024"
        },
        {
        "id": "419866361",
        "name": "Alex Gramolich Ramos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alexgramolich@gmail.com",
        "genero": "M",
        "dataNasc": "14 Set.",
        "telefone": "67992987466",
        "ultInteracao": "Compra",
        "dataInteracao": "14/08/2024"
        },
        {
        "id": "507598304",
        "name": "Ricardo Mendonca Lima",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ricardo.limafmf@gmail.com",
        "genero": "M",
        "dataNasc": "29 Ago.",
        "telefone": "5531983523002",
        "ultInteracao": "Compra",
        "dataInteracao": "14/08/2024"
        },
        {
        "id": "40516965",
        "name": "Silas de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "silas.audioprofissional@yahoo.com.br",
        "genero": "M",
        "dataNasc": "21 Mar.",
        "telefone": "22998804009",
        "ultInteracao": "Compra",
        "dataInteracao": "14/08/2024"
        },
        {
        "id": "75185084",
        "name": "Marcio Rosostolato Machado",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rosostolato@protonmail.com",
        "genero": "M",
        "dataNasc": "25 Nov.",
        "telefone": "31994506779",
        "ultInteracao": "Compra",
        "dataInteracao": "14/08/2024"
        },
        {
        "id": "779898959",
        "name": "Mateus Vitor de Castro Goncalves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mateus0404@gmail.com",
        "genero": "",
        "dataNasc": "04 Abr.",
        "telefone": "37999658082",
        "ultInteracao": "Compra",
        "dataInteracao": "14/08/2024"
        },
        {
        "id": "815820243",
        "name": "Lethicia Pinheiro Lopes",
        "comPromocional": false,
        "numCompras": 1,
        "email": "lethiciapinheirolopes@gmail.com",
        "genero": "",
        "dataNasc": "06 Jun.",
        "telefone": "5524999221838",
        "ultInteracao": "Compra",
        "dataInteracao": "13/08/2024"
        },
        {
        "id": "246792698",
        "name": "Iran Pereira da Silva",
        "comPromocional": false,
        "numCompras": 1,
        "email": "irannsilvaa@gmail.com",
        "genero": "M",
        "dataNasc": "26 Mai.",
        "telefone": " 31975134923",
        "ultInteracao": "Compra",
        "dataInteracao": "13/08/2024"
        },
        {
        "id": "228426198",
        "name": "Jackeline Zunzarren Queiroz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jackzqueiroz@gmail.com",
        "genero": "",
        "dataNasc": "17 Fev.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "12/08/2024"
        },
        {
        "id": "266798142",
        "name": "Antonio Carlos Pires Pinto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "anthonypintto@gmail.com",
        "genero": "M",
        "dataNasc": "10 Nov.",
        "telefone": "21997152008",
        "ultInteracao": "Compra",
        "dataInteracao": "11/08/2024"
        },
        {
        "id": "183374602",
        "name": "Rosenei Martins Estrada",
        "comPromocional": false,
        "numCompras": 1,
        "email": "rosemartins660@hotmail.com",
        "genero": "",
        "dataNasc": "29 Ago.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "11/08/2024"
        },
        {
        "id": "211384483",
        "name": "Reginaldo Chaves Vidal",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rchavesvidal@gmail.com",
        "genero": "M",
        "dataNasc": "09 Mai.",
        "telefone": " 6899719306",
        "ultInteracao": "Compra",
        "dataInteracao": "09/08/2024"
        },
        {
        "id": "200511326",
        "name": "Cristiano Medeiros Felgueiras",
        "comPromocional": true,
        "numCompras": 1,
        "email": "crismedfelg@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Nov.",
        "telefone": " 1171772011",
        "ultInteracao": "Compra",
        "dataInteracao": "09/08/2024"
        },
        {
        "id": "447471365",
        "name": "Nivaldo da Silva Cruz",
        "comPromocional": true,
        "numCompras": 1,
        "email": "nivalsc7@gmail.com",
        "genero": "M",
        "dataNasc": "29 Jul.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "08/08/2024"
        },
        {
        "id": "626070257",
        "name": "Robson Donizetti Pinto Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "robsondonizetti26@gmail.com",
        "genero": "",
        "dataNasc": "17 Out.",
        "telefone": "5537991276271",
        "ultInteracao": "Compra",
        "dataInteracao": "08/08/2024"
        },
        {
        "id": "89278732",
        "name": "Lourenco Bevilaqua",
        "comPromocional": true,
        "numCompras": 1,
        "email": "bevilaqua73@gmail.com",
        "genero": "M",
        "dataNasc": "19 Set.",
        "telefone": "49998361909",
        "ultInteracao": "Compra",
        "dataInteracao": "08/08/2024"
        },
        {
        "id": "414832876",
        "name": "Paulo Roberto Brinholi",
        "comPromocional": false,
        "numCompras": 1,
        "email": "paulorb957@gmail.com",
        "genero": "",
        "dataNasc": "08 Fev.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "08/08/2024"
        },
        {
        "id": "94264607",
        "name": "Tiago Miranda da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "tiago_tms06@hotmail.com",
        "genero": "M",
        "dataNasc": "15 Jun.",
        "telefone": "17991813814",
        "ultInteracao": "Compra",
        "dataInteracao": "08/08/2024"
        },
        {
        "id": "1936515790",
        "name": "Odail Rangel Mote",
        "comPromocional": false,
        "numCompras": 1,
        "email": "ogelzinho@gmail.com",
        "genero": "M",
        "dataNasc": "04 Abr.",
        "telefone": "5521985307612",
        "ultInteracao": "Compra",
        "dataInteracao": "07/08/2024"
        },
        {
        "id": "42626494",
        "name": "Fernando Reis Ribas Watacabe",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fernando.watacabe@gmail.com",
        "genero": "M",
        "dataNasc": "21 Fev.",
        "telefone": "11999621666",
        "ultInteracao": "Compra",
        "dataInteracao": "06/08/2024"
        },
        {
        "id": "1141975",
        "name": "Pedro Emidio Dias Guimaraes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pedg3000@yahoo.com.br",
        "genero": "M",
        "dataNasc": "19 Mar.",
        "telefone": "31996961903",
        "ultInteracao": "Compra",
        "dataInteracao": "06/08/2024"
        },
        {
        "id": "414268018",
        "name": "Fabiano de Oliveira Rocha",
        "comPromocional": true,
        "numCompras": 1,
        "email": "fabianoolirocha@gmail.com",
        "genero": "M",
        "dataNasc": "27 Mai.",
        "telefone": "21970409972",
        "ultInteracao": "Compra",
        "dataInteracao": "06/08/2024"
        },
        {
        "id": "73832618",
        "name": "Renato da Silva Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "renatosf.sc@gmail.com",
        "genero": "",
        "dataNasc": "21 Set.",
        "telefone": "48999242551",
        "ultInteracao": "Compra",
        "dataInteracao": "06/08/2024"
        },
        {
        "id": "721154102",
        "name": "Leonardo Silva Oliveira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leotunr@gmail.com",
        "genero": "M",
        "dataNasc": "09 Fev.",
        "telefone": "31991733689",
        "ultInteracao": "Compra",
        "dataInteracao": "05/08/2024"
        },
        {
        "id": "182766979",
        "name": "Juliano Klann",
        "comPromocional": true,
        "numCompras": 1,
        "email": "julianoklann@catolicasc.org.br",
        "genero": "",
        "dataNasc": "20 Jun.",
        "telefone": "5547999906552",
        "ultInteracao": "Compra",
        "dataInteracao": "05/08/2024"
        },
        {
        "id": "48549344",
        "name": "Wanthuil Jose Pereira Filho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "wanthuil@gmail.com",
        "genero": "M",
        "dataNasc": "17 Out.",
        "telefone": "21997986011",
        "ultInteracao": "Compra",
        "dataInteracao": "04/08/2024"
        },
        {
        "id": "469309071",
        "name": "Carlos Frederico de Bergo Barros",
        "comPromocional": false,
        "numCompras": 1,
        "email": "carlosbergo@gmail.com",
        "genero": "M",
        "dataNasc": "10 Nov.",
        "telefone": "5531983557958",
        "ultInteracao": "Compra",
        "dataInteracao": "03/08/2024"
        },
        {
        "id": "192411352",
        "name": "Silmar Antonio Martins Tavares",
        "comPromocional": false,
        "numCompras": 1,
        "email": "silmarmtavares@hotmail.com",
        "genero": "M",
        "dataNasc": "31 Mai.",
        "telefone": " 86182098",
        "ultInteracao": "Compra",
        "dataInteracao": "03/08/2024"
        },
        {
        "id": "246617472",
        "name": "Renato Dos Santos Faria",
        "comPromocional": true,
        "numCompras": 1,
        "email": "renato.santos.faria@gmail.com",
        "genero": "M",
        "dataNasc": "10 Jun.",
        "telefone": " 11974756350",
        "ultInteracao": "Compra",
        "dataInteracao": "03/08/2024"
        },
        {
        "id": "113610035",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luccar.autocenter@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": " 1158410446",
        "ultInteracao": "Compra",
        "dataInteracao": "03/08/2024"
        },
        {
        "id": "503306610",
        "name": "Roberto Mauro Pereira Campos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "robertomauropereiracampos@gmail.com",
        "genero": "M",
        "dataNasc": "09 Jun.",
        "telefone": "31997605351",
        "ultInteracao": "Compra",
        "dataInteracao": "02/08/2024"
        },
        {
        "id": "164661957",
        "name": "Paulo Henrique Ferreira Dos Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "henryke.paullo@hotmail.com",
        "genero": "M",
        "dataNasc": "21 Jul.",
        "telefone": " 011963668211",
        "ultInteracao": "Compra",
        "dataInteracao": "02/08/2024"
        },
        {
        "id": "289796629",
        "name": "Osmar Dias Rodrigues Cariri",
        "comPromocional": true,
        "numCompras": 1,
        "email": "osmarcariri1@gmail.com",
        "genero": "M",
        "dataNasc": "03 Fev.",
        "telefone": "5511968179895",
        "ultInteracao": "Compra",
        "dataInteracao": "02/08/2024"
        },
        {
        "id": "313611851",
        "name": "Gabriel Antonio Zanardo Folle",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gabrielfolle19@gmail.com",
        "genero": "M",
        "dataNasc": "19 Mai.",
        "telefone": "54991976281",
        "ultInteracao": "Compra",
        "dataInteracao": "02/08/2024"
        },
        {
        "id": "222646624",
        "name": "Patricia Brocco",
        "comPromocional": true,
        "numCompras": 1,
        "email": "patriciabrocco28@hotmail.com",
        "genero": "",
        "dataNasc": "28 Fev.",
        "telefone": " 05192422744",
        "ultInteracao": "Compra",
        "dataInteracao": "02/08/2024"
        },
        {
        "id": "390880833",
        "name": "Zion Cleber de Souza Pereira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "zion.jaragua@gmail.com",
        "genero": "",
        "dataNasc": "14 Nov.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "02/08/2024"
        },
        {
        "id": "198922472",
        "name": "Marcelo Pereira Souto",
        "comPromocional": true,
        "numCompras": 1,
        "email": "marcelopsouto@yahoo.com.br",
        "genero": "M",
        "dataNasc": "02 Jun.",
        "telefone": " (38)999296464",
        "ultInteracao": "Compra",
        "dataInteracao": "01/08/2024"
        },
        {
        "id": "28842446",
        "name": "Leonardo Marcelino Moreno",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leonardommoreno@hotmail.com",
        "genero": "M",
        "dataNasc": "20 Ago.",
        "telefone": "1122182238",
        "ultInteracao": "Compra",
        "dataInteracao": "30/07/2024"
        },
        {
        "id": "60802831",
        "name": "Adro Vanclei Santos Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "vanclei.adro@gmail.com",
        "genero": "M",
        "dataNasc": "26 Fev.",
        "telefone": "71997278178",
        "ultInteracao": "Compra",
        "dataInteracao": "29/07/2024"
        },
        {
        "id": "33877363",
        "name": "Alessandro Resende Parreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sandro.parreira@hotmail.com",
        "genero": "M",
        "dataNasc": "12 Abr.",
        "telefone": "62999423158",
        "ultInteracao": "Compra",
        "dataInteracao": "28/07/2024"
        },
        {
        "id": "164578680",
        "name": "Ricardo da Silva Conceicao",
        "comPromocional": true,
        "numCompras": 1,
        "email": "ricardo.transportesrt@gmail.com",
        "genero": "M",
        "dataNasc": "14 Nov.",
        "telefone": "21969793771",
        "ultInteracao": "Compra",
        "dataInteracao": "28/07/2024"
        },
        {
        "id": "554193166",
        "name": "Yuri Kelwin Sampaio Dutra",
        "comPromocional": true,
        "numCompras": 1,
        "email": "yurikelwin@hotmail.com",
        "genero": "M",
        "dataNasc": "09 Nov.",
        "telefone": "5514991786267",
        "ultInteracao": "Compra",
        "dataInteracao": "28/07/2024"
        },
        {
        "id": "193809168",
        "name": "Marcelo Ferreira da Costa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "costa.marcelo.mfc@gmail.com",
        "genero": "M",
        "dataNasc": "29 Dez.",
        "telefone": " 5194431065",
        "ultInteracao": "Compra",
        "dataInteracao": "27/07/2024"
        },
        {
        "id": "48943272",
        "name": "Ilton Claudio Rodrigues de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "iltonpizzaria@hotmail.com",
        "genero": "M",
        "dataNasc": "25 Jan.",
        "telefone": "4591030838",
        "ultInteracao": "Compra",
        "dataInteracao": "27/07/2024"
        },
        {
        "id": "220535619",
        "name": "Eduarda Mendes Meira Lomeu",
        "comPromocional": true,
        "numCompras": 1,
        "email": "dudalomeu@hotmail.com",
        "genero": "",
        "dataNasc": "02 Jul.",
        "telefone": " 32 9 85170660",
        "ultInteracao": "Compra",
        "dataInteracao": "26/07/2024"
        },
        {
        "id": "48524906",
        "name": "Adenir Joao Rubio Bagli",
        "comPromocional": true,
        "numCompras": 2,
        "email": "ademirbagli1@hotmail.com",
        "genero": "",
        "dataNasc": "26 Jun.",
        "telefone": "3388197070",
        "ultInteracao": "Compra",
        "dataInteracao": "26/07/2024"
        },
        {
        "id": "197215201",
        "name": "Luiz Fernando Alves Sousa",
        "comPromocional": true,
        "numCompras": 1,
        "email": "luizfmail@gmail.com",
        "genero": "M",
        "dataNasc": "07 Mai.",
        "telefone": "31995458482",
        "ultInteracao": "Compra",
        "dataInteracao": "26/07/2024"
        },
        {
        "id": "165528648",
        "name": "Lucinete Silva de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sooretamascapamentos@gmail.com",
        "genero": "",
        "dataNasc": "25 Jul.",
        "telefone": "27996304511",
        "ultInteracao": "Compra",
        "dataInteracao": "26/07/2024"
        },
        {
        "id": "130412722",
        "name": "Catila Maria Lopes de Souza Mauricio da Rocha",
        "comPromocional": true,
        "numCompras": 1,
        "email": "catilasouza@hotmail.com",
        "genero": "",
        "dataNasc": "16 Fev.",
        "telefone": "3732324000",
        "ultInteracao": "Compra",
        "dataInteracao": "25/07/2024"
        },
        {
        "id": "54606219",
        "name": "Igor Samuel Couto de Almeida",
        "comPromocional": true,
        "numCompras": 2,
        "email": "igalmeidadtna@outlook.com",
        "genero": "M",
        "dataNasc": "30 Dez.",
        "telefone": "3835318287",
        "ultInteracao": "Compra",
        "dataInteracao": "24/07/2024"
        },
        {
        "id": "93815709",
        "name": "Gustavo Luiz Rodrigues Cometti",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gustavocometti@hotmail.com",
        "genero": "M",
        "dataNasc": "26 Out.",
        "telefone": "2727999727740",
        "ultInteracao": "Compra",
        "dataInteracao": "24/07/2024"
        },
        {
        "id": "8371048",
        "name": "Gabriel Albino Ponciano Nepomuceno",
        "comPromocional": true,
        "numCompras": 3,
        "email": "gabrielalbino@hotmail.com",
        "genero": "M",
        "dataNasc": "17 Set.",
        "telefone": "3188136713",
        "ultInteracao": "Compra",
        "dataInteracao": "23/07/2024"
        },
        {
        "id": "112437647",
        "name": "Adriano da Silva Buachack",
        "comPromocional": true,
        "numCompras": 1,
        "email": "adrianobuachack@gmail.com",
        "genero": "M",
        "dataNasc": "23 Mai.",
        "telefone": " 43984924299",
        "ultInteracao": "Compra",
        "dataInteracao": "23/07/2024"
        },
        {
        "id": "437248955",
        "name": "Luiz Albino Laureiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lalpparizotto@yahoo.com.br",
        "genero": "M",
        "dataNasc": "27 Jun.",
        "telefone": "5554999214036",
        "ultInteracao": "Compra",
        "dataInteracao": "23/07/2024"
        },
        {
        "id": "170485605",
        "name": "Jose Mendonca Lopes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rafaelatila22@gmail.com",
        "genero": "",
        "dataNasc": "25 Fev.",
        "telefone": "021991947741",
        "ultInteracao": "Compra",
        "dataInteracao": "23/07/2024"
        },
        {
        "id": "277863873",
        "name": "Jose Sergio Batista Ribeiro",
        "comPromocional": true,
        "numCompras": 1,
        "email": "josesergiobatistaribeiro@gmail.com",
        "genero": "M",
        "dataNasc": "31 Mai.",
        "telefone": "35998482743",
        "ultInteracao": "Compra",
        "dataInteracao": "22/07/2024"
        },
        {
        "id": "145499647",
        "name": "Sandra Maria Bezerra Do Nascimento",
        "comPromocional": true,
        "numCompras": 1,
        "email": "sandra_mbn@yahoo.com.br",
        "genero": "",
        "dataNasc": "15 Fev.",
        "telefone": "2134972285",
        "ultInteracao": "Compra",
        "dataInteracao": "21/07/2024"
        },
        {
        "id": "90709358",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lorencel2@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "3791998090",
        "ultInteracao": "Compra",
        "dataInteracao": "21/07/2024"
        },
        {
        "id": "583778980",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "paulistanadeliverypizzaria@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "6135429592",
        "ultInteracao": "Compra",
        "dataInteracao": "20/07/2024"
        },
        {
        "id": "214908959",
        "name": "Gustavo Alves Antunes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gustavo-antunes1@hotmail.com",
        "genero": "M",
        "dataNasc": "22 Mai.",
        "telefone": "5521975515297",
        "ultInteracao": "Compra",
        "dataInteracao": "20/07/2024"
        },
        {
        "id": "217508320",
        "name": "Gisele Gal Santinon",
        "comPromocional": true,
        "numCompras": 1,
        "email": "giselegal@outlook.com",
        "genero": "",
        "dataNasc": "06 Set.",
        "telefone": " 1197483-2955",
        "ultInteracao": "Compra",
        "dataInteracao": "19/07/2024"
        },
        {
        "id": "146246558",
        "name": "Carlos Eduardo de Souza Araujo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "c_edu82@yahoo.com.br",
        "genero": "M",
        "dataNasc": "30 Ago.",
        "telefone": " 3193849888",
        "ultInteracao": "Compra",
        "dataInteracao": "19/07/2024"
        },
        {
        "id": "191915665",
        "name": "Leandro Pereira Gomes",
        "comPromocional": true,
        "numCompras": 1,
        "email": "leandropgomes11@gmail.com",
        "genero": "M",
        "dataNasc": "25 Jul.",
        "telefone": " 31 98856-0039",
        "ultInteracao": "Compra",
        "dataInteracao": "19/07/2024"
        },
        {
        "id": "204855708",
        "name": "Jessica Paola Miranda Cardoso",
        "comPromocional": true,
        "numCompras": 1,
        "email": "bonecaje@hotmail.com",
        "genero": "",
        "dataNasc": "09 Ago.",
        "telefone": " 33984028819",
        "ultInteracao": "Compra",
        "dataInteracao": "18/07/2024"
        },
        {
        "id": "59039679",
        "name": "Julio Borgerth Lobato",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lobatojulio@gmail.com",
        "genero": "M",
        "dataNasc": "13 Out.",
        "telefone": "2181015323",
        "ultInteracao": "Compra",
        "dataInteracao": "18/07/2024"
        },
        {
        "id": "149051016",
        "name": "Damaris Pereira Carvalho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "damaris_p_c@hotmail.com",
        "genero": "",
        "dataNasc": "30 Jan.",
        "telefone": " 11 41315081",
        "ultInteracao": "Compra",
        "dataInteracao": "18/07/2024"
        },
        {
        "id": "316350967",
        "name": "Alan Fred da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "alanfredda@gmail.com",
        "genero": "M",
        "dataNasc": "18 Jun.",
        "telefone": "5531999965551",
        "ultInteracao": "Compra",
        "dataInteracao": "18/07/2024"
        },
        {
        "id": "618205108",
        "name": "Gustavo Fonseca Mariano",
        "comPromocional": false,
        "numCompras": 1,
        "email": "gustavoeemcg@hotmail.com",
        "genero": "M",
        "dataNasc": "30 Jan.",
        "telefone": "15997229217",
        "ultInteracao": "Compra",
        "dataInteracao": "17/07/2024"
        },
        {
        "id": "1095577603",
        "name": "Andre Batista",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thaisab2013@hotmail.com",
        "genero": "M",
        "dataNasc": "01 Jun.",
        "telefone": "5533988225075",
        "ultInteracao": "Compra",
        "dataInteracao": "17/07/2024"
        },
        {
        "id": "1904193049",
        "name": "Matheus Sinval Silva Santos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mthssinval@yahoo.com.br",
        "genero": "M",
        "dataNasc": "22 Nov.",
        "telefone": "5531991999884",
        "ultInteracao": "Compra",
        "dataInteracao": "17/07/2024"
        },
        {
        "id": "578851266",
        "name": "Joao Batista da Conceicao Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "jbsouza321@gmail.com",
        "genero": "",
        "dataNasc": "20 Abr.",
        "telefone": "74988040179",
        "ultInteracao": "Compra",
        "dataInteracao": "16/07/2024"
        },
        {
        "id": "1902904045",
        "name": "Isadora Silveira Machado",
        "comPromocional": true,
        "numCompras": 1,
        "email": "Isadorasilmachado@gmail.com",
        "genero": "",
        "dataNasc": "13 Dez.",
        "telefone": "5531998205534",
        "ultInteracao": "Compra",
        "dataInteracao": "16/07/2024"
        },
        {
        "id": "469532171",
        "name": "Tonimar Nei Aires",
        "comPromocional": true,
        "numCompras": 2,
        "email": "tonimarney@hotmail.com",
        "genero": "M",
        "dataNasc": "14 Ago.",
        "telefone": "5553999713651",
        "ultInteracao": "Compra",
        "dataInteracao": "16/07/2024"
        },
        {
        "id": "74952444",
        "name": "Rafael Boa Gadioli",
        "comPromocional": true,
        "numCompras": 1,
        "email": "rafael.gadioli86@gmail.com",
        "genero": "M",
        "dataNasc": "16 Dez.",
        "telefone": "27998517125",
        "ultInteracao": "Compra",
        "dataInteracao": "16/07/2024"
        },
        {
        "id": "288164393",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "mecanicajgefilhos@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "16/07/2024"
        },
        {
        "id": "1005819928",
        "name": "Maria Cecilia Guimaraes Fonseca",
        "comPromocional": true,
        "numCompras": 1,
        "email": "m_ceci9@hotmail.com",
        "genero": "",
        "dataNasc": "09 Dez.",
        "telefone": "5538997246288",
        "ultInteracao": "Compra",
        "dataInteracao": "15/07/2024"
        },
        {
        "id": "1657094806",
        "name": "Douglas Lachman",
        "comPromocional": true,
        "numCompras": 1,
        "email": "douglaslachman2021@gmail.com",
        "genero": "M",
        "dataNasc": "25 Jun.",
        "telefone": "5542998564355",
        "ultInteracao": "Compra",
        "dataInteracao": "15/07/2024"
        },
        {
        "id": "1137650046",
        "name": " ",
        "comPromocional": true,
        "numCompras": 1,
        "email": "aldcejamfonseca@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "5584988462888",
        "ultInteracao": "Compra",
        "dataInteracao": "15/07/2024"
        },
        {
        "id": "136756732",
        "name": "Evandro Dutra Garcia",
        "comPromocional": true,
        "numCompras": 1,
        "email": "pedro.garcia.pipoca@hotmail.com",
        "genero": "M",
        "dataNasc": "22 Jan.",
        "telefone": " 37- 99244220",
        "ultInteracao": "Compra",
        "dataInteracao": "15/07/2024"
        },
        {
        "id": "74725211",
        "name": "Fabiana Ferreira de Sousa Reis",
        "comPromocional": true,
        "numCompras": 1,
        "email": "bi.ana.2@hotmail.com",
        "genero": "",
        "dataNasc": "06 Mar.",
        "telefone": "3196114077",
        "ultInteracao": "Compra",
        "dataInteracao": "15/07/2024"
        },
        {
        "id": "593237974",
        "name": "Altina Bartolomeu da Cunha",
        "comPromocional": true,
        "numCompras": 1,
        "email": "abdacunha@hotmail.com",
        "genero": "",
        "dataNasc": "24 Ago.",
        "telefone": "5531987512407",
        "ultInteracao": "Compra",
        "dataInteracao": "15/07/2024"
        },
        {
        "id": "127744172",
        "name": "Eduardo Gonzaga da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "edugonzaga28@hotmail.com",
        "genero": "M",
        "dataNasc": "04 Jul.",
        "telefone": " 75 9101 8892",
        "ultInteracao": "Compra",
        "dataInteracao": "15/07/2024"
        },
        {
        "id": "26900439",
        "name": "Reinaldo Gustavo de Mesquita",
        "comPromocional": true,
        "numCompras": 1,
        "email": "reita77@gmail.com",
        "genero": "M",
        "dataNasc": "23 Jul.",
        "telefone": "21980130237",
        "ultInteracao": "Compra",
        "dataInteracao": "13/07/2024"
        },
        {
        "id": "1897888965",
        "name": "Diogenes Vicente Ferreira",
        "comPromocional": true,
        "numCompras": 1,
        "email": "diogenesvicenteferreira@gmail.com",
        "genero": "M",
        "dataNasc": "13 Mai.",
        "telefone": "5531985864860",
        "ultInteracao": "Compra",
        "dataInteracao": "13/07/2024"
        },
        {
        "id": "137047589",
        "name": "Paulo Henrique da Silva Miranda",
        "comPromocional": true,
        "numCompras": 1,
        "email": "clickpaulo@gmail.com",
        "genero": "M",
        "dataNasc": "01 Dez.",
        "telefone": " (31)91237372",
        "ultInteracao": "Compra",
        "dataInteracao": "12/07/2024"
        },
        {
        "id": "111609898",
        "name": "Lucas Goncalves de Freitas",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lukashexa@hotmail.com",
        "genero": "M",
        "dataNasc": "16 Fev.",
        "telefone": " 91811352",
        "ultInteracao": "Compra",
        "dataInteracao": "11/07/2024"
        },
        {
        "id": "182206274",
        "name": "Antonio Carlos de Miranda Pacheco Junior",
        "comPromocional": true,
        "numCompras": 1,
        "email": "antonio.pacheco@jdantas.com.br",
        "genero": "M",
        "dataNasc": "30 Out.",
        "telefone": " 31999973005",
        "ultInteracao": "Compra",
        "dataInteracao": "10/07/2024"
        },
        {
        "id": "35112395",
        "name": "Alair Jorge de Amorim Filho",
        "comPromocional": true,
        "numCompras": 1,
        "email": "lairincawboy@hotmail.com",
        "genero": "",
        "dataNasc": "04 Abr.",
        "telefone": "3835646072",
        "ultInteracao": "Compra",
        "dataInteracao": "10/07/2024"
        },
        {
        "id": "232819559",
        "name": "Gustavo Davi Alves da Costa",
        "comPromocional": true,
        "numCompras": 2,
        "email": "gustavo_bh@msn.com",
        "genero": "M",
        "dataNasc": "15 Jun.",
        "telefone": " 31986357718",
        "ultInteracao": "Compra",
        "dataInteracao": "09/07/2024"
        },
        {
        "id": "537183850",
        "name": "Thiago Costa Rodrigues",
        "comPromocional": true,
        "numCompras": 1,
        "email": "thiago.costa.rodrigues1@gmail.com",
        "genero": "M",
        "dataNasc": "25 Ago.",
        "telefone": "5567982192323",
        "ultInteracao": "Compra",
        "dataInteracao": "08/07/2024"
        },
        {
        "id": "259840410",
        "name": "Carlos Saibel Brandemburg",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carlossbrandemburg@gmail.com",
        "genero": "M",
        "dataNasc": "19 Fev.",
        "telefone": "01527999371394",
        "ultInteracao": "Compra",
        "dataInteracao": "06/07/2024"
        },
        {
        "id": "206311679",
        "name": "Carla da Costa Alves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "carla.c.alves@gmail.com",
        "genero": "",
        "dataNasc": "16 Jan.",
        "telefone": "31993145309",
        "ultInteracao": "Compra",
        "dataInteracao": "24/06/2024"
        },
        {
        "id": "592763055",
        "name": "Valdinei Junio Alves",
        "comPromocional": true,
        "numCompras": 1,
        "email": "valdineijunio813@gmail.com",
        "genero": "",
        "dataNasc": "03 Jan.",
        "telefone": "38997363425",
        "ultInteracao": "Compra",
        "dataInteracao": "24/06/2024"
        },
        {
        "id": "679640688",
        "name": "Elaine Cristina Adriano Ferreira",
        "comPromocional": true,
        "numCompras": 2,
        "email": "messiasrobertof@gmail.com",
        "genero": "",
        "dataNasc": "22 Jun.",
        "telefone": "",
        "ultInteracao": "Compra",
        "dataInteracao": "15/06/2024"
        },
        {
        "id": "1063189286",
        "name": "Felipe Barbosa Cota",
        "comPromocional": true,
        "numCompras": 1,
        "email": "felipe.cota@grafite.com",
        "genero": "M",
        "dataNasc": "06 Mar.",
        "telefone": "5533999540539",
        "ultInteracao": "Compra",
        "dataInteracao": "11/06/2024"
        },
        {
        "id": "84081509",
        "name": "Gustavo Gontijo Araujo",
        "comPromocional": true,
        "numCompras": 1,
        "email": "gustavogaraujo@hotmail.com",
        "genero": "M",
        "dataNasc": "01 Nov.",
        "telefone": "31991761952",
        "ultInteracao": "Compra",
        "dataInteracao": "05/06/2024"
        },
        {
        "id": "661980232",
        "name": "Carlos Eduardo Jesus da Silva",
        "comPromocional": true,
        "numCompras": 1,
        "email": "cadugamersmg@gmail.com",
        "genero": "M",
        "dataNasc": "11 Jul.",
        "telefone": "31981064087",
        "ultInteracao": "Compra",
        "dataInteracao": "05/06/2024"
        },
        {
        "id": "159082168",
        "name": "Deia Veloso de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "deia.veloso1@hotmail.com",
        "genero": "F",
        "dataNasc": "29 Abr.",
        "telefone": "31996246585",
        "ultInteracao": "Compra",
        "dataInteracao": "03/06/2024"
        },
        {
        "id": "276532664",
        "name": "Danilo Camargo de Souza Filho",
        "comPromocional": false,
        "numCompras": 1,
        "email": "danilocamargofilho@gmail.com",
        "genero": "M",
        "dataNasc": "08 Abr.",
        "telefone": "33984398244",
        "ultInteracao": "Compra",
        "dataInteracao": "28/05/2024"
        },
        {
        "id": "170495139",
        "name": "Joao Paulo Abreu Passos",
        "comPromocional": true,
        "numCompras": 1,
        "email": "joao-passos2011@hotmail.com",
        "genero": "M",
        "dataNasc": "12 Mar.",
        "telefone": " 31 92585206",
        "ultInteracao": "Compra",
        "dataInteracao": "24/05/2024"
        },
        {
        "id": "52936415",
        "name": "Janilton Dos Santos Rezende",
        "comPromocional": true,
        "numCompras": 1,
        "email": "janiltonrezende@yahoo.com.br",
        "genero": "M",
        "dataNasc": "02 Out.",
        "telefone": "13988156410",
        "ultInteracao": "Compra",
        "dataInteracao": "23/05/2024"
        },
        {
        "id": "42425501",
        "name": "Micael Rodolfo Luiz de Souza",
        "comPromocional": true,
        "numCompras": 1,
        "email": "micael_rodolfo@hotmail.com",
        "genero": "M",
        "dataNasc": "25 Set.",
        "telefone": "67981658051",
        "ultInteracao": "Compra",
        "dataInteracao": "22/05/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "adrianocostatorres.cabecao@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "17/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Claudineicleiton@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "15/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Junimcarservice@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "15/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "andreluizgrigato@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "14/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "pgmartins.drive@outlook.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "14/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Felipedecar@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "lucineimts@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "daniell@helpdeskinformatica.net.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "sandrovc@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "12/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "idalcenoc@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "raphaellopescarvalho@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "elyvelton972@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "karyne_rodrigues88@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "primoscentroautomotivo@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "uarleisoares10@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "05/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "frederico.bauer@icloud.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "03/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "eltonfparreira@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "02/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "regia.weimann@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "01/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "glaucobarbosa@uol.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "01/05/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "mxfreitas20@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "30/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rhelbertlovis@outlook.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "romarioteodoro2222@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "cubanosroma@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "marcusvdutra@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "lucio.bello@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "28/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "josiascolth2018@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "santososeias879@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "mayconvanessa820@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "25/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "christofer.alves@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "22/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "naiafinom@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "20/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "raby1643@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "19/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rauldesouzadaniel@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "17/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Carlos76aniceto@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "17/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "gouveiaflavia@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "17/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "anagui64@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "jorgezaia@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "12/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "mj4306337@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "12/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "leonardodasilva5475@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "09/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "marcelomamao@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "09/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "joserobertosantor@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "mailsongafilt@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "antoniocarlosnota07@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "07/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "marcio.alrbv@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "07/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "marcelojosegomesdasilva623@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "04/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "ednaldoroberto1984@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "03/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "ediremigio@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "02/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "nilton118freitas@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "02/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "robertafaria@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "01/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "fabriciasalome@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "01/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "lmmroger@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "01/04/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "joseraimundodossantosc@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Rigerio@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "28/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "elshaday.reparacaoautomotiva@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "27/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "jorgerodriguesp@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "27/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "ruimaco388@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "gisellecsantos@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "24/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "zanolfelipe@icloud.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "24/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Jtpuyol@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "24/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "allanmartinsa@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "23/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "concencomeirelles@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "22/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "andresouza69@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "21/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "fcjb.10@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "21/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "ruicleiber@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "21/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Lkaiky811@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "20/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Rodolfo.thompson91@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "19/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "vanilsonspinheiro@bol.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "16/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "leandrotcastro2@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "16/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "alancota@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "16/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "xpgdantas@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "15/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "vendas@brsette.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "14/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "brunols5@icloud.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Sandersonclayton2@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "grandenim@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "12/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "eugenio030992gsilva@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "administrativo@infraengeconstrucoes.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "jeantonini75@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "07/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rrsentidozonasul@bol.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "07/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "darciolb23@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "02/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "gilmarsc@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "01/03/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "marreiropombal@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "igorfssilva.contato@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "25/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Alessandravmss@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "24/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "maxinstrutor@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "24/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Philipe_cjes@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "23/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "denilsonfelix098@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "23/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "hug0fonseca@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "21/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "fabiomachadovaz@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "20/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "mengaofc227@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "19/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "moderna.led.iluminacao@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "18/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "mbrostel@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "18/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "aldorasec33@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "dayrellrodrigo@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "paulojoviano@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "jal_tripui@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "10/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Ronaldo.mrodrigues@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "10/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rodrigopessoa.brasilmontagens@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "04/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "va.edu@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "04/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "leandroferrsantos@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "04/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "marialiaquerino@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "03/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "uberaloy@gmail.xom",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "03/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "pimenteleleuq@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "02/02/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "hcr2008@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "28/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "pr.manoelpereiradasilvafilho@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "27/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "ivanil03@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "dar_suarez@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rosanegbittar@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "25/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "glaubersantos11@outlook.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "24/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rodrigo1234567890.rg@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "22/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "carlosalgustomirandarodrigues@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "17/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "valmir-sbr160@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "15/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "jonnetg@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "15/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "wilk.freire@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "14/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "mqsmaciel@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Bmmenezeslima@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "gema58@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "10/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rodrigobarretobatista@hotmail.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "09/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "renato273@bol.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "wiliam.barbosa@saude.gov.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "07/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "63luizsilva@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "04/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "gilk8k@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "03/01/2025"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "costadiego4875@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "30/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "erivaldojrba@outlook.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "30/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "mariadefatimabraganca51@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "30/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Jorgedeltaphb@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "bustamantemagalhaes@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "28/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "paulosergiojota@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "28/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "leonardo.anrake@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "27/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Neneukey@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "maycon.ribeiro466@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "peterbdp500@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "luisantoniodepaiva8@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "24/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Tavim1rd1@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "22/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "robertvaguinerguerra@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "20/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "wesleialvescoelho@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "20/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "alexandregmorais@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "20/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Gabrielc4rv@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "19/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "lucianorubik1998@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "17/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "samukaejessica@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "16/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "bhmg46@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "14/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "miltonfersan@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "fernandoxxt2211@outlook.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "12/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "agf_monteiro@outlook.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rogeriofgarcia@yahoo.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "flaviofc61@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "leandrogrudeski44@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "marceloq140@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "10/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "maquirgarcia1193@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "09/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "scjclaudio@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "05/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "joseedilsonpereiradasilvaedils@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "04/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "emmerson.bernardino@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "03/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "mirianjg30@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "03/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "marujo.marcio@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "02/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "kevinwashington01@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "01/12/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "geraldoraposo@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "hiltonrsilva2016@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "luizmota@terra.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "25/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "luangs.eldorado@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "20/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "shiltonsilva764@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "18/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "eduardo67silveira@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "samyr_silva@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "cidsouzabp@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "vemkamodas@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "12/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "mariaveronicapessoa@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "ivanruy@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "10/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "irapuanj594@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "06/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "luizneves53@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "05/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "LUK******@GMAIL.COM",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "03/11/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rodrigoenzo2016@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "31/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "petronio@imam.org.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "30/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "flarony81@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "30/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rosepachecobh@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "flaviosousa179@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rodrigo_alvescosta@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "gecarneirods@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "24/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "paulocampeao9@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "20/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "josafa.xavier0107@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "20/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rycardolacerda@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "18/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "fabricioribeiro238@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "17/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Lucas.pinas@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "17/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "nanaerafa37@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "16/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "leizon.usilima@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "15/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "josevieira.neto@outlook.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "15/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Balbinoleonardodasilva@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "14/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "brunobs535554@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "12/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "fernandorneves@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "12/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "jjbbirj@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "12/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "juliobarbato_172@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "emidioeverton83@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "gilmarreginaldosouza@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "10/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "andersonricardo455@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "09/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "alfenpecas2017@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "eliasinacio2020@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Shashadarocha@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "fp293706@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "07/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "ruicelio@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "07/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "wmtratoresfranca@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "06/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "ascjcavalcante@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "06/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "luiamg.gioannini@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "06/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "gesimiel19@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "05/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rafaelsuperbikes@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "03/10/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Sedvaldosoaresmedeiros@yahoo.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "30/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "marcelonevys@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "edsondeoliveira234@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "tony.medeiros@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "eugenetaxistanapista@terra.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "28/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "thiago1781@live.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "27/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "msantorj@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "24/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "lekobuffet@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "23/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "angelomezzetti@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "23/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "moreiraevaldo79@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "22/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "kallelramos@outlook.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "22/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "crissramonn@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "22/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "edmilsongarcia1977@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "22/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "juscelinocnc@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "21/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "pr.argeurocha@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "20/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "grumbt11@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "19/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "kimkim_sandro@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "18/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "andersongabriel2120@yahoo.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "16/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "afonsosfranca36@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "14/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "aguia65@hotmmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "12/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "emerson.grijo@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "12/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Gilmarsousa085@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "12/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "heliobento9@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "geralmagela@bol.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "10/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Leanferna2019@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "obpcquississana@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "guoliveirap328@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "felipesilva008@outlook.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Davidanicarmo@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "geronimorgs@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "07/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Maikel.zamboni@5gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "07/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "jsoficinas@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "07/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "itaspórts@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "05/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "elisonmateus0@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "05/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "ulisses_freitaas@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "05/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "marcioegabi.la@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "05/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Marciobatistacintra8@icloud.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "03/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "ejjmarques@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "03/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Helinhohbc@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "01/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Santos.vinicius9920@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "01/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "luissoares5129@terra.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "01/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Issamunw@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "01/09/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "jeremias_junior@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "31/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "talissoncabral@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "31/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "ds474653@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "31/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "renato90grau@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "31/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "priscilarcontabil@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "30/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "gjpereira@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Biancasouza12e@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "eriveltodesouza2011@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "28/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "marcusminero@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "28/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "andersonbegliomini@terra.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "27/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "nilsondapaz@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "carlos.souza@passaroverde.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "jeanssb@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "fernandorneve@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "25/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "codl323@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "23/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "lopesharley@live.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "21/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "clebersonlonghi5@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "19/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "sergioleitesthel@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "19/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "largata@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "17/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "dindaoporto@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "15/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "franciscofernandes262@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "14/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "cassiopt@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "prbj82@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "04/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "geraldomagelasilva2008@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "02/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "evandrofreitas67@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "02/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "brytmas@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "01/08/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "wcelestinopereira@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "andretxa@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "c.junior3000@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "mariaeduardanunesmottaaraujo@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "28/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "wilwil171@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "prof.denilsonsantos@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "24/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "jclaret53@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "23/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "rodrigokeiser@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "22/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "alexsantosluiz22@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "20/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "udilanpaulo@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "19/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "leonardo.costa@versatilengenharia.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "17/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "mrvchristo@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "15/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "clsouzadv@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "13/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "felix1973ca@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "osvaldomariano15@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "11/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "ernestodg1972@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "fabicleus@yahoo.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "08/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "vilmats2005@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "06/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "santosobadias9@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "03/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "joaobatistadornelas439@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "02/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "marquestratores@marqusetratores.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "02/07/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "autolitoralsc@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/06/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "HEBERTY156@OUTLOOK.COM",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "29/06/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "wellingtonmario4@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "24/06/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "daniela.araujo@3dcontabilidade.com.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "24/06/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "Lac-214@hotmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "21/06/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "walter.luiz@emater.mg.gov.br",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "21/06/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "marao13@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "19/06/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "alexandre.francamoreira@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "15/06/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "harfacil@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "07/06/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "erloneugenio21@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "28/05/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "renatocravemaga@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "26/05/2024"
        },
        {
        "id": "",
        "name": "",
        "comPromocional": true,
        "numCompras": 0,
        "email": "helvio38949818@gmail.com",
        "genero": "",
        "dataNasc": "",
        "telefone": "",
        "ultInteracao": "Assinatura",
        "dataInteracao": "19/05/2024"
        }
    ]
}